var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFootballClubDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 408.91 510.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #f1f1f1;\n      }\n\n      .st2 {\n        fill: #3c3c3b;\n      }\n\n      .st3 {\n        fill: #585757;\n      }\n\n      .st4 {\n        fill: #b4b4b3;\n      }\n\n      .st5 {\n        fill: #e0e0e0;\n      }\n\n      .st6 {\n        fill: #bbbbba;\n      }\n\n      .st7 {\n        fill: #bfbfbe;\n      }\n\n      .st8 {\n        fill: #909090;\n      }\n\n      .st9 {\n        fill: #dfdfdf;\n      }\n\n      .st10 {\n        fill: #292928;\n      }\n\n      .st11 {\n        fill: #f5f4f5;\n      }\n\n      .st12 {\n        fill: #464545;\n      }\n\n      .st13 {\n        fill: #cecdcd;\n      }\n\n      .st14 {\n        fill: #a7a7a7;\n      }\n\n      .st15 {\n        fill: #2c2b2a;\n      }\n\n      .st16 {\n        fill: #f4f4f3;\n      }\n\n      .st17 {\n        fill: #d6d6d6;\n      }\n\n      .st18 {\n        fill: #cdcdcc;\n      }\n\n      .st19 {\n        fill: #bdbdbd;\n      }\n\n      .st20 {\n        fill: #363635;\n      }\n\n      .st21 {\n        fill: #c9c9c8;\n      }\n\n      .st22 {\n        fill: #b7b7b6;\n      }\n\n      .st23 {\n        fill: #bcbcbb;\n      }\n\n      .st24 {\n        fill: #eaeaea;\n      }\n\n      .st25 {\n        fill: #7c7c7b;\n      }\n\n      .st26 {\n        fill: #c0bfbf;\n      }\n\n      .st27 {\n        fill: #878786;\n      }\n\n      .st28 {\n        fill: #9c9c9c;\n      }\n\n      .st29 {\n        fill: #a3a3a2;\n      }\n\n      .st30 {\n        fill: #e3e3e3;\n      }\n\n      .st31 {\n        fill: #939392;\n      }\n\n      .st32 {\n        fill: #d2d2d2;\n      }\n\n      .st33 {\n        fill: #575656;\n      }\n\n      .st34 {\n        fill: #707070;\n      }\n\n      .st35 {\n        fill: #254578;\n      }\n\n      .st36 {\n        fill: #e6e6e6;\n      }\n\n      .st37 {\n        fill: #3a3939;\n      }\n\n      .st38 {\n        fill: #242422;\n      }\n\n      .st39 {\n        fill: #b5b5b5;\n      }\n\n      .st40, .st41 {\n        fill: #1e3562;\n      }\n\n      .st42 {\n        mix-blend-mode: multiply;\n        opacity: .48;\n      }\n\n      .st43 {\n        fill: #e9e9e8;\n      }\n\n      .st44 {\n        fill: #b0afaf;\n      }\n\n      .st45 {\n        fill: #959494;\n      }\n\n      .st46 {\n        fill: #555454;\n      }\n\n      .st47 {\n        fill: #d0d0d0;\n      }\n\n      .st48 {\n        fill: #858584;\n      }\n\n      .st49 {\n        fill: #828282;\n      }\n\n      .st50 {\n        fill: #8a8989;\n      }\n\n      .st51 {\n        fill: #b8b8b7;\n      }\n\n      .st41 {\n        fill-rule: evenodd;\n      }\n\n      .st52 {\n        fill: #e2e2e2;\n      }\n\n      .st53 {\n        fill: #efefef;\n      }\n\n      .st54 {\n        fill: #4c4c4b;\n      }\n\n      .st55 {\n        fill: #3f3f3e;\n      }\n\n      .st56 {\n        fill: #b3b3b2;\n      }\n\n      .st57 {\n        fill: #e4e4e4;\n      }\n\n      .st58 {\n        fill: #424241;\n      }\n\n      .st59 {\n        fill: #f6f6f6;\n      }\n\n      .st60 {\n        fill: #ebebeb;\n      }\n\n      .st61 {\n        fill: #5f5f5e;\n      }\n\n      .st62 {\n        fill: #d9d9d9;\n      }\n\n      .st63 {\n        fill: #a1a1a1;\n      }\n\n      .st64 {\n        fill: #f4f4f4;\n      }\n\n      .st65 {\n        fill: #dbdbdb;\n      }\n\n      .st66 {\n        fill: #595858;\n      }\n\n      .st67 {\n        fill: #50504f;\n      }\n\n      .st68 {\n        fill: #8e8e8d;\n      }\n\n      .st69 {\n        fill: #cecece;\n      }\n\n      .st70 {\n        fill: #444342;\n      }\n\n      .st71 {\n        fill: #5a5959;\n      }\n\n      .st72 {\n        fill: #3b3b3a;\n      }\n\n      .st73 {\n        fill: #969696;\n      }\n\n      .st74 {\n        fill: #525251;\n      }\n\n      .st75 {\n        fill: #c1c1c1;\n      }\n\n      .st76 {\n        fill: #7a7a79;\n      }\n\n      .st77 {\n        fill: #4f4f4e;\n      }\n\n      .st78 {\n        fill: #807f7f;\n      }\n\n      .st79 {\n        fill: #a4a4a3;\n      }\n\n      .st80 {\n        fill: #7e7d7d;\n      }\n\n      .st81 {\n        fill: #60605f;\n      }\n\n      .st82 {\n        fill: #5d5d5c;\n      }\n\n      .st83 {\n        fill: #919191;\n      }\n\n      .st84 {\n        fill: #a5a5a4;\n      }\n\n      .st85 {\n        fill: #d4d4d4;\n      }\n\n      .st86 {\n        fill: #565555;\n      }\n\n      .st87 {\n        fill: #949493;\n      }\n\n      .st88 {\n        fill: #999998;\n      }\n\n      .st89 {\n        fill: #9e9e9d;\n      }\n\n      .st90 {\n        fill: #d5d4d4;\n      }\n\n      .st91 {\n        fill: #1d1d1b;\n      }\n\n      .st92 {\n        fill: #353534;\n      }\n\n      .st93 {\n        fill: #c2c2c1;\n      }\n\n      .st94 {\n        fill: #666665;\n      }\n\n      .st95 {\n        fill: #818080;\n      }\n\n      .st96 {\n        fill: #e5e5e5;\n      }\n\n      .st97 {\n        fill: #4d4d4c;\n      }\n\n      .st98 {\n        fill: #ccc;\n      }\n\n      .st99 {\n        fill: #636362;\n      }\n\n      .st100 {\n        isolation: isolate;\n      }\n\n      .st101 {\n        fill: #d8d8d8;\n      }\n\n      .st102 {\n        fill: #c3c3c3;\n      }\n\n      .st103 {\n        fill: #c4c4c4;\n      }\n\n      .st104 {\n        fill: #757574;\n      }\n\n      .st105 {\n        fill: #b1b1b1;\n      }\n\n      .st106 {\n        fill: #dedede;\n      }\n\n      .st107 {\n        fill: #a0a0a0;\n      }\n\n      .st108 {\n        fill: #717170;\n      }\n\n      .st109 {\n        fill: #a9a9a8;\n      }\n\n      .st110 {\n        fill: #3e3e3d;\n      }\n\n      .st111 {\n        fill: #2e2e2d;\n      }\n\n      .st112 {\n        fill: #989897;\n      }\n\n      .st113 {\n        fill: #bebebe;\n      }\n\n      .st114 {\n        fill: #c7c7c7;\n      }\n\n      .st115 {\n        fill: #2a2a29;\n      }\n\n      .st116 {\n        fill: #2f2f2e;\n      }\n\n      .st117 {\n        fill: #d1d1d0;\n      }\n\n      .st118 {\n        fill: #a6a6a6;\n      }\n\n      .st119 {\n        fill: #656564;\n      }\n\n      .st120 {\n        fill: #9f9f9e;\n      }\n\n      .st121 {\n        fill: #ddd;\n      }\n\n      .st122 {\n        fill: #888887;\n      }\n\n      .st123 {\n        clip-path: url(#clippath-1);\n      }\n\n      .st124 {\n        clip-path: url(#clippath-2);\n      }\n\n      .st125 {\n        fill: #212120;\n      }\n\n      .st126 {\n        fill: #587eb1;\n      }\n\n      .st127 {\n        fill: #6e6d6d;\n      }\n\n      .st128 {\n        fill: #20201e;\n      }\n\n      .st129 {\n        fill: #e7e7e7;\n      }\n\n      .st130 {\n        fill: #b0b0b0;\n      }\n\n      .st131 {\n        fill: #d7d7d7;\n      }\n\n      .st132 {\n        fill: #5c5c5b;\n      }\n\n      .st133 {\n        fill: #9b9b9b;\n      }\n\n      .st134 {\n        fill: #676766;\n      }\n\n      .st135 {\n        fill: #6f6f6f;\n      }\n\n      .st136 {\n        fill: #323130;\n      }\n\n      .st137 {\n        fill: #9a9999;\n      }\n\n      .st138 {\n        fill: #dededd;\n      }\n\n      .st139 {\n        fill: #393837;\n      }\n\n      .st140 {\n        fill: #fff;\n      }\n\n      .st141 {\n        fill: #696868;\n      }\n\n      .st142 {\n        fill: #747473;\n      }\n\n      .st143 {\n        fill: #aeaead;\n      }\n\n      .st144 {\n        fill: #f9f9f9;\n      }\n\n      .st145 {\n        fill: #f0f0f0;\n      }\n\n      .st146 {\n        fill: #bcbcbc;\n      }\n\n      .st147 {\n        fill: #c5c5c5;\n      }\n\n      .st148 {\n        fill: #9b9a9a;\n      }\n\n      .st149 {\n        fill: #5c5b5b;\n      }\n\n      .st150 {\n        fill: #bababa;\n      }\n\n      .st151 {\n        fill: #4e4e4d;\n      }\n\n      .st152 {\n        fill: #fafafa;\n      }\n\n      .st153 {\n        fill: #343433;\n      }\n\n      .st154 {\n        fill: #afafae;\n      }\n\n      .st155 {\n        fill: #898888;\n      }\n\n      .st156 {\n        fill: #30302f;\n      }\n\n      .st157 {\n        fill: #1e1e1d;\n      }\n\n      .st158 {\n        fill: #8c8c8b;\n      }\n\n      .st159 {\n        fill: #e9e9e9;\n      }\n\n      .st160 {\n        fill: #818181;\n      }\n\n      .st161 {\n        fill: #f8f8f8;\n      }\n\n      .st162 {\n        fill: silver;\n      }\n\n      .st163 {\n        fill: #3d3d3c;\n      }\n\n      .st164 {\n        fill: #e6e6e5;\n      }\n\n      .st165 {\n        fill: #b5b4b4;\n      }\n\n      .st166 {\n        fill: #b8b8b8;\n      }\n\n      .st167 {\n        fill: #959595;\n      }\n\n      .st168 {\n        fill: #797978;\n      }\n\n      .st169 {\n        fill: #908f8f;\n      }\n\n      .st170 {\n        opacity: .22;\n      }\n\n      .st171 {\n        fill: #4a4a49;\n      }\n\n      .st172 {\n        fill: #f7f7f7;\n      }\n\n      .st173 {\n        fill: #8b8b8b;\n      }\n\n      .st174 {\n        fill: #fefefe;\n      }\n\n      .st175 {\n        fill: #868685;\n      }\n\n      .st176 {\n        fill: #979796;\n      }\n\n      .st177 {\n        fill: #6b6a6a;\n      }\n\n      .st178 {\n        fill: #3c99bf;\n      }\n\n      .st179 {\n        fill: #7d7d7c;\n      }\n\n      .st180 {\n        fill: #7f7e7e;\n      }\n\n      .st181 {\n        fill: #d5d5d5;\n      }\n\n      .st182 {\n        fill: #acacac;\n      }\n\n      .st183 {\n        fill: #abaaaa;\n      }\n\n      .st184 {\n        fill: #a2a2a2;\n      }\n\n      .st185 {\n        fill: #40403f;\n      }\n\n      .st186 {\n        fill: #2581c4;\n      }\n\n      .st187 {\n        fill: #646463;\n      }\n\n      .st188 {\n        fill: #f2f2f2;\n      }\n\n      .st189 {\n        fill: #dbdbda;\n      }\n\n      .st190 {\n        fill: #8f8e8e;\n      }\n\n      .st191 {\n        fill: #4b4b4a;\n      }\n\n      .st192 {\n        fill: #6d6c6c;\n      }\n\n      .st193 {\n        fill: #5e5e5d;\n      }\n\n      .st194 {\n        fill: #8a8a8a;\n      }\n\n      .st195 {\n        fill: #f5f5f5;\n      }\n\n      .st196 {\n        fill: #ababab;\n      }\n\n      .st197 {\n        fill: #5b5a5a;\n      }\n\n      .st198 {\n        fill: #282826;\n      }\n\n      .st199 {\n        fill: #373736;\n      }\n\n      .st200 {\n        fill: #e1e1e1;\n      }\n\n      .st201 {\n        fill: #686867;\n      }\n\n      .st202 {\n        fill: #7b7b7a;\n      }\n\n      .st203 {\n        fill: #838383;\n      }\n\n      .st204 {\n        fill: #2d2d2c;\n      }\n\n      .st205 {\n        fill: #545352;\n      }\n\n      .st206 {\n        fill: #777776;\n      }\n\n      .st207 {\n        fill: #f3f3f3;\n      }\n\n      .st208 {\n        fill: #d8d8d7;\n      }\n\n      .st209 {\n        fill: #fbfbfb;\n      }\n\n      .st210 {\n        fill: #fcfcfc;\n      }\n\n      .st211 {\n        fill: #767675;\n      }\n\n      .st212 {\n        fill: #494948;\n      }\n\n      .st213 {\n        fill: #b9b9b9;\n      }\n\n      .st214 {\n        fill: #cbcbcb;\n      }\n\n      .st215 {\n        fill: #a09f9f;\n      }\n\n      .st216 {\n        fill: #aaaaa9;\n      }\n\n      .st217 {\n        fill: #6e6e6e;\n      }\n\n      .st218 {\n        fill: #848483;\n      }\n\n      .st219 {\n        fill: #474646;\n      }\n\n      .st220 {\n        fill: #9d9d9c;\n      }\n\n      .st221 {\n        fill: #484847;\n      }\n\n      .st222 {\n        fill: #333332;\n      }\n\n      .st223 {\n        fill: #6c6b6b;\n      }\n\n      .st224 {\n        fill: #8d8d8c;\n      }\n\n      .st225 {\n        fill: #737372;\n      }\n\n      .st226 {\n        fill: #a8a8a8;\n      }\n\n      .st227 {\n        fill: #454444;\n      }\n\n      .st228 {\n        fill: #414140;\n      }\n\n      .st229 {\n        fill: #727271;\n      }\n\n      .st230 {\n        fill: #515150;\n      }\n\n      .st231 {\n        fill: #ededed;\n      }\n\n      .st232 {\n        fill: #c6c6c5;\n      }\n\n      .st233 {\n        fill: #626261;\n      }\n\n      .st234 {\n        fill: #929291;\n      }\n\n      .st235 {\n        fill: #078136;\n      }\n\n      .st236 {\n        fill: #adadad;\n      }\n\n      .st237 {\n        fill: #262625;\n      }\n\n      .st238 {\n        fill: #c8c8c8;\n      }\n\n      .st239 {\n        fill: #252524;\n      }\n\n      .st240 {\n        fill: #d3d3d3;\n      }\n\n      .st241 {\n        fill: #dadada;\n      }\n\n      .st242 {\n        fill: #c3c3c2;\n      }\n\n      .st243 {\n        fill: #222221;\n      }\n\n      .st244 {\n        fill: #d1d1d1;\n      }\n\n      .st245 {\n        fill: #e1e0e0;\n      }\n\n      .st246 {\n        fill: #eee;\n      }\n\n      .st247 {\n        fill: #6a6969;\n      }\n\n      .st248 {\n        fill: #dcdcdc;\n      }\n\n      .st249 {\n        fill: #787877;\n      }\n\n      .st250 {\n        fill: #b6b6b6;\n      }\n\n      .st251 {\n        clip-path: url(#clippath);\n      }\n\n      .st252 {\n        fill: #cacaca;\n      }\n\n      .st253 {\n        fill: #c7c6c6;\n      }\n\n      .st254 {\n        fill: #ea571c;\n      }\n\n      .st255 {\n        fill: #cfcfcf;\n      }\n\n      .st256 {\n        fill: #cac9c9;\n      }\n\n      .st257 {\n        fill: #a6a5a5;\n      }\n\n      .st258 {\n        fill: #e8e8e8;\n      }\n\n      .st259 {\n        fill: #616160;\n      }\n\n      .st260 {\n        fill: #b2b2b2;\n      }\n\n      .st261 {\n        fill: #ececec;\n      }\n\n      .st262 {\n        fill: #fdfdfd;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: -0.95,
    y: -0.37,
    width: 409.19,
    height: 511.84
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-.07,84.38V11.83C-.07,5.39,5.2.11,11.65.11h818.8c6.45,0,11.72,5.28,11.72,11.72v72.55H-.07Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M450.61,213.1c-21.43,23.53-38.85,33.58-52.13,34.75-17.6,1.56-26.62-.05-63.42-14.77-28.24-11.29-40.13-2.62-45.18,3.04-5.98,6.7-9.63,15.85-14.33,26.06-4.73,10.26-15.52,23.2-43,32.58,0,0,.96,8.29.24,9.01h216.52l1.3-90.67Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st251"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st11",
    x: 169.45,
    y: 68.02,
    width: 672.43,
    height: 442.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "st235",
    d: "M-.07,84.38V11.83C-.07,5.39,5.2.11,11.65.11h818.8c6.45,0,11.72,5.28,11.72,11.72v72.55"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st42"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st123"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M-.07.11v84.27V.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st140",
    x: -0.07,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st174",
    x: 3.23,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st174",
    x: 6.53,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st262",
    x: 9.83,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st210",
    x: 13.14,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st210",
    x: 16.44,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st209",
    x: 19.74,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st152",
    x: 23.05,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st144",
    x: 26.35,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st144",
    x: 29.65,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st161",
    x: 32.96,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st172",
    x: 36.26,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st59",
    x: 39.56,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st59",
    x: 42.86,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st195",
    x: 46.17,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st64",
    x: 49.47,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st16",
    x: 52.77,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st207",
    x: 56.08,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st188",
    x: 59.38,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 62.68,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 65.98,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st145",
    x: 69.29,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st53",
    x: 72.59,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st246",
    x: 75.89,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st246",
    x: 79.2,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st231",
    x: 82.5,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st261",
    x: 85.8,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st60",
    x: 89.1,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st60",
    x: 92.41,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 95.71,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st159",
    x: 99.01,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st43",
    x: 102.32,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st258",
    x: 105.62,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st129",
    x: 108.92,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st36",
    x: 112.23,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st164",
    x: 115.53,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st96",
    x: 118.83,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st57",
    x: 122.13,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st30",
    x: 125.44,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st30",
    x: 128.74,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st52",
    x: 132.04,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st200",
    x: 135.35,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st245",
    x: 138.65,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    x: 141.95,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 145.25,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st106",
    x: 148.56,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st138",
    x: 151.86,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st121",
    x: 155.16,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st248",
    x: 158.47,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st65",
    x: 161.77,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st189",
    x: 165.07,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st241",
    x: 168.37,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st62",
    x: 171.68,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st101",
    x: 174.98,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st208",
    x: 178.28,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st131",
    x: 181.59,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st17",
    x: 184.89,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st181",
    x: 188.19,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st90",
    x: 191.5,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st85",
    x: 194.8,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st240",
    x: 198.1,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st32",
    x: 201.4,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st244",
    x: 204.71,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st117",
    x: 208.01,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st47",
    x: 211.31,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st255",
    x: 214.62,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st69",
    x: 217.92,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    x: 221.22,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 224.52,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st98",
    x: 227.83,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st214",
    x: 231.13,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st252",
    x: 234.43,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st256",
    x: 237.74,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st21",
    x: 241.04,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st238",
    x: 244.34,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st114",
    x: 247.64,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st253",
    x: 250.95,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st232",
    x: 254.25,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st147",
    x: 257.55,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st103",
    x: 260.86,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st102",
    x: 264.16,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st242",
    x: 267.46,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st93",
    x: 270.77,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st75",
    x: 274.07,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st162",
    x: 277.37,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st26",
    x: 280.67,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st7",
    x: 283.98,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st113",
    x: 287.28,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st19",
    x: 290.58,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st146",
    x: 293.89,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st23",
    x: 297.19,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    x: 300.49,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st150",
    x: 303.79,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st213",
    x: 307.1,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st166",
    x: 310.4,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st51",
    x: 313.7,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st22",
    x: 317.01,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st250",
    x: 320.31,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st39",
    x: 323.61,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st165",
    x: 326.92,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 330.22,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st56",
    x: 333.52,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st260",
    x: 336.82,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st105",
    x: 340.13,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st130",
    x: 343.43,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st44",
    x: 346.73,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st154",
    x: 350.04,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st143",
    x: 353.34,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st236",
    x: 356.64,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st182",
    x: 359.94,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st196",
    x: 363.25,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st183",
    x: 366.55,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st216",
    x: 369.85,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st109",
    x: 373.16,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st226",
    x: 376.46,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st14",
    x: 379.76,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st118",
    x: 383.06,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st257",
    x: 386.37,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st84",
    x: 389.67,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st79",
    x: 392.97,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st29",
    x: 396.28,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st184",
    x: 399.58,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st63",
    x: 402.88,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st107",
    x: 406.19,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st215",
    x: 409.49,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st120",
    x: 412.79,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st89",
    x: 416.09,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st220",
    x: 419.4,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st28",
    x: 422.7,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st133",
    x: 426,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st148",
    x: 429.31,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st137",
    x: 432.61,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st88",
    x: 435.91,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st112",
    x: 439.21,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st176",
    x: 442.52,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st73",
    x: 445.82,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st167",
    x: 449.12,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st45",
    x: 452.43,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st87",
    x: 455.73,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st31",
    x: 459.03,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st234",
    x: 462.33,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st83",
    x: 465.64,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: 468.94,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st169",
    x: 472.24,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st190",
    x: 475.55,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st68",
    x: 478.85,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st224",
    x: 482.15,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st158",
    x: 485.46,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st173",
    x: 488.76,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st194",
    x: 492.06,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st50",
    x: 495.36,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st155",
    x: 498.67,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st122",
    x: 501.97,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st27",
    x: 505.27,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st175",
    x: 508.58,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st48",
    x: 511.88,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st218",
    x: 515.18,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st203",
    x: 518.48,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st49",
    x: 521.79,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st160",
    x: 525.09,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st95",
    x: 528.39,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st78",
    x: 531.7,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st180",
    x: 535,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st80",
    x: 538.3,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st179",
    x: 541.61,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st25",
    x: 544.91,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st202",
    x: 548.21,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st76",
    x: 551.51,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st168",
    x: 554.82,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st249",
    x: 558.12,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st206",
    x: 561.42,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st211",
    x: 564.73,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st104",
    x: 568.03,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st142",
    x: 571.33,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st225",
    x: 574.63,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st229",
    x: 577.94,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st108",
    x: 581.24,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st34",
    x: 584.54,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st135",
    x: 587.85,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st217",
    x: 591.15,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st127",
    x: 594.45,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st192",
    x: 597.75,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st223",
    x: 601.06,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st177",
    x: 604.36,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st247",
    x: 607.66,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st141",
    x: 610.97,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st201",
    x: 614.27,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st134",
    x: 617.57,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st94",
    x: 620.88,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st119",
    x: 624.18,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st187",
    x: 627.48,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st99",
    x: 630.78,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st233",
    x: 634.09,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st259",
    x: 637.39,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st81",
    x: 640.69,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st61",
    x: 644,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st193",
    x: 647.3,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st82",
    x: 650.6,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st132",
    x: 653.9,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st149",
    x: 657.21,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st197",
    x: 660.51,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st71",
    x: 663.81,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st66",
    x: 667.12,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 670.42,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 673.72,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st86",
    x: 677.02,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st46",
    x: 680.33,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st205",
    x: 683.63,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st74",
    x: 686.93,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st230",
    x: 690.24,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st67",
    x: 693.54,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st77",
    x: 696.84,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st151",
    x: 700.15,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st97",
    x: 703.45,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st54",
    x: 706.75,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st191",
    x: 710.05,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st171",
    x: 713.36,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st212",
    x: 716.66,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st221",
    x: 719.96,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st219",
    x: 723.27,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 726.57,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st227",
    x: 729.87,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st70",
    x: 733.17,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st58",
    x: 736.48,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st228",
    x: 739.78,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st185",
    x: 743.08,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st55",
    x: 746.39,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st110",
    x: 749.69,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st163",
    x: 752.99,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 756.29,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st72",
    x: 759.6,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st37",
    x: 762.9,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st139",
    x: 766.2,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st199",
    x: 769.51,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 772.81,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st92",
    x: 776.11,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st153",
    x: 779.42,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st222",
    x: 782.72,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st136",
    x: 786.02,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st156",
    x: 789.32,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st116",
    x: 792.63,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st111",
    x: 795.93,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st204",
    x: 799.23,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st15",
    x: 802.54,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st115",
    x: 805.84,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 809.14,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st198",
    x: 812.44,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st237",
    x: 815.75,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st239",
    x: 819.05,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st38",
    x: 822.35,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st243",
    x: 825.66,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st125",
    x: 828.96,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st128",
    x: 832.26,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st157",
    x: 835.57,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st91",
    x: 838.87,
    y: 0.11,
    width: 3.3,
    height: 84.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M842.17,84.38V.11v84.27Z"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "st140",
    x: 196.91,
    y: 410.44,
    width: 355.11,
    height: 153.53,
    rx: 11.62,
    ry: 11.62
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M218.75,488.31c-.58.64-1.48.96-2.69.96s-2.11-.32-2.69-.96c-.58-.64-.87-1.65-.87-3.02s.29-2.38.87-3.02c.58-.64,1.48-.96,2.69-.96s2.11.32,2.69.96c.58.64.87,1.65.87,3.02s-.29,2.38-.87,3.02ZM218.36,483.44c-.18-.46-.46-.79-.84-1s-.86-.31-1.46-.31-1.09.1-1.46.31c-.38.2-.66.54-.84,1s-.28,1.07-.28,1.84.09,1.38.28,1.84c.18.46.46.79.84,1,.38.2.86.31,1.46.31s1.09-.1,1.46-.31.66-.54.84-1,.28-1.07.28-1.84-.09-1.38-.28-1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M221.99,483.46v3.64c0,.47.12.82.35,1.04.24.22.6.34,1.1.34.35,0,.68-.06,1-.19s.58-.3.8-.53v-4.3h.98v5.69h-.89l-.06-.65c-.29.23-.62.42-1,.56s-.78.21-1.21.21c-.68,0-1.19-.19-1.54-.56-.35-.38-.52-.92-.52-1.64v-3.6h.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M228.86,484.18c.28-.18.61-.35.99-.5s.75-.26,1.12-.34v.77c-.35.07-.73.18-1.13.34-.4.15-.72.31-.95.47v4.24h-.98v-5.69h.89l.07.72h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M239.42,489.27c-.98,0-1.71-.25-2.2-.76-.49-.51-.73-1.24-.73-2.2s.27-1.71.8-2.21,1.27-.75,2.21-.75c.36,0,.66.03.91.08s.5.13.74.25v.78c-.43-.21-.92-.31-1.48-.31-.73,0-1.28.17-1.65.52s-.56.9-.56,1.66.17,1.31.5,1.66c.34.34.89.52,1.67.52.55,0,1.06-.1,1.52-.31v.79c-.5.21-1.09.31-1.75.31l.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M243.6,481.06v6.76c0,.23.04.39.11.49s.2.14.38.14.36-.02.54-.07v.78c-.21.08-.47.12-.78.12-.4,0-.71-.11-.92-.32-.21-.21-.32-.55-.32-1.03v-6.86h.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M246.4,483.46v3.64c0,.47.12.82.35,1.04.24.22.6.34,1.1.34.35,0,.68-.06,1-.19s.58-.3.8-.53v-4.3h.98v5.69h-.89l-.06-.65c-.29.23-.62.42-1,.56s-.78.21-1.21.21c-.68,0-1.19-.19-1.54-.56-.35-.38-.52-.92-.52-1.64v-3.6h.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M257.1,488.52c-.45.5-1.08.75-1.9.75-.42,0-.79-.06-1.11-.17-.32-.12-.61-.3-.87-.55l-.07.6h-.84v-8.09h.98v2.82c.52-.36,1.15-.54,1.9-.54,1.72,0,2.58.97,2.58,2.92,0,1.01-.22,1.76-.67,2.26h0ZM253.3,484.7v3.1c.42.46.98.68,1.66.68s1.13-.18,1.41-.54c.28-.36.43-.92.43-1.68s-.15-1.3-.44-1.63c-.3-.33-.77-.49-1.42-.49s-1.21.19-1.63.56h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M265.63,489.15h-.98v-4.91h-.88l.1-.78h1.76v5.69ZM264.55,482.13v-.9h1.09v.9h-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M270.25,487.22c-.09-.11-.21-.2-.38-.28-.16-.08-.42-.17-.77-.28l-.32-.11c-.4-.14-.71-.26-.94-.38s-.41-.28-.55-.48c-.14-.2-.2-.47-.2-.8,0-.51.18-.9.54-1.16.36-.26.92-.4,1.69-.4.59,0,1.13.08,1.61.23v.86c-.5-.17-.99-.25-1.45-.25-.51,0-.87.05-1.09.16-.21.1-.32.29-.32.55,0,.18.05.33.14.43.09.1.22.19.4.26.17.07.47.17.91.31.47.14.84.29,1.1.43.26.14.45.32.58.53.12.21.19.48.19.8,0,1.08-.75,1.62-2.26,1.62-.36,0-.71-.02-1.04-.07s-.62-.11-.84-.19v-.86c.54.19,1.13.29,1.75.29.52,0,.88-.05,1.09-.16.21-.11.31-.31.31-.61,0-.18-.04-.33-.13-.44h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M281.04,489.36c-.15-.09-.41-.13-.79-.13h-1.51c-.52,0-.91-.09-1.18-.27-.26-.18-.4-.44-.4-.79,0-.25.08-.47.23-.68.15-.2.37-.35.66-.44-.62-.3-.94-.86-.94-1.68,0-.7.2-1.22.61-1.55.41-.33,1.04-.49,1.9-.49.3,0,.62.04.98.12h2.05l-.04.67h-1.03c.34.3.52.71.52,1.25,0,.64-.19,1.13-.56,1.48-.37.34-.93.52-1.69.52-.17,0-.4-.02-.7-.06-.26.02-.5.09-.71.22s-.31.3-.31.5c0,.14.06.25.17.31.11.06.31.09.59.09h1.57c.57,0,1,.12,1.31.35.3.23.46.56.46,1,0,.54-.22.92-.67,1.15-.44.23-1.11.34-2.01.34-.95,0-1.71-.1-2.28-.3v-.82c.31.1.67.18,1.06.24.4.06.79.08,1.17.08.44,0,.78-.02,1.02-.05s.42-.09.54-.19.18-.23.18-.43c0-.21-.07-.36-.22-.44h.02ZM280.8,486.35c.22-.18.33-.51.33-.97s-.11-.8-.34-1.01-.61-.31-1.16-.31-.92.1-1.16.31c-.24.2-.36.54-.36,1.01s.12.77.35.96.62.29,1.18.29.95-.09,1.17-.28h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M284.23,484.18c.28-.18.61-.35.99-.5s.75-.26,1.12-.34v.77c-.35.07-.73.18-1.13.34-.4.15-.72.31-.95.47v4.24h-.98v-5.69h.89l.07.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M292.45,486.3c0,.98-.23,1.72-.69,2.22s-1.18.74-2.15.74-1.69-.25-2.15-.74-.69-1.24-.69-2.22c0-1.98.95-2.96,2.84-2.96s2.84.99,2.84,2.96ZM291.04,487.92c.28-.34.43-.88.43-1.62s-.14-1.28-.43-1.62-.76-.5-1.43-.5-1.14.17-1.43.5-.43.88-.43,1.62.14,1.28.43,1.62c.28.34.76.5,1.43.5s1.15-.17,1.43-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M296.94,485.02l-1.36,4.13h-.98l-1.49-5.69h.98l1.12,4.57,1.27-3.91v-.66h.76l1.4,4.57,1.12-4.57h.98l-1.49,5.69h-.98l-1.33-4.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M303.62,489.15h-.98v-4.91h-.88l.1-.78h1.76v5.69ZM302.54,482.13v-.9h1.09v.9h-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M309.55,489.15v-3.68c0-.34-.04-.61-.13-.8s-.23-.32-.44-.41-.5-.13-.88-.13c-.35,0-.68.06-1,.19s-.58.3-.8.53v4.3h-.98v-5.69h.89l.06.65c.62-.51,1.36-.77,2.21-.77.72,0,1.24.17,1.57.5s.49.86.49,1.58v3.72h-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M315.83,489.36c-.15-.09-.41-.13-.79-.13h-1.51c-.52,0-.91-.09-1.18-.27-.26-.18-.4-.44-.4-.79,0-.25.08-.47.23-.68.15-.2.37-.35.66-.44-.62-.3-.94-.86-.94-1.68,0-.7.2-1.22.61-1.55.41-.33,1.04-.49,1.9-.49.3,0,.62.04.98.12h2.05l-.04.67h-1.03c.34.3.52.71.52,1.25,0,.64-.19,1.13-.56,1.48-.37.34-.93.52-1.69.52-.17,0-.4-.02-.7-.06-.26.02-.5.09-.71.22s-.31.3-.31.5c0,.14.06.25.17.31.11.06.31.09.59.09h1.57c.57,0,1,.12,1.31.35.3.23.46.56.46,1,0,.54-.22.92-.67,1.15-.44.23-1.11.34-2.01.34-.95,0-1.71-.1-2.28-.3v-.82c.31.1.67.18,1.06.24.4.06.79.08,1.17.08.44,0,.78-.02,1.02-.05s.42-.09.54-.19.18-.23.18-.43c0-.21-.07-.36-.22-.44h.02ZM315.59,486.35c.22-.18.33-.51.33-.97s-.11-.8-.34-1.01-.61-.31-1.16-.31-.92.1-1.16.31c-.24.2-.36.54-.36,1.01s.12.77.35.96.62.29,1.18.29.95-.09,1.17-.28h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M328.07,488.52c-.45.5-1.08.75-1.9.75-.42,0-.79-.06-1.11-.17-.32-.12-.61-.3-.87-.55l-.07.6h-.84v-8.09h.98v2.82c.52-.36,1.15-.54,1.9-.54,1.72,0,2.58.97,2.58,2.92,0,1.01-.22,1.76-.67,2.26h0ZM324.26,484.7v3.1c.42.46.98.68,1.66.68s1.13-.18,1.41-.54c.28-.36.43-.92.43-1.68s-.15-1.3-.44-1.63c-.3-.33-.77-.49-1.42-.49s-1.21.19-1.63.56h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M330.3,483.46l1.98,4.58,2.04-4.58h1.01l-2.39,5.44c-.23.54-.45.97-.65,1.3-.2.33-.44.59-.71.78-.28.19-.61.29-.99.29s-.7-.05-.98-.16v-.79c.22.08.47.12.73.12s.47-.05.63-.14c.16-.09.29-.22.4-.4.11-.17.25-.44.42-.81l-2.51-5.63h1.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M341.47,483.46v-1.4l.98-.3v1.7h1.57l-.06.78h-1.51v3.28c0,.35.08.6.23.74.16.14.43.22.81.22.21,0,.44-.04.68-.12v.74c-.3.11-.64.17-1.02.17-.55,0-.97-.15-1.26-.44-.29-.3-.43-.72-.43-1.26v-3.32h-.86v-.78h.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M349.62,489.15v-3.68c0-.49-.11-.83-.32-1.03s-.58-.3-1.09-.3c-.32,0-.65.07-.99.21-.34.14-.62.32-.85.55v4.26h-.98v-8.09h.98v3.01c.6-.49,1.32-.73,2.17-.73.7,0,1.21.17,1.55.51s.51.87.51,1.58v3.72h-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M353.25,487.79c.16.24.39.42.7.53s.73.16,1.26.16c.58,0,1.12-.1,1.61-.3v.77c-.49.22-1.09.32-1.8.32-1.02,0-1.78-.24-2.28-.73-.5-.49-.76-1.24-.76-2.26,0-.94.22-1.66.67-2.17s1.13-.77,2.05-.77c.81,0,1.42.22,1.84.65.42.43.63,1,.63,1.7v1.07h-4.21c.03.44.13.78.28,1.03h0ZM353.36,484.59c-.26.31-.39.79-.39,1.46h3.34v-.47c0-.47-.13-.83-.38-1.08s-.65-.37-1.19-.37c-.66,0-1.11.15-1.37.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M363.63,484.11c.46-.52,1.11-.77,1.93-.77.37,0,.7.04,1,.13s.58.22.85.41v-2.82h.98v8.09h-.84l-.07-.6c-.26.25-.55.43-.87.55s-.69.17-1.11.17c-.83,0-1.47-.23-1.91-.69s-.66-1.19-.66-2.19.23-1.76.7-2.27h0ZM364.37,484.68c-.3.36-.45.93-.45,1.71s.14,1.28.42,1.6.75.49,1.42.49,1.23-.23,1.66-.68v-3.1c-.42-.38-.97-.56-1.63-.56s-1.11.18-1.41.55h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M373.99,488.5c-.25.26-.55.46-.91.58-.36.12-.79.19-1.3.19-.58,0-1.05-.15-1.43-.44s-.57-.72-.57-1.27.18-.99.54-1.3c.36-.32.91-.47,1.66-.47h1.98v-.35c0-.32-.04-.57-.13-.75s-.25-.31-.48-.39c-.23-.08-.57-.12-1.01-.12-.66,0-1.3.1-1.9.31v-.82c.57-.22,1.24-.32,2.03-.32s1.42.17,1.82.5.6.86.6,1.59v3.72h-.83l-.07-.65h0ZM372,486.53c-.44,0-.76.08-.95.25-.2.16-.29.42-.29.77,0,.33.11.56.32.7.22.14.54.21.96.21.81,0,1.45-.28,1.92-.83v-1.1h-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M376.75,483.46l1.98,4.58,2.04-4.58h1.01l-2.39,5.44c-.23.54-.45.97-.65,1.3-.2.33-.44.59-.71.78-.28.19-.61.29-.99.29s-.7-.05-.98-.16v-.79c.22.08.47.12.73.12s.47-.05.63-.14c.16-.09.29-.22.4-.4.11-.17.25-.44.42-.81l-2.51-5.63h1.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M383.82,488.37v.78h-1.08v-.78h1.08ZM383.77,481.42h-.98v1.88l.07,4h.84l.07-4v-1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M392.43,489.15h-1.06l-1.8-7.73h.97l1.45,6.36,1.67-5.51v-.85h.8l1.8,6.36,1.48-6.36h.96l-1.79,7.73h-1.04l-1.68-5.88-1.76,5.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M401.47,489.15h-.98v-4.91h-.88l.1-.78h1.76v5.69ZM400.39,482.13v-.9h1.09v.9h-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M403.55,483.46v-1.4l.98-.3v1.7h1.57l-.06.78h-1.51v3.28c0,.35.08.6.23.74.16.14.43.22.81.22.21,0,.44-.04.68-.12v.74c-.3.11-.64.17-1.02.17-.55,0-.97-.15-1.26-.44-.29-.3-.43-.72-.43-1.26v-3.32h-.86v-.78h.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M411.69,489.15v-3.68c0-.49-.11-.83-.32-1.03s-.58-.3-1.09-.3c-.32,0-.65.07-.99.21-.34.14-.62.32-.85.55v4.26h-.98v-8.09h.98v3.01c.6-.49,1.32-.73,2.17-.73.7,0,1.21.17,1.55.51s.51.87.51,1.58v3.72h-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M419.84,482.26l-1.22.22v-.83l2.21-.35v7.85h-.98v-6.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M426.48,488.63c-.49.42-1.2.64-2.12.64-.38,0-.75-.03-1.13-.08s-.69-.14-.92-.24v-.88c.59.24,1.24.36,1.94.36s1.19-.13,1.51-.38c.32-.26.47-.66.47-1.2s-.13-.93-.38-1.17-.7-.37-1.35-.37h-2.23v-.68l.2-3.2h4.19l-.1.77h-3.26l-.16,2.34h1.45c.9,0,1.56.19,1.98.58.42.38.64.96.64,1.74s-.24,1.36-.73,1.79v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M433.59,483.46v-1.4l.98-.3v1.7h1.57l-.06.78h-1.51v3.28c0,.35.08.6.23.74.16.14.43.22.81.22.21,0,.44-.04.68-.12v.74c-.29.11-.63.17-1.02.17-.55,0-.97-.15-1.26-.44s-.43-.72-.43-1.26v-3.32h-.86v-.78h.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M438.53,487.79c.16.24.39.42.7.53s.73.16,1.26.16c.58,0,1.12-.1,1.61-.3v.77c-.49.22-1.09.32-1.8.32-1.02,0-1.78-.24-2.28-.73-.5-.49-.76-1.24-.76-2.26,0-.94.22-1.66.67-2.17s1.13-.77,2.05-.77c.81,0,1.42.22,1.84.65.42.43.63,1,.63,1.7v1.07h-4.21c.03.44.13.78.28,1.03h0ZM438.64,484.59c-.26.31-.39.79-.39,1.46h3.34v-.47c0-.47-.13-.83-.38-1.08s-.65-.37-1.19-.37c-.66,0-1.11.15-1.37.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M447.87,488.5c-.25.26-.55.46-.91.58-.36.12-.79.19-1.3.19-.58,0-1.05-.15-1.43-.44s-.57-.72-.57-1.27.18-.99.54-1.3c.36-.32.91-.47,1.66-.47h1.98v-.35c0-.32-.04-.57-.13-.75s-.25-.31-.48-.39c-.23-.08-.57-.12-1.01-.12-.66,0-1.3.1-1.9.31v-.82c.57-.22,1.24-.32,2.03-.32s1.42.17,1.82.5.6.86.6,1.59v3.72h-.83l-.07-.65h0ZM445.88,486.53c-.44,0-.76.08-.95.25-.2.16-.29.42-.29.77,0,.33.11.56.32.7.22.14.54.21.96.21.81,0,1.45-.28,1.92-.83v-1.1h-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M458.06,489.15v-3.68c0-.5-.1-.84-.31-1.04s-.55-.29-1.03-.29c-.32,0-.62.05-.91.16-.28.11-.52.27-.71.47.05.2.07.43.07.7v3.68h-.92v-3.66c0-.5-.08-.85-.25-1.05s-.48-.31-.94-.31c-.3,0-.6.07-.9.2s-.56.31-.79.53v4.28h-.97v-5.69h.89l.06.65c.64-.51,1.33-.77,2.06-.77.41,0,.73.07.97.2s.42.33.54.58c.3-.25.62-.44.97-.58.35-.14.76-.2,1.22-.2.65,0,1.13.17,1.45.5s.47.84.47,1.53v3.78h-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M463.58,487.22c-.09-.11-.21-.2-.38-.28s-.42-.17-.77-.28l-.32-.11c-.4-.14-.71-.26-.94-.38s-.41-.28-.55-.48-.2-.47-.2-.8c0-.51.18-.9.54-1.16.36-.26.92-.4,1.69-.4.59,0,1.13.08,1.61.23v.86c-.5-.17-.99-.25-1.45-.25-.51,0-.87.05-1.09.16-.21.1-.32.29-.32.55,0,.18.05.33.14.43.09.1.22.19.4.26.17.07.47.17.91.31.47.14.84.29,1.1.43s.45.32.58.53.19.48.19.8c0,1.08-.75,1.62-2.26,1.62-.36,0-.71-.02-1.04-.07s-.62-.11-.84-.19v-.86c.54.19,1.13.29,1.75.29.52,0,.88-.05,1.09-.16.21-.11.31-.31.31-.61,0-.18-.04-.33-.13-.44h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M474.67,488.5c-.25.26-.55.46-.91.58-.36.12-.79.19-1.3.19-.58,0-1.05-.15-1.43-.44s-.57-.72-.57-1.27.18-.99.54-1.3c.36-.32.91-.47,1.66-.47h1.98v-.35c0-.32-.04-.57-.13-.75s-.25-.31-.48-.39c-.23-.08-.57-.12-1.01-.12-.66,0-1.3.1-1.9.31v-.82c.57-.22,1.24-.32,2.03-.32s1.42.17,1.82.5.6.86.6,1.59v3.72h-.83l-.07-.65h0ZM472.67,486.53c-.44,0-.76.08-.95.25-.2.16-.29.42-.29.77,0,.33.11.56.32.7.22.14.54.21.96.21.81,0,1.45-.28,1.92-.83v-1.1h-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M477.27,483.46v-1.4l.98-.3v1.7h1.57l-.06.78h-1.51v3.28c0,.35.08.6.23.74.16.14.43.22.81.22.21,0,.44-.04.68-.12v.74c-.3.11-.64.17-1.02.17-.55,0-.97-.15-1.26-.44s-.43-.72-.43-1.26v-3.32h-.86v-.78h.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M486.2,484.11c.46-.52,1.11-.77,1.93-.77.37,0,.7.04,1,.13s.58.22.85.41v-2.82h.98v8.09h-.84l-.07-.6c-.26.25-.55.43-.87.55s-.69.17-1.11.17c-.83,0-1.47-.23-1.91-.69s-.66-1.19-.66-2.19.23-1.76.7-2.27h0ZM486.94,484.68c-.3.36-.45.93-.45,1.71s.14,1.28.42,1.6.75.49,1.42.49,1.23-.23,1.66-.68v-3.1c-.42-.38-.97-.56-1.63-.56s-1.11.18-1.41.55h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M494.5,489.15h-.98v-4.91h-.88l.1-.78h1.76v5.69ZM493.42,482.13v-.9h1.09v.9h-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M499.39,481.05v.74c-.25-.09-.51-.13-.79-.13-.4,0-.67.07-.82.22-.15.14-.22.4-.22.76v.83h1.54l-.05.78h-1.49v4.91h-.98v-4.91h-.85v-.78h.85v-.83c0-.55.15-.98.46-1.3.3-.31.74-.47,1.32-.47.38,0,.72.06,1.04.18h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M503,481.05v.74c-.25-.09-.51-.13-.79-.13-.4,0-.67.07-.82.22-.15.14-.22.4-.22.76v.83h1.54l-.05.78h-1.49v4.91h-.98v-4.91h-.85v-.78h.85v-.83c0-.55.15-.98.46-1.3.3-.31.74-.47,1.32-.47.38,0,.72.06,1.04.18h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M504.51,487.79c.16.24.39.42.7.53s.73.16,1.26.16c.58,0,1.12-.1,1.61-.3v.77c-.49.22-1.09.32-1.8.32-1.02,0-1.78-.24-2.28-.73-.5-.49-.76-1.24-.76-2.26,0-.94.22-1.66.67-2.17s1.13-.77,2.05-.77c.81,0,1.42.22,1.84.65.42.43.63,1,.63,1.7v1.07h-4.21c.03.44.13.78.28,1.03h0ZM504.61,484.59c-.26.31-.39.79-.39,1.46h3.34v-.47c0-.47-.13-.83-.38-1.08s-.65-.37-1.19-.37c-.66,0-1.11.15-1.37.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M510.83,484.18c.28-.18.61-.35.99-.5.38-.15.75-.26,1.12-.34v.77c-.35.07-.73.18-1.13.34-.4.15-.72.31-.95.47v4.24h-.98v-5.69h.89l.07.72h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M514.81,487.79c.16.24.39.42.7.53s.73.16,1.26.16c.58,0,1.12-.1,1.61-.3v.77c-.49.22-1.09.32-1.8.32-1.02,0-1.78-.24-2.28-.73-.5-.49-.76-1.24-.76-2.26,0-.94.22-1.66.67-2.17s1.13-.77,2.05-.77c.81,0,1.42.22,1.84.65.42.43.63,1,.63,1.7v1.07h-4.21c.03.44.13.78.28,1.03h.01ZM514.92,484.59c-.26.31-.39.79-.39,1.46h3.34v-.47c0-.47-.13-.83-.38-1.08s-.65-.37-1.19-.37c-.66,0-1.11.15-1.37.46h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M524.42,489.15v-3.68c0-.34-.04-.61-.13-.8s-.23-.32-.44-.41-.5-.13-.88-.13c-.35,0-.68.06-1,.19-.31.13-.58.3-.8.53v4.3h-.98v-5.69h.89l.06.65c.62-.51,1.36-.77,2.21-.77.72,0,1.24.17,1.57.5.33.34.49.86.49,1.58v3.72h-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M527.41,483.46v-1.4l.98-.3v1.7h1.57l-.06.78h-1.51v3.28c0,.35.08.6.23.74.16.14.43.22.81.22.21,0,.44-.04.68-.12v.74c-.3.11-.64.17-1.02.17-.55,0-.97-.15-1.26-.44s-.43-.72-.43-1.26v-3.32h-.86v-.78h.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M216.71,504.5c-.25.26-.55.46-.91.58s-.79.19-1.3.19c-.58,0-1.05-.15-1.43-.44s-.57-.72-.57-1.27.18-.99.54-1.3c.36-.32.91-.47,1.66-.47h1.98v-.35c0-.32-.04-.57-.13-.75-.09-.18-.25-.31-.48-.39-.23-.08-.57-.12-1.01-.12-.66,0-1.3.1-1.9.31v-.82c.57-.22,1.24-.32,2.03-.32s1.42.17,1.82.5.6.86.6,1.59v3.72h-.83l-.07-.65h0ZM214.72,502.53c-.44,0-.76.08-.95.25-.2.16-.29.42-.29.77,0,.33.11.56.32.7.22.14.54.21.96.21.81,0,1.45-.28,1.92-.83v-1.1h-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M222.91,505.36c-.15-.09-.41-.13-.79-.13h-1.51c-.52,0-.91-.09-1.18-.27-.26-.18-.4-.44-.4-.79,0-.25.08-.47.23-.68.15-.2.37-.35.66-.44-.62-.3-.94-.86-.94-1.68,0-.7.2-1.22.61-1.55s1.04-.49,1.9-.49c.3,0,.62.04.98.12h2.05l-.04.67h-1.03c.34.3.52.71.52,1.25,0,.64-.19,1.13-.56,1.48-.37.34-.93.52-1.69.52-.17,0-.4-.02-.7-.06-.26.02-.5.09-.71.22s-.31.3-.31.5c0,.14.06.25.17.31s.31.09.59.09h1.57c.57,0,1,.12,1.31.35.3.23.46.56.46,1,0,.54-.22.92-.67,1.15-.44.23-1.11.34-2.01.34-.95,0-1.71-.1-2.28-.3v-.82c.31.1.67.18,1.06.24.4.06.79.08,1.17.08.44,0,.78-.02,1.02-.05s.42-.09.54-.19.18-.23.18-.43c0-.21-.07-.36-.22-.44h.02ZM222.67,502.35c.22-.18.33-.51.33-.97s-.11-.8-.34-1.01-.61-.31-1.16-.31-.92.1-1.16.31c-.24.2-.36.54-.36,1.01s.12.77.35.96c.23.19.62.29,1.18.29s.95-.09,1.17-.28h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M226.46,503.79c.16.24.39.42.7.53s.73.16,1.26.16c.58,0,1.12-.1,1.61-.3v.77c-.49.22-1.09.32-1.8.32-1.02,0-1.78-.24-2.28-.73-.5-.49-.76-1.24-.76-2.26,0-.94.22-1.66.67-2.17s1.13-.77,2.05-.77c.81,0,1.42.22,1.84.65s.63,1,.63,1.7v1.07h-4.21c.03.44.13.78.28,1.03h.01ZM226.57,500.59c-.26.31-.39.79-.39,1.46h3.34v-.47c0-.47-.13-.83-.38-1.08s-.65-.37-1.19-.37c-.66,0-1.11.15-1.37.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M240.07,505.36c-.15-.09-.41-.13-.79-.13h-1.51c-.52,0-.91-.09-1.18-.27-.26-.18-.4-.44-.4-.79,0-.25.08-.47.23-.68.15-.2.37-.35.66-.44-.62-.3-.94-.86-.94-1.68,0-.7.2-1.22.61-1.55s1.04-.49,1.9-.49c.3,0,.62.04.98.12h2.05l-.04.67h-1.03c.34.3.52.71.52,1.25,0,.64-.19,1.13-.56,1.48-.37.34-.93.52-1.69.52-.17,0-.4-.02-.7-.06-.26.02-.5.09-.71.22s-.31.3-.31.5c0,.14.06.25.17.31s.31.09.59.09h1.57c.57,0,1,.12,1.31.35.3.23.46.56.46,1,0,.54-.22.92-.67,1.15-.44.23-1.11.34-2.01.34-.95,0-1.71-.1-2.28-.3v-.82c.31.1.67.18,1.06.24.4.06.79.08,1.17.08.44,0,.78-.02,1.02-.05s.42-.09.54-.19.18-.23.18-.43c0-.21-.07-.36-.22-.44h.02ZM239.83,502.35c.22-.18.33-.51.33-.97s-.11-.8-.34-1.01-.61-.31-1.16-.31-.92.1-1.16.31c-.24.2-.36.54-.36,1.01s.12.77.35.96c.23.19.62.29,1.18.29s.95-.09,1.17-.28h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M243.25,500.18c.28-.18.61-.35.99-.5s.75-.26,1.12-.34v.77c-.35.07-.73.18-1.13.34-.4.15-.72.31-.95.47v4.24h-.98v-5.69h.89l.07.72h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M251.47,502.3c0,.98-.23,1.72-.69,2.22s-1.18.74-2.15.74-1.69-.25-2.15-.74-.69-1.24-.69-2.22c0-1.98.95-2.96,2.84-2.96s2.84.99,2.84,2.96ZM250.06,503.92c.28-.34.43-.88.43-1.62s-.14-1.28-.43-1.62-.76-.5-1.43-.5-1.14.17-1.43.5-.43.88-.43,1.62.14,1.28.43,1.62c.28.34.76.5,1.43.5s1.15-.17,1.43-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M253.84,499.46v3.64c0,.47.12.82.35,1.04.24.22.6.34,1.1.34.35,0,.68-.06,1-.19s.58-.3.8-.53v-4.3h.98v5.69h-.89l-.06-.65c-.29.23-.62.42-1,.56s-.78.21-1.21.21c-.68,0-1.19-.19-1.54-.56-.35-.38-.52-.92-.52-1.64v-3.6h.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M264.54,504.5c-.45.51-1.08.77-1.91.77-.74,0-1.38-.18-1.9-.54v3.01h-.98v-8.28h.84l.07.6c.26-.25.55-.43.87-.55s.69-.17,1.11-.17c.83,0,1.47.23,1.91.69s.66,1.19.66,2.19-.22,1.77-.67,2.28h0ZM263.78,503.93c.3-.36.45-.93.45-1.71s-.14-1.28-.42-1.6-.75-.49-1.42-.49-1.23.23-1.66.68v3.1c.42.38.97.56,1.63.56s1.11-.18,1.41-.55h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M269.58,503.22c-.09-.11-.21-.2-.38-.28-.16-.08-.42-.17-.77-.28l-.32-.11c-.4-.14-.71-.26-.94-.38s-.41-.28-.55-.48c-.14-.2-.2-.47-.2-.8,0-.51.18-.9.54-1.16.36-.26.92-.4,1.69-.4.59,0,1.13.08,1.61.23v.86c-.5-.17-.99-.25-1.45-.25-.51,0-.87.05-1.09.16-.21.1-.32.29-.32.55,0,.18.05.33.14.43.09.1.22.19.4.26.17.07.47.17.91.31.47.14.84.29,1.1.43.26.14.45.32.58.53.12.21.19.48.19.8,0,1.08-.75,1.62-2.26,1.62-.36,0-.71-.02-1.04-.07s-.62-.11-.84-.19v-.86c.54.19,1.13.29,1.75.29.52,0,.88-.05,1.09-.16.21-.11.31-.31.31-.61,0-.18-.04-.33-.13-.44h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M280.93,505.15v-3.68c0-.34-.04-.61-.13-.8s-.23-.32-.44-.41-.5-.13-.88-.13c-.35,0-.68.06-1,.19s-.58.3-.8.53v4.3h-.98v-5.69h.89l.06.65c.62-.51,1.36-.77,2.21-.77.72,0,1.24.17,1.57.5s.49.86.49,1.58v3.72h-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M288.79,502.3c0,.98-.23,1.72-.69,2.22s-1.18.74-2.15.74-1.69-.25-2.15-.74-.69-1.24-.69-2.22c0-1.98.95-2.96,2.84-2.96s2.84.99,2.84,2.96ZM287.38,503.92c.28-.34.43-.88.43-1.62s-.14-1.28-.43-1.62-.76-.5-1.43-.5-1.14.17-1.43.5-.43.88-.43,1.62.14,1.28.43,1.62c.28.34.76.5,1.43.5s1.15-.17,1.43-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M293.28,501.02l-1.36,4.13h-.98l-1.49-5.69h.98l1.12,4.57,1.27-3.91v-.66h.76l1.4,4.57,1.12-4.57h.98l-1.49,5.69h-.98l-1.33-4.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M298.28,504.32h.89v.83h-.89v-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M311.19,504.31c-.58.64-1.48.96-2.69.96s-2.11-.32-2.69-.96c-.58-.64-.87-1.65-.87-3.02s.29-2.38.87-3.02c.58-.64,1.48-.96,2.69-.96s2.11.32,2.69.96c.58.64.87,1.65.87,3.02s-.29,2.38-.87,3.02ZM310.8,499.44c-.18-.46-.46-.79-.84-1s-.86-.31-1.46-.31-1.09.1-1.46.31c-.38.2-.66.54-.84,1s-.28,1.07-.28,1.84.09,1.38.28,1.84c.18.46.46.79.84,1,.38.2.86.31,1.46.31s1.09-.1,1.46-.31.66-.54.84-1,.28-1.07.28-1.84-.09-1.38-.28-1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M314.42,499.46v3.64c0,.47.12.82.35,1.04.24.22.6.34,1.1.34.35,0,.68-.06,1-.19s.58-.3.8-.53v-4.3h.98v5.69h-.89l-.06-.65c-.29.23-.62.42-1,.56s-.78.21-1.21.21c-.68,0-1.19-.19-1.54-.56-.35-.38-.52-.92-.52-1.64v-3.6h.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M321.3,500.18c.28-.18.61-.35.99-.5s.75-.26,1.12-.34v.77c-.35.07-.73.18-1.13.34-.4.15-.72.31-.95.47v4.24h-.98v-5.69h.89l.07.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M332.94,505.15h-3.77v-7.73h3.58c1.47,0,2.21.68,2.21,2.04,0,.42-.08.77-.25,1.05s-.41.5-.72.65c.85.21,1.27.8,1.27,1.78,0,1.47-.77,2.21-2.32,2.21h0ZM333.7,498.5c-.22-.22-.62-.32-1.19-.32h-2.35v2.63h2.53c.9,0,1.34-.42,1.34-1.27,0-.47-.11-.82-.33-1.03h0ZM333.91,504.06c.24-.23.36-.62.36-1.15,0-.46-.12-.81-.37-1.03s-.68-.33-1.28-.33h-2.46v2.86h2.62c.52,0,.9-.12,1.14-.35h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M337.62,499.46v3.64c0,.47.12.82.35,1.04.24.22.6.34,1.1.34.35,0,.68-.06,1-.19s.58-.3.8-.53v-4.3h.98v5.69h-.89l-.06-.65c-.29.23-.62.42-1,.56s-.78.21-1.21.21c-.68,0-1.19-.19-1.54-.56-.35-.38-.52-.92-.52-1.64v-3.6h.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M344.52,497.06v6.76c0,.23.04.39.11.49s.2.14.38.14.36-.02.54-.07v.78c-.21.08-.47.12-.78.12-.4,0-.71-.11-.92-.32s-.32-.55-.32-1.03v-6.86h.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M347.37,497.06v6.76c0,.23.04.39.11.49s.2.14.38.14.36-.02.54-.07v.78c-.21.08-.47.12-.78.12-.4,0-.71-.11-.92-.32s-.32-.55-.32-1.03v-6.86h.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M352.47,503.22c-.09-.11-.21-.2-.38-.28-.16-.08-.42-.17-.77-.28l-.32-.11c-.4-.14-.71-.26-.94-.38s-.41-.28-.55-.48c-.14-.2-.2-.47-.2-.8,0-.51.18-.9.54-1.16.36-.26.92-.4,1.69-.4.59,0,1.13.08,1.61.23v.86c-.5-.17-.99-.25-1.45-.25-.51,0-.87.05-1.09.16-.21.1-.32.29-.32.55,0,.18.05.33.14.43.09.1.22.19.4.26.17.07.47.17.91.31.47.14.84.29,1.1.43.26.14.45.32.58.53.12.21.19.48.19.8,0,1.08-.75,1.62-2.26,1.62-.36,0-.71-.02-1.04-.07s-.62-.11-.84-.19v-.86c.54.19,1.13.29,1.75.29.52,0,.88-.05,1.09-.16.21-.11.31-.31.31-.61,0-.18-.04-.33-.13-.44h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M363.18,501.02l-1.36,4.13h-.98l-1.49-5.69h.98l1.12,4.57,1.27-3.91v-.66h.76l1.4,4.57,1.12-4.57h.98l-1.49,5.69h-.98l-1.33-4.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M373.33,502.3c0,.98-.23,1.72-.69,2.22s-1.18.74-2.15.74-1.69-.25-2.15-.74-.69-1.24-.69-2.22c0-1.98.95-2.96,2.84-2.96s2.84.99,2.84,2.96ZM371.92,503.92c.28-.34.43-.88.43-1.62s-.14-1.28-.43-1.62-.76-.5-1.43-.5-1.14.17-1.43.5-.43.88-.43,1.62.14,1.28.43,1.62c.28.34.76.5,1.43.5s1.15-.17,1.43-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M379.01,505.15v-3.68c0-.34-.04-.61-.13-.8s-.23-.32-.44-.41-.5-.13-.88-.13c-.35,0-.68.06-1,.19s-.58.3-.8.53v4.3h-.98v-5.69h.89l.06.65c.62-.51,1.36-.77,2.21-.77.72,0,1.24.17,1.57.5s.49.86.49,1.58v3.72h-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M391.62,502.3c0,.98-.23,1.72-.69,2.22s-1.18.74-2.15.74-1.69-.25-2.15-.74-.69-1.24-.69-2.22c0-1.98.95-2.96,2.84-2.96s2.84.99,2.84,2.96ZM390.21,503.92c.28-.34.43-.88.43-1.62s-.14-1.28-.43-1.62-.76-.5-1.43-.5-1.14.17-1.43.5-.43.88-.43,1.62.14,1.28.43,1.62c.28.34.76.5,1.43.5s1.15-.17,1.43-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M393.98,499.46v3.64c0,.47.12.82.35,1.04.24.22.6.34,1.1.34.35,0,.68-.06,1-.19s.58-.3.8-.53v-4.3h.98v5.69h-.89l-.06-.65c-.29.23-.62.42-1,.56s-.78.21-1.21.21c-.68,0-1.19-.19-1.54-.56-.35-.38-.52-.92-.52-1.64v-3.6h.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M400.86,500.18c.28-.18.61-.35.99-.5s.75-.26,1.12-.34v.77c-.35.07-.73.18-1.13.34-.4.15-.72.31-.95.47v4.24h-.98v-5.69h.89l.07.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M412.69,504.7c-.51.38-1.22.57-2.13.57-.35,0-.73-.03-1.13-.1-.4-.06-.72-.14-.95-.23v-.86c.59.23,1.24.35,1.96.35s1.22-.11,1.54-.32c.32-.21.49-.57.49-1.09,0-.94-.59-1.42-1.78-1.42h-1.12l.1-.74h.92c.57,0,.99-.12,1.28-.37.28-.25.43-.6.43-1.07s-.15-.76-.44-.97c-.3-.21-.76-.31-1.39-.31-.31,0-.63.03-.95.1-.32.06-.62.15-.89.25v-.85c.23-.1.53-.18.9-.24s.72-.1,1.07-.1c.89,0,1.56.19,2.01.58.45.38.68.9.68,1.54,0,.42-.11.79-.32,1.12-.22.33-.54.56-.96.69.49.11.85.33,1.09.65s.36.7.36,1.15c0,.74-.25,1.29-.76,1.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M415.86,500.18c.28-.18.61-.35.99-.5s.75-.26,1.12-.34v.77c-.35.07-.73.18-1.13.34-.4.15-.72.31-.95.47v4.24h-.98v-5.69h.89l.07.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M419.08,500.11c.46-.52,1.11-.77,1.93-.77.37,0,.7.04,1,.13s.58.22.85.41v-2.82h.98v8.09h-.84l-.07-.6c-.26.25-.55.43-.87.55s-.69.17-1.11.17c-.83,0-1.47-.23-1.91-.69s-.66-1.19-.66-2.19.23-1.76.7-2.27h0ZM419.82,500.68c-.3.36-.45.93-.45,1.71s.14,1.28.42,1.6.75.49,1.42.49,1.23-.23,1.66-.68v-3.1c-.42-.38-.97-.56-1.63-.56s-1.11.18-1.41.55h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M433.77,505.36c-.15-.09-.41-.13-.79-.13h-1.51c-.52,0-.91-.09-1.18-.27-.26-.18-.4-.44-.4-.79,0-.25.08-.47.23-.68.15-.2.37-.35.66-.44-.62-.3-.94-.86-.94-1.68,0-.7.2-1.22.61-1.55.41-.33,1.04-.49,1.9-.49.3,0,.62.04.98.12h2.05l-.04.67h-1.03c.34.3.52.71.52,1.25,0,.64-.19,1.13-.56,1.48s-.93.52-1.69.52c-.17,0-.4-.02-.7-.06-.26.02-.5.09-.71.22s-.31.3-.31.5c0,.14.06.25.17.31.11.06.31.09.59.09h1.57c.57,0,1,.12,1.31.35.3.23.46.56.46,1,0,.54-.22.92-.67,1.15-.44.23-1.11.34-2.01.34-.95,0-1.71-.1-2.28-.3v-.82c.31.1.67.18,1.06.24.4.06.79.08,1.17.08.44,0,.78-.02,1.02-.05s.42-.09.54-.19.18-.23.18-.43c0-.21-.07-.36-.22-.44h.02ZM433.53,502.35c.22-.18.33-.51.33-.97s-.11-.8-.34-1.01c-.23-.21-.61-.31-1.16-.31s-.92.1-1.16.31c-.24.2-.36.54-.36,1.01s.12.77.35.96.62.29,1.18.29.95-.09,1.17-.28h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M439.84,504.5c-.25.26-.55.46-.91.58-.36.12-.79.19-1.3.19-.58,0-1.05-.15-1.43-.44s-.57-.72-.57-1.27.18-.99.54-1.3c.36-.32.91-.47,1.66-.47h1.98v-.35c0-.32-.04-.57-.13-.75s-.25-.31-.48-.39c-.23-.08-.57-.12-1.01-.12-.66,0-1.3.1-1.9.31v-.82c.57-.22,1.24-.32,2.03-.32s1.42.17,1.82.5.6.86.6,1.59v3.72h-.83l-.07-.65h0ZM437.85,502.53c-.44,0-.76.08-.95.25-.2.16-.29.42-.29.77,0,.33.11.56.32.7.22.14.54.21.96.21.81,0,1.45-.28,1.92-.83v-1.1h-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M450.03,505.15v-3.68c0-.5-.1-.84-.31-1.04s-.55-.29-1.03-.29c-.32,0-.62.05-.91.16-.28.11-.52.27-.71.47.05.2.07.43.07.7v3.68h-.92v-3.66c0-.5-.08-.85-.25-1.05s-.48-.31-.94-.31c-.3,0-.6.07-.9.2s-.56.31-.79.53v4.28h-.97v-5.69h.89l.06.65c.64-.51,1.33-.77,2.06-.77.41,0,.73.07.97.2s.42.33.54.58c.3-.25.62-.44.97-.58.35-.14.76-.2,1.22-.2.65,0,1.13.17,1.45.5s.47.84.47,1.53v3.78h-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M453.65,503.79c.16.24.39.42.7.53s.73.16,1.26.16c.58,0,1.12-.1,1.61-.3v.77c-.49.22-1.09.32-1.8.32-1.02,0-1.78-.24-2.28-.73-.5-.49-.76-1.24-.76-2.26,0-.94.22-1.66.67-2.17s1.13-.77,2.05-.77c.81,0,1.42.22,1.84.65.42.43.63,1,.63,1.7v1.07h-4.21c.03.44.13.78.28,1.03h0ZM453.76,500.59c-.26.31-.39.79-.39,1.46h3.34v-.47c0-.47-.13-.83-.38-1.08s-.65-.37-1.19-.37c-.66,0-1.11.15-1.37.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M465.44,505.15h-.98v-4.91h-.88l.1-.78h1.76v5.69ZM464.36,498.13v-.9h1.09v.9h-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M471.37,505.15v-3.68c0-.34-.04-.61-.13-.8s-.23-.32-.44-.41-.5-.13-.88-.13c-.35,0-.68.06-1,.19-.31.13-.58.3-.8.53v4.3h-.98v-5.69h.89l.06.65c.62-.51,1.36-.77,2.21-.77.72,0,1.24.17,1.57.5.33.34.49.86.49,1.58v3.72h-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M482.5,504.5c-.25.26-.55.46-.91.58-.36.12-.79.19-1.3.19-.58,0-1.05-.15-1.43-.44s-.57-.72-.57-1.27.18-.99.54-1.3c.36-.32.91-.47,1.66-.47h1.98v-.35c0-.32-.04-.57-.13-.75s-.25-.31-.48-.39c-.23-.08-.57-.12-1.01-.12-.66,0-1.3.1-1.9.31v-.82c.57-.22,1.24-.32,2.03-.32s1.42.17,1.82.5.6.86.6,1.59v3.72h-.83l-.07-.65h0ZM480.51,502.53c-.44,0-.76.08-.95.25-.2.16-.29.42-.29.77,0,.33.11.56.32.7.22.14.54.21.96.21.81,0,1.45-.28,1.92-.83v-1.1h-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M490.54,500.18c.28-.18.61-.35.99-.5s.75-.26,1.12-.34v.77c-.35.07-.73.18-1.13.34-.4.15-.72.31-.95.47v4.24h-.98v-5.69h.89l.07.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M498.76,502.3c0,.98-.23,1.72-.69,2.22s-1.18.74-2.15.74-1.69-.25-2.15-.74-.69-1.24-.69-2.22c0-1.98.95-2.96,2.84-2.96s2.84.99,2.84,2.96ZM497.35,503.92c.28-.34.43-.88.43-1.62s-.14-1.28-.43-1.62-.76-.5-1.43-.5-1.14.17-1.43.5-.43.88-.43,1.62.14,1.28.43,1.62.76.5,1.43.5,1.15-.17,1.43-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M503.25,501.02l-1.36,4.13h-.98l-1.49-5.69h.98l1.12,4.57,1.27-3.91v-.66h.76l1.4,4.57,1.12-4.57h.98l-1.49,5.69h-.98l-1.33-4.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M514.04,497.06v6.76c0,.23.04.39.11.49.08.09.2.14.38.14s.36-.02.54-.07v.78c-.21.08-.47.12-.78.12-.4,0-.71-.11-.92-.32s-.32-.55-.32-1.03v-6.86h.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M519.64,504.5c-.25.26-.55.46-.91.58s-.79.19-1.3.19c-.58,0-1.05-.15-1.43-.44s-.57-.72-.57-1.27.18-.99.54-1.3c.36-.32.91-.47,1.66-.47h1.98v-.35c0-.32-.04-.57-.13-.75s-.25-.31-.48-.39c-.23-.08-.57-.12-1.01-.12-.66,0-1.3.1-1.9.31v-.82c.57-.22,1.24-.32,2.03-.32s1.42.17,1.82.5.6.86.6,1.59v3.72h-.83l-.07-.65h0ZM517.65,502.53c-.44,0-.76.08-.95.25-.2.16-.29.42-.29.77,0,.33.11.56.32.7.22.14.54.21.96.21.81,0,1.45-.28,1.92-.83v-1.1h-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M525.09,503.22c-.09-.11-.21-.2-.38-.28s-.42-.17-.77-.28l-.32-.11c-.4-.14-.71-.26-.94-.38s-.41-.28-.55-.48-.2-.47-.2-.8c0-.51.18-.9.54-1.16s.92-.4,1.69-.4c.59,0,1.13.08,1.61.23v.86c-.5-.17-.99-.25-1.45-.25-.51,0-.87.05-1.09.16-.21.1-.32.29-.32.55,0,.18.05.33.14.43s.22.19.4.26c.17.07.47.17.91.31.47.14.84.29,1.1.43s.45.32.58.53.19.48.19.8c0,1.08-.75,1.62-2.26,1.62-.36,0-.71-.02-1.04-.07s-.62-.11-.84-.19v-.86c.54.19,1.13.29,1.75.29.52,0,.88-.05,1.09-.16.21-.11.31-.31.31-.61,0-.18-.04-.33-.13-.44h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M528.03,499.46v-1.4l.98-.3v1.7h1.57l-.06.78h-1.51v3.28c0,.35.08.6.23.74.16.14.43.22.81.22.21,0,.44-.04.68-.12v.74c-.3.11-.64.17-1.02.17-.55,0-.97-.15-1.26-.44s-.43-.72-.43-1.26v-3.32h-.86v-.78h.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M217.22,520.72c-.5.37-1.24.55-2.21.55s-1.74-.12-2.33-.36v-.88c.7.26,1.45.4,2.24.4.71,0,1.23-.1,1.57-.29.33-.19.5-.53.5-1.01,0-.3-.07-.53-.21-.71s-.36-.33-.66-.46c-.3-.12-.74-.25-1.31-.39-.85-.21-1.44-.48-1.79-.8-.34-.33-.52-.78-.52-1.34,0-.67.24-1.19.73-1.57.48-.37,1.2-.56,2.14-.56.42,0,.82.03,1.21.09s.7.13.93.21v.86c-.61-.22-1.27-.32-1.98-.32s-1.19.1-1.53.3-.51.53-.51.98c0,.26.06.48.18.64.12.16.32.3.61.41.28.12.71.24,1.27.38.9.22,1.54.51,1.9.87s.54.83.54,1.41c0,.69-.25,1.22-.75,1.58h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M223.2,520.5c-.25.26-.55.46-.91.58s-.79.19-1.3.19c-.58,0-1.05-.15-1.43-.44s-.57-.72-.57-1.27.18-.99.54-1.3c.36-.32.91-.47,1.66-.47h1.98v-.35c0-.32-.04-.57-.13-.75-.09-.18-.25-.31-.48-.39s-.57-.12-1.01-.12c-.66,0-1.3.1-1.9.31v-.82c.57-.22,1.24-.32,2.03-.32s1.42.17,1.82.5.6.86.6,1.59v3.72h-.83l-.07-.65h0ZM221.21,518.53c-.44,0-.76.08-.95.25-.2.16-.29.42-.29.77,0,.33.11.56.32.7.22.14.54.21.96.21.81,0,1.45-.28,1.92-.83v-1.1h-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M225.8,515.46v-1.4l.98-.3v1.7h1.57l-.06.78h-1.51v3.28c0,.35.08.6.23.74.16.14.43.22.81.22.21,0,.44-.04.68-.12v.74c-.3.11-.64.17-1.02.17-.55,0-.97-.15-1.26-.44-.29-.3-.43-.72-.43-1.26v-3.32h-.86v-.78h.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M230.34,515.46v3.64c0,.47.12.82.35,1.04.24.22.6.34,1.1.34.35,0,.68-.06,1-.19s.58-.3.8-.53v-4.3h.98v5.69h-.89l-.06-.65c-.29.23-.62.42-1,.56s-.78.21-1.21.21c-.68,0-1.19-.19-1.54-.56-.35-.38-.52-.92-.52-1.64v-3.6h.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M237.22,516.18c.28-.18.61-.35.99-.5s.75-.26,1.12-.34v.77c-.35.07-.73.18-1.13.34-.4.15-.72.31-.95.47v4.24h-.98v-5.69h.89l.07.72h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M240.44,516.11c.46-.52,1.11-.77,1.93-.77.37,0,.7.04,1,.13s.58.22.85.41v-2.82h.98v8.09h-.84l-.07-.6c-.26.25-.55.43-.87.55-.32.12-.69.17-1.11.17-.83,0-1.47-.23-1.91-.69s-.66-1.19-.66-2.19.23-1.76.7-2.27h0ZM241.18,516.68c-.3.36-.45.93-.45,1.71s.14,1.28.42,1.6.75.49,1.42.49,1.23-.23,1.66-.68v-3.1c-.42-.38-.97-.56-1.63-.56s-1.11.18-1.41.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M250.8,520.5c-.25.26-.55.46-.91.58s-.79.19-1.3.19c-.58,0-1.05-.15-1.43-.44s-.57-.72-.57-1.27.18-.99.54-1.3c.36-.32.91-.47,1.66-.47h1.98v-.35c0-.32-.04-.57-.13-.75-.09-.18-.25-.31-.48-.39s-.57-.12-1.01-.12c-.66,0-1.3.1-1.9.31v-.82c.57-.22,1.24-.32,2.03-.32s1.42.17,1.82.5.6.86.6,1.59v3.72h-.83l-.07-.65h0ZM248.81,518.53c-.44,0-.76.08-.95.25-.2.16-.29.42-.29.77,0,.33.11.56.32.7.22.14.54.21.96.21.81,0,1.45-.28,1.92-.83v-1.1h-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M253.56,515.46l1.98,4.58,2.04-4.58h1.01l-2.39,5.44c-.23.54-.45.97-.65,1.3s-.44.59-.71.78c-.28.19-.61.29-.99.29s-.7-.05-.98-.16v-.79c.22.08.47.12.73.12s.47-.05.63-.14.29-.22.4-.4c.11-.17.25-.44.42-.81l-2.51-5.63h1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M259.1,520.46h.89l-.5,2.12h-.72l.34-2.12h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M269.58,517.02l-1.36,4.13h-.98l-1.49-5.69h.98l1.12,4.57,1.27-3.91v-.66h.76l1.4,4.57,1.12-4.57h.98l-1.49,5.69h-.98l-1.33-4.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M275.25,519.79c.16.24.39.42.7.53s.73.16,1.26.16c.58,0,1.12-.1,1.61-.3v.77c-.49.22-1.09.32-1.8.32-1.02,0-1.78-.24-2.28-.73s-.76-1.24-.76-2.26c0-.94.22-1.66.67-2.17s1.13-.77,2.05-.77c.81,0,1.42.22,1.84.65.42.43.63,1,.63,1.7v1.07h-4.21c.03.44.13.78.28,1.03h0ZM275.36,516.59c-.26.31-.39.79-.39,1.46h3.34v-.47c0-.47-.13-.83-.38-1.08s-.65-.37-1.19-.37c-.66,0-1.11.15-1.37.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M281.6,513.06v6.76c0,.23.04.39.11.49s.2.14.38.14.36-.02.54-.07v.78c-.21.08-.47.12-.78.12-.4,0-.71-.11-.92-.32-.21-.21-.32-.55-.32-1.03v-6.86h.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M284.46,513.06v6.76c0,.23.04.39.11.49s.2.14.38.14.36-.02.54-.07v.78c-.21.08-.47.12-.78.12-.4,0-.71-.11-.92-.32-.21-.21-.32-.55-.32-1.03v-6.86h.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M291.65,516.11c.46-.52,1.11-.77,1.93-.77.37,0,.7.04,1,.13s.58.22.85.41v-2.82h.98v8.09h-.84l-.07-.6c-.26.25-.55.43-.87.55s-.69.17-1.11.17c-.83,0-1.47-.23-1.91-.69s-.66-1.19-.66-2.19.23-1.76.7-2.27h0ZM292.39,516.68c-.3.36-.45.93-.45,1.71s.14,1.28.42,1.6.75.49,1.42.49,1.23-.23,1.66-.68v-3.1c-.42-.38-.97-.56-1.63-.56s-1.11.18-1.41.55h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M303.36,518.3c0,.98-.23,1.72-.69,2.22s-1.18.74-2.15.74-1.69-.25-2.15-.74-.69-1.24-.69-2.22c0-1.98.95-2.96,2.84-2.96s2.84.99,2.84,2.96ZM301.95,519.92c.28-.34.43-.88.43-1.62s-.14-1.28-.43-1.62-.76-.5-1.43-.5-1.14.17-1.43.5-.43.88-.43,1.62.14,1.28.43,1.62c.28.34.76.5,1.43.5s1.15-.17,1.43-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M309.03,521.15v-3.68c0-.34-.04-.61-.13-.8s-.23-.32-.44-.41-.5-.13-.88-.13c-.35,0-.68.06-1,.19s-.58.3-.8.53v4.3h-.98v-5.69h.89l.06.65c.62-.51,1.36-.77,2.21-.77.72,0,1.24.17,1.57.5s.49.86.49,1.58v3.72h-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M312.66,519.79c.16.24.39.42.7.53s.73.16,1.26.16c.58,0,1.12-.1,1.61-.3v.77c-.49.22-1.09.32-1.8.32-1.02,0-1.78-.24-2.28-.73s-.76-1.24-.76-2.26c0-.94.22-1.66.67-2.17s1.13-.77,2.05-.77c.81,0,1.42.22,1.84.65.42.43.63,1,.63,1.7v1.07h-4.21c.03.44.13.78.28,1.03h0ZM312.77,516.59c-.26.31-.39.79-.39,1.46h3.34v-.47c0-.47-.13-.83-.38-1.08s-.65-.37-1.19-.37c-.66,0-1.11.15-1.37.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M322.98,515.46v-1.4l.98-.3v1.7h1.57l-.06.78h-1.51v3.28c0,.35.08.6.23.74.16.14.43.22.81.22.21,0,.44-.04.68-.12v.74c-.3.11-.64.17-1.02.17-.55,0-.97-.15-1.26-.44-.29-.3-.43-.72-.43-1.26v-3.32h-.86v-.78h.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M332.04,518.3c0,.98-.23,1.72-.69,2.22s-1.18.74-2.15.74-1.69-.25-2.15-.74-.69-1.24-.69-2.22c0-1.98.95-2.96,2.84-2.96s2.84.99,2.84,2.96ZM330.63,519.92c.28-.34.43-.88.43-1.62s-.14-1.28-.43-1.62-.76-.5-1.43-.5-1.14.17-1.43.5-.43.88-.43,1.62.14,1.28.43,1.62c.28.34.76.5,1.43.5s1.15-.17,1.43-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M338.82,515.46l1.98,4.58,2.04-4.58h1.01l-2.39,5.44c-.23.54-.45.97-.65,1.3-.2.33-.44.59-.71.78-.28.19-.61.29-.99.29s-.7-.05-.98-.16v-.79c.22.08.47.12.73.12s.47-.05.63-.14.29-.22.4-.4c.11-.17.25-.44.42-.81l-2.51-5.63h1.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M349.95,518.3c0,.98-.23,1.72-.69,2.22s-1.18.74-2.15.74-1.69-.25-2.15-.74-.69-1.24-.69-2.22c0-1.98.95-2.96,2.84-2.96s2.84.99,2.84,2.96ZM348.54,519.92c.28-.34.43-.88.43-1.62s-.14-1.28-.43-1.62-.76-.5-1.43-.5-1.14.17-1.43.5-.43.88-.43,1.62.14,1.28.43,1.62c.28.34.76.5,1.43.5s1.15-.17,1.43-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M352.32,515.46v3.64c0,.47.12.82.35,1.04.24.22.6.34,1.1.34.35,0,.68-.06,1-.19s.58-.3.8-.53v-4.3h.98v5.69h-.89l-.06-.65c-.29.23-.62.42-1,.56s-.78.21-1.21.21c-.68,0-1.19-.19-1.54-.56-.35-.38-.52-.92-.52-1.64v-3.6h.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M366.77,520.5c-.25.26-.55.46-.91.58-.36.12-.79.19-1.3.19-.58,0-1.05-.15-1.43-.44s-.57-.72-.57-1.27.18-.99.54-1.3c.36-.32.91-.47,1.66-.47h1.98v-.35c0-.32-.04-.57-.13-.75s-.25-.31-.48-.39-.57-.12-1.01-.12c-.66,0-1.3.1-1.9.31v-.82c.57-.22,1.24-.32,2.03-.32s1.42.17,1.82.5.6.86.6,1.59v3.72h-.83l-.07-.65h0ZM364.77,518.53c-.44,0-.76.08-.95.25-.2.16-.29.42-.29.77,0,.33.11.56.32.7.22.14.54.21.96.21.81,0,1.45-.28,1.92-.83v-1.1h-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M373.52,521.15v-3.68c0-.34-.04-.61-.13-.8s-.23-.32-.44-.41-.5-.13-.88-.13c-.35,0-.68.06-1,.19s-.58.3-.8.53v4.3h-.98v-5.69h.89l.06.65c.62-.51,1.36-.77,2.21-.77.72,0,1.24.17,1.57.5s.49.86.49,1.58v3.72h-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M376.58,516.11c.46-.52,1.11-.77,1.93-.77.37,0,.7.04,1,.13s.58.22.85.41v-2.82h.98v8.09h-.84l-.07-.6c-.26.25-.55.43-.87.55s-.69.17-1.11.17c-.83,0-1.47-.23-1.91-.69s-.66-1.19-.66-2.19.23-1.76.7-2.27h0ZM377.32,516.68c-.3.36-.45.93-.45,1.71s.14,1.28.42,1.6.75.49,1.42.49,1.23-.23,1.66-.68v-3.1c-.42-.38-.97-.56-1.63-.56s-1.11.18-1.41.55h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M390.27,521.27c-.98,0-1.71-.25-2.2-.76-.49-.51-.73-1.24-.73-2.2s.27-1.71.8-2.21,1.27-.75,2.21-.75c.36,0,.66.03.91.08s.5.13.74.25v.78c-.43-.21-.92-.31-1.48-.31-.73,0-1.28.17-1.65.52s-.56.9-.56,1.66.17,1.31.5,1.66c.34.34.89.52,1.67.52.55,0,1.06-.1,1.52-.31v.79c-.5.21-1.09.31-1.75.31l.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M398.49,518.3c0,.98-.23,1.72-.69,2.22s-1.18.74-2.15.74-1.69-.25-2.15-.74-.69-1.24-.69-2.22c0-1.98.95-2.96,2.84-2.96s2.84.99,2.84,2.96ZM397.08,519.92c.28-.34.43-.88.43-1.62s-.14-1.28-.43-1.62-.76-.5-1.43-.5-1.14.17-1.43.5-.43.88-.43,1.62.14,1.28.43,1.62c.28.34.76.5,1.43.5s1.15-.17,1.43-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M403.6,520.5c-.25.26-.55.46-.91.58-.36.12-.79.19-1.3.19-.58,0-1.05-.15-1.43-.44s-.57-.72-.57-1.27.18-.99.54-1.3c.36-.32.91-.47,1.66-.47h1.98v-.35c0-.32-.04-.57-.13-.75s-.25-.31-.48-.39-.57-.12-1.01-.12c-.66,0-1.3.1-1.9.31v-.82c.57-.22,1.24-.32,2.03-.32s1.42.17,1.82.5.6.86.6,1.59v3.72h-.83l-.07-.65h0ZM401.61,518.53c-.44,0-.76.08-.95.25-.2.16-.29.42-.29.77,0,.33.11.56.32.7.22.14.54.21.96.21.81,0,1.45-.28,1.92-.83v-1.1h-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M408.63,521.27c-.98,0-1.71-.25-2.2-.76-.49-.51-.73-1.24-.73-2.2s.27-1.71.8-2.21,1.27-.75,2.21-.75c.36,0,.66.03.91.08s.5.13.74.25v.78c-.43-.21-.92-.31-1.48-.31-.73,0-1.28.17-1.65.52s-.56.9-.56,1.66.17,1.31.5,1.66c.34.34.89.52,1.67.52.55,0,1.06-.1,1.52-.31v.79c-.5.21-1.09.31-1.75.31l.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M416.06,521.15v-3.68c0-.49-.11-.83-.32-1.03s-.58-.3-1.09-.3c-.32,0-.65.07-.99.21s-.62.32-.85.55v4.26h-.98v-8.09h.98v3.01c.6-.49,1.32-.73,2.17-.73.7,0,1.21.17,1.55.51s.51.87.51,1.58v3.72h-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M420.52,521.15h-.98v-4.91h-.88l.1-.78h1.76v5.69ZM419.44,514.13v-.9h1.09v.9h-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M426.45,521.15v-3.68c0-.34-.04-.61-.13-.8s-.23-.32-.44-.41-.5-.13-.88-.13c-.35,0-.68.06-1,.19-.31.13-.58.3-.8.53v4.3h-.98v-5.69h.89l.06.65c.62-.51,1.36-.77,2.21-.77.72,0,1.24.17,1.57.5s.49.86.49,1.58v3.72h-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M432.73,521.36c-.15-.09-.41-.13-.79-.13h-1.51c-.52,0-.91-.09-1.18-.27-.26-.18-.4-.44-.4-.79,0-.25.08-.47.23-.68.15-.2.37-.35.66-.44-.62-.3-.94-.86-.94-1.68,0-.7.2-1.22.61-1.55.41-.33,1.04-.49,1.9-.49.3,0,.62.04.98.12h2.05l-.04.67h-1.03c.34.3.52.71.52,1.25,0,.64-.19,1.13-.56,1.48-.37.34-.93.52-1.69.52-.17,0-.4-.02-.7-.06-.26.02-.5.09-.71.22s-.31.3-.31.5c0,.14.06.25.17.31.11.06.31.09.59.09h1.57c.57,0,1,.12,1.31.35.3.23.46.56.46,1,0,.54-.22.92-.67,1.15-.44.23-1.11.34-2.01.34-.95,0-1.71-.1-2.28-.3v-.82c.31.1.67.18,1.06.24.4.06.79.08,1.17.08.44,0,.78-.02,1.02-.05.24-.03.42-.09.54-.19s.18-.23.18-.43c0-.21-.07-.36-.22-.44h.02ZM432.49,518.35c.22-.18.33-.51.33-.97s-.11-.8-.34-1.01-.61-.31-1.16-.31-.92.1-1.16.31c-.24.2-.36.54-.36,1.01s.12.77.35.96.62.29,1.18.29.95-.09,1.17-.28h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M443.11,519.22c-.09-.11-.21-.2-.38-.28s-.42-.17-.77-.28l-.32-.11c-.4-.14-.71-.26-.94-.38s-.41-.28-.55-.48-.2-.47-.2-.8c0-.51.18-.9.54-1.16.36-.26.92-.4,1.69-.4.59,0,1.13.08,1.61.23v.86c-.5-.17-.99-.25-1.45-.25-.51,0-.87.05-1.09.16-.21.1-.32.29-.32.55,0,.18.05.33.14.43.09.1.22.19.4.26.17.07.47.17.91.31.47.14.84.29,1.1.43s.45.32.58.53.19.48.19.8c0,1.08-.75,1.62-2.26,1.62-.36,0-.71-.02-1.04-.07s-.62-.11-.84-.19v-.86c.54.19,1.13.29,1.75.29.52,0,.88-.05,1.09-.16s.31-.31.31-.61c0-.18-.04-.33-.13-.44h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M446.05,515.46v-1.4l.98-.3v1.7h1.57l-.06.78h-1.51v3.28c0,.35.08.6.23.74.16.14.43.22.81.22.21,0,.44-.04.68-.12v.74c-.3.11-.64.17-1.02.17-.55,0-.97-.15-1.26-.44s-.43-.72-.43-1.26v-3.32h-.86v-.78h.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M453.51,520.5c-.25.26-.55.46-.91.58-.36.12-.79.19-1.3.19-.58,0-1.05-.15-1.43-.44s-.57-.72-.57-1.27.18-.99.54-1.3c.36-.32.91-.47,1.66-.47h1.98v-.35c0-.32-.04-.57-.13-.75s-.25-.31-.48-.39-.57-.12-1.01-.12c-.66,0-1.3.1-1.9.31v-.82c.57-.22,1.24-.32,2.03-.32s1.42.17,1.82.5.6.86.6,1.59v3.72h-.83l-.07-.65h0ZM451.52,518.53c-.44,0-.76.08-.95.25-.2.16-.29.42-.29.77,0,.33.11.56.32.7.22.14.54.21.96.21.81,0,1.45-.28,1.92-.83v-1.1h-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M459.22,513.05v.74c-.25-.09-.51-.13-.79-.13-.4,0-.67.07-.82.22-.15.14-.22.4-.22.76v.83h1.54l-.05.78h-1.49v4.91h-.98v-4.91h-.85v-.78h.85v-.83c0-.55.15-.98.46-1.3.3-.31.74-.47,1.32-.47.38,0,.72.06,1.04.18h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M462.84,513.05v.74c-.25-.09-.51-.13-.79-.13-.4,0-.67.07-.82.22-.15.14-.22.4-.22.76v.83h1.54l-.05.78h-1.49v4.91h-.98v-4.91h-.85v-.78h.85v-.83c0-.55.15-.98.46-1.3.3-.31.74-.47,1.32-.47.38,0,.72.06,1.04.18h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M462.39,520.46h.89l-.5,2.12h-.72l.34-2.12h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M474.73,518.3c0,.98-.23,1.72-.69,2.22s-1.18.74-2.15.74-1.69-.25-2.15-.74-.69-1.24-.69-2.22c0-1.98.95-2.96,2.84-2.96s2.84.99,2.84,2.96ZM473.32,519.92c.28-.34.43-.88.43-1.62s-.14-1.28-.43-1.62-.76-.5-1.43-.5-1.14.17-1.43.5-.43.88-.43,1.62.14,1.28.43,1.62.76.5,1.43.5,1.15-.17,1.43-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M477.09,515.46v3.64c0,.47.12.82.35,1.04.24.22.6.34,1.1.34.35,0,.68-.06,1-.19.31-.13.58-.3.8-.53v-4.3h.98v5.69h-.89l-.06-.65c-.29.23-.62.42-1,.56s-.78.21-1.21.21c-.68,0-1.19-.19-1.54-.56-.35-.38-.52-.92-.52-1.64v-3.6h.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M483.97,516.18c.28-.18.61-.35.99-.5s.75-.26,1.12-.34v.77c-.35.07-.73.18-1.13.34-.4.15-.72.31-.95.47v4.24h-.98v-5.69h.89l.07.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M492.22,515.46v-1.4l.98-.3v1.7h1.57l-.06.78h-1.51v3.28c0,.35.08.6.23.74.16.14.43.22.81.22.21,0,.44-.04.68-.12v.74c-.3.11-.64.17-1.02.17-.55,0-.97-.15-1.26-.44s-.43-.72-.43-1.26v-3.32h-.86v-.78h.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M497.16,519.79c.16.24.39.42.7.53.31.11.73.16,1.26.16.58,0,1.12-.1,1.61-.3v.77c-.49.22-1.09.32-1.8.32-1.02,0-1.78-.24-2.28-.73s-.76-1.24-.76-2.26c0-.94.22-1.66.67-2.17s1.13-.77,2.05-.77c.81,0,1.42.22,1.84.65.42.43.63,1,.63,1.7v1.07h-4.21c.03.44.13.78.28,1.03h0ZM497.27,516.59c-.26.31-.39.79-.39,1.46h3.34v-.47c0-.47-.13-.83-.38-1.08s-.65-.37-1.19-.37c-.66,0-1.11.15-1.37.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M506.5,520.5c-.25.26-.55.46-.91.58-.36.12-.79.19-1.3.19-.58,0-1.05-.15-1.43-.44s-.57-.72-.57-1.27.18-.99.54-1.3c.36-.32.91-.47,1.66-.47h1.98v-.35c0-.32-.04-.57-.13-.75s-.25-.31-.48-.39-.57-.12-1.01-.12c-.66,0-1.3.1-1.9.31v-.82c.57-.22,1.24-.32,2.03-.32s1.42.17,1.82.5.6.86.6,1.59v3.72h-.83l-.07-.65h0ZM504.51,518.53c-.44,0-.76.08-.95.25-.2.16-.29.42-.29.77,0,.33.11.56.32.7.22.14.54.21.96.21.81,0,1.45-.28,1.92-.83v-1.1h-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M516.69,521.15v-3.68c0-.5-.1-.84-.31-1.04s-.55-.29-1.03-.29c-.32,0-.62.05-.91.16-.28.11-.52.27-.71.47.05.2.07.43.07.7v3.68h-.92v-3.66c0-.5-.08-.85-.25-1.05s-.48-.31-.94-.31c-.3,0-.6.07-.9.2s-.56.31-.79.53v4.28h-.97v-5.69h.89l.06.65c.64-.51,1.33-.77,2.06-.77.41,0,.73.07.97.2s.42.33.54.58c.3-.25.62-.44.97-.58s.76-.2,1.22-.2c.65,0,1.13.17,1.45.5s.47.84.47,1.53v3.78h-.97,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M522.21,519.22c-.09-.11-.21-.2-.38-.28s-.42-.17-.77-.28l-.32-.11c-.4-.14-.71-.26-.94-.38s-.41-.28-.55-.48-.2-.47-.2-.8c0-.51.18-.9.54-1.16.36-.26.92-.4,1.69-.4.59,0,1.13.08,1.61.23v.86c-.5-.17-.99-.25-1.45-.25-.51,0-.87.05-1.09.16-.21.1-.32.29-.32.55,0,.18.05.33.14.43s.22.19.4.26c.17.07.47.17.91.31.47.14.84.29,1.1.43s.45.32.58.53.19.48.19.8c0,1.08-.75,1.62-2.26,1.62-.36,0-.71-.02-1.04-.07s-.62-.11-.84-.19v-.86c.54.19,1.13.29,1.75.29.52,0,.88-.05,1.09-.16s.31-.31.31-.61c0-.18-.04-.33-.13-.44h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M533.3,520.5c-.25.26-.55.46-.91.58s-.79.19-1.3.19c-.58,0-1.05-.15-1.43-.44s-.57-.72-.57-1.27.18-.99.54-1.3c.36-.32.91-.47,1.66-.47h1.98v-.35c0-.32-.04-.57-.13-.75s-.25-.31-.48-.39-.57-.12-1.01-.12c-.66,0-1.3.1-1.9.31v-.82c.57-.22,1.24-.32,2.03-.32s1.42.17,1.82.5.6.86.6,1.59v3.72h-.83l-.07-.65h0ZM531.3,518.53c-.44,0-.76.08-.95.25-.2.16-.29.42-.29.77,0,.33.11.56.32.7.22.14.54.21.96.21.81,0,1.45-.28,1.92-.83v-1.1h-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M536.78,516.18c.28-.18.61-.35.99-.5s.75-.26,1.12-.34v.77c-.35.07-.73.18-1.13.34-.4.15-.72.31-.95.47v4.24h-.98v-5.69h.89l.07.72h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M540.75,519.79c.16.24.39.42.7.53.31.11.73.16,1.26.16.58,0,1.12-.1,1.61-.3v.77c-.49.22-1.09.32-1.8.32-1.02,0-1.78-.24-2.28-.73s-.76-1.24-.76-2.26c0-.94.22-1.66.67-2.17s1.13-.77,2.05-.77c.81,0,1.42.22,1.84.65.42.43.63,1,.63,1.7v1.07h-4.21c.03.44.13.78.28,1.03h.01ZM540.86,516.59c-.26.31-.39.79-.39,1.46h3.34v-.47c0-.47-.13-.83-.38-1.08s-.65-.37-1.19-.37c-.66,0-1.11.15-1.37.46h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M220.4,537.15v-3.68c0-.5-.1-.84-.31-1.04s-.55-.29-1.03-.29c-.32,0-.62.05-.91.16-.28.11-.52.27-.71.47.05.2.07.43.07.7v3.68h-.92v-3.66c0-.5-.08-.85-.25-1.05s-.48-.31-.94-.31c-.3,0-.6.07-.9.2-.3.13-.56.31-.79.53v4.28h-.97v-5.69h.89l.06.65c.64-.51,1.33-.77,2.06-.77.41,0,.73.07.97.2s.42.33.54.58c.3-.25.62-.44.97-.58s.76-.2,1.22-.2c.65,0,1.13.17,1.45.5s.47.84.47,1.53v3.78h-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M226.79,536.5c-.25.26-.55.46-.91.58s-.79.19-1.3.19c-.58,0-1.05-.15-1.43-.44s-.57-.72-.57-1.27.18-.99.54-1.3c.36-.32.91-.47,1.66-.47h1.98v-.35c0-.32-.04-.57-.13-.75-.09-.18-.25-.31-.48-.39s-.57-.12-1.01-.12c-.66,0-1.3.1-1.9.31v-.82c.57-.22,1.24-.32,2.03-.32s1.42.17,1.82.5.6.86.6,1.59v3.72h-.83l-.07-.65h0ZM224.8,534.53c-.44,0-.76.08-.95.25-.2.16-.29.42-.29.77,0,.33.11.56.32.7.22.14.54.21.96.21.81,0,1.45-.28,1.92-.83v-1.1h-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M234.23,537.15h-1.03l-2.05-2.9-.85.8v2.1h-.98v-8.09h.98v4.91l2.66-2.51h1.14l-2.33,2.26,2.46,3.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M236.75,537.15h-.98v-4.91h-.88l.1-.78h1.76v5.69ZM235.67,530.13v-.9h1.09v.9h-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M242.68,537.15v-3.68c0-.34-.04-.61-.13-.8-.09-.19-.23-.32-.44-.41s-.5-.13-.88-.13c-.35,0-.68.06-1,.19s-.58.3-.8.53v4.3h-.98v-5.69h.89l.06.65c.62-.51,1.36-.77,2.21-.77.72,0,1.24.17,1.57.5s.49.86.49,1.58v3.72h-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M248.96,537.36c-.15-.09-.41-.13-.79-.13h-1.51c-.52,0-.91-.09-1.18-.27-.26-.18-.4-.44-.4-.79,0-.25.08-.47.23-.68.15-.2.37-.35.66-.44-.62-.3-.94-.86-.94-1.68,0-.7.2-1.22.61-1.55s1.04-.49,1.9-.49c.3,0,.62.04.98.12h2.05l-.04.67h-1.03c.34.3.52.71.52,1.25,0,.64-.19,1.13-.56,1.48-.37.34-.93.52-1.69.52-.17,0-.4-.02-.7-.06-.26.02-.5.09-.71.22s-.31.3-.31.5c0,.14.06.25.17.31s.31.09.59.09h1.57c.57,0,1,.12,1.31.35.3.23.46.56.46,1,0,.54-.22.92-.67,1.15-.44.23-1.11.34-2.01.34-.95,0-1.71-.1-2.28-.3v-.82c.31.1.67.18,1.06.24.4.06.79.08,1.17.08.44,0,.78-.02,1.02-.05.24-.03.42-.09.54-.19s.18-.23.18-.43c0-.21-.07-.36-.22-.44h.02ZM248.72,534.35c.22-.18.33-.51.33-.97s-.11-.8-.34-1.01-.61-.31-1.16-.31-.92.1-1.16.31c-.24.2-.36.54-.36,1.01s.12.77.35.96c.23.19.62.29,1.18.29s.95-.09,1.17-.28h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M260.08,537.36c-.15-.09-.41-.13-.79-.13h-1.51c-.52,0-.91-.09-1.18-.27-.26-.18-.4-.44-.4-.79,0-.25.08-.47.23-.68.15-.2.37-.35.66-.44-.62-.3-.94-.86-.94-1.68,0-.7.2-1.22.61-1.55.41-.33,1.04-.49,1.9-.49.3,0,.62.04.98.12h2.05l-.04.67h-1.03c.34.3.52.71.52,1.25,0,.64-.19,1.13-.56,1.48-.37.34-.93.52-1.69.52-.17,0-.4-.02-.7-.06-.26.02-.5.09-.71.22s-.31.3-.31.5c0,.14.06.25.17.31.11.06.31.09.59.09h1.57c.57,0,1,.12,1.31.35.3.23.46.56.46,1,0,.54-.22.92-.67,1.15-.44.23-1.11.34-2.01.34-.95,0-1.71-.1-2.28-.3v-.82c.31.1.67.18,1.06.24.4.06.79.08,1.17.08.44,0,.78-.02,1.02-.05.24-.03.42-.09.54-.19s.18-.23.18-.43c0-.21-.07-.36-.22-.44h.02ZM259.84,534.35c.22-.18.33-.51.33-.97s-.11-.8-.34-1.01-.61-.31-1.16-.31-.92.1-1.16.31c-.24.2-.36.54-.36,1.01s.12.77.35.96.62.29,1.18.29.95-.09,1.17-.28h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M263.27,532.18c.28-.18.61-.35.99-.5s.75-.26,1.12-.34v.77c-.35.07-.73.18-1.13.34-.4.15-.72.31-.95.47v4.24h-.98v-5.69h.89l.07.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M267.25,535.79c.16.24.39.42.7.53s.73.16,1.26.16c.58,0,1.12-.1,1.61-.3v.77c-.49.22-1.09.32-1.8.32-1.02,0-1.78-.24-2.28-.73s-.76-1.24-.76-2.26c0-.94.22-1.66.67-2.17s1.13-.77,2.05-.77c.81,0,1.42.22,1.84.65.42.43.63,1,.63,1.7v1.07h-4.21c.03.44.13.78.28,1.03h0ZM267.35,532.59c-.26.31-.39.79-.39,1.46h3.34v-.47c0-.47-.13-.83-.38-1.08s-.65-.37-1.19-.37c-.66,0-1.11.15-1.37.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M276.59,536.5c-.25.26-.55.46-.91.58-.36.12-.79.19-1.3.19-.58,0-1.05-.15-1.43-.44s-.57-.72-.57-1.27.18-.99.54-1.3c.36-.32.91-.47,1.66-.47h1.98v-.35c0-.32-.04-.57-.13-.75s-.25-.31-.48-.39-.57-.12-1.01-.12c-.66,0-1.3.1-1.9.31v-.82c.57-.22,1.24-.32,2.03-.32s1.42.17,1.82.5.6.86.6,1.59v3.72h-.83l-.07-.65h0ZM274.6,534.53c-.44,0-.76.08-.95.25-.2.16-.29.42-.29.77,0,.33.11.56.32.7.22.14.54.21.96.21.81,0,1.45-.28,1.92-.83v-1.1h-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M279.19,531.46v-1.4l.98-.3v1.7h1.57l-.06.78h-1.51v3.28c0,.35.08.6.23.74.16.14.43.22.81.22.21,0,.44-.04.68-.12v.74c-.3.11-.64.17-1.02.17-.55,0-.97-.15-1.26-.44-.29-.3-.43-.72-.43-1.26v-3.32h-.86v-.78h.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M292.45,536.5c-.45.51-1.08.77-1.91.77-.74,0-1.38-.18-1.9-.54v3.01h-.98v-8.28h.84l.07.6c.26-.25.55-.43.87-.55s.69-.17,1.11-.17c.83,0,1.47.23,1.91.69s.66,1.19.66,2.19-.22,1.77-.67,2.28h0ZM291.69,535.93c.3-.36.45-.93.45-1.71s-.14-1.28-.42-1.6c-.28-.32-.75-.49-1.42-.49s-1.23.23-1.66.68v3.1c.42.38.97.56,1.63.56s1.11-.18,1.41-.55h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M295.52,532.18c.28-.18.61-.35.99-.5s.75-.26,1.12-.34v.77c-.35.07-.73.18-1.13.34-.4.15-.72.31-.95.47v4.24h-.98v-5.69h.89l.07.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M303.74,534.3c0,.98-.23,1.72-.69,2.22s-1.18.74-2.15.74-1.69-.25-2.15-.74-.69-1.24-.69-2.22c0-1.98.95-2.96,2.84-2.96s2.84.99,2.84,2.96ZM302.33,535.92c.28-.34.43-.88.43-1.62s-.14-1.28-.43-1.62-.76-.5-1.43-.5-1.14.17-1.43.5-.43.88-.43,1.62.14,1.28.43,1.62c.28.34.76.5,1.43.5s1.15-.17,1.43-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M308.44,537.36c-.15-.09-.41-.13-.79-.13h-1.51c-.52,0-.91-.09-1.18-.27-.26-.18-.4-.44-.4-.79,0-.25.08-.47.23-.68.15-.2.37-.35.66-.44-.62-.3-.94-.86-.94-1.68,0-.7.2-1.22.61-1.55.41-.33,1.04-.49,1.9-.49.3,0,.62.04.98.12h2.05l-.04.67h-1.03c.34.3.52.71.52,1.25,0,.64-.19,1.13-.56,1.48-.37.34-.93.52-1.69.52-.17,0-.4-.02-.7-.06-.26.02-.5.09-.71.22s-.31.3-.31.5c0,.14.06.25.17.31.11.06.31.09.59.09h1.57c.57,0,1,.12,1.31.35.3.23.46.56.46,1,0,.54-.22.92-.67,1.15-.44.23-1.11.34-2.01.34-.95,0-1.71-.1-2.28-.3v-.82c.31.1.67.18,1.06.24.4.06.79.08,1.17.08.44,0,.78-.02,1.02-.05.24-.03.42-.09.54-.19s.18-.23.18-.43c0-.21-.07-.36-.22-.44h.02ZM308.2,534.35c.22-.18.33-.51.33-.97s-.11-.8-.34-1.01-.61-.31-1.16-.31-.92.1-1.16.31c-.24.2-.36.54-.36,1.01s.12.77.35.96.62.29,1.18.29.95-.09,1.17-.28h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M311.63,532.18c.28-.18.61-.35.99-.5s.75-.26,1.12-.34v.77c-.35.07-.73.18-1.13.34-.4.15-.72.31-.95.47v4.24h-.98v-5.69h.89l.07.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M315.6,535.79c.16.24.39.42.7.53s.73.16,1.26.16c.58,0,1.12-.1,1.61-.3v.77c-.49.22-1.09.32-1.8.32-1.02,0-1.78-.24-2.28-.73s-.76-1.24-.76-2.26c0-.94.22-1.66.67-2.17s1.13-.77,2.05-.77c.81,0,1.42.22,1.84.65.42.43.63,1,.63,1.7v1.07h-4.21c.03.44.13.78.28,1.03h0ZM315.71,532.59c-.26.31-.39.79-.39,1.46h3.34v-.47c0-.47-.13-.83-.38-1.08s-.65-.37-1.19-.37c-.66,0-1.11.15-1.37.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M323.9,535.22c-.09-.11-.21-.2-.38-.28-.16-.08-.42-.17-.77-.28l-.32-.11c-.4-.14-.71-.26-.94-.38s-.41-.28-.55-.48c-.14-.2-.2-.47-.2-.8,0-.51.18-.9.54-1.16.36-.26.92-.4,1.69-.4.59,0,1.13.08,1.61.23v.86c-.5-.17-.99-.25-1.45-.25-.51,0-.87.05-1.09.16-.21.1-.32.29-.32.55,0,.18.05.33.14.43.09.1.22.19.4.26.17.07.47.17.91.31.47.14.84.29,1.1.43s.45.32.58.53c.12.21.19.48.19.8,0,1.08-.75,1.62-2.26,1.62-.36,0-.71-.02-1.04-.07s-.62-.11-.84-.19v-.86c.54.19,1.13.29,1.75.29.52,0,.88-.05,1.09-.16s.31-.31.31-.61c0-.18-.04-.33-.13-.44h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M329.39,535.22c-.09-.11-.21-.2-.38-.28-.16-.08-.42-.17-.77-.28l-.32-.11c-.4-.14-.71-.26-.94-.38s-.41-.28-.55-.48c-.14-.2-.2-.47-.2-.8,0-.51.18-.9.54-1.16.36-.26.92-.4,1.69-.4.59,0,1.13.08,1.61.23v.86c-.5-.17-.99-.25-1.45-.25-.51,0-.87.05-1.09.16-.21.1-.32.29-.32.55,0,.18.05.33.14.43.09.1.22.19.4.26.17.07.47.17.91.31.47.14.84.29,1.1.43s.45.32.58.53c.12.21.19.48.19.8,0,1.08-.75,1.62-2.26,1.62-.36,0-.71-.02-1.04-.07s-.62-.11-.84-.19v-.86c.54.19,1.13.29,1.75.29.52,0,.88-.05,1.09-.16s.31-.31.31-.61c0-.18-.04-.33-.13-.44h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M338.36,537.15h-.98v-4.91h-.88l.1-.78h1.76v5.69ZM337.28,530.13v-.9h1.09v.9h-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M344.29,537.15v-3.68c0-.34-.04-.61-.13-.8s-.23-.32-.44-.41-.5-.13-.88-.13c-.35,0-.68.06-1,.19s-.58.3-.8.53v4.3h-.98v-5.69h.89l.06.65c.62-.51,1.36-.77,2.21-.77.72,0,1.24.17,1.57.5s.49.86.49,1.58v3.72h-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M351.84,531.46v-1.4l.98-.3v1.7h1.57l-.06.78h-1.51v3.28c0,.35.08.6.23.74.16.14.43.22.81.22.21,0,.44-.04.68-.12v.74c-.3.11-.64.17-1.02.17-.55,0-.97-.15-1.26-.44-.29-.3-.43-.72-.43-1.26v-3.32h-.86v-.78h.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M359.99,537.15v-3.68c0-.49-.11-.83-.32-1.03s-.58-.3-1.09-.3c-.32,0-.65.07-.99.21s-.62.32-.85.55v4.26h-.98v-8.09h.98v3.01c.6-.49,1.32-.73,2.17-.73.7,0,1.21.17,1.55.51s.51.87.51,1.58v3.72h-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M363.62,535.79c.16.24.39.42.7.53s.73.16,1.26.16c.58,0,1.12-.1,1.61-.3v.77c-.49.22-1.09.32-1.8.32-1.02,0-1.78-.24-2.28-.73s-.76-1.24-.76-2.26c0-.94.22-1.66.67-2.17s1.13-.77,2.05-.77c.81,0,1.42.22,1.84.65.42.43.63,1,.63,1.7v1.07h-4.21c.03.44.13.78.28,1.03h0ZM363.72,532.59c-.26.31-.39.79-.39,1.46h3.34v-.47c0-.47-.13-.83-.38-1.08s-.65-.37-1.19-.37c-.66,0-1.11.15-1.37.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M374.53,529.06v6.76c0,.23.04.39.11.49s.2.14.38.14.36-.02.54-.07v.78c-.21.08-.47.12-.78.12-.4,0-.71-.11-.92-.32-.21-.21-.32-.55-.32-1.03v-6.86h.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M377.19,535.79c.16.24.39.42.7.53s.73.16,1.26.16c.58,0,1.12-.1,1.61-.3v.77c-.49.22-1.09.32-1.8.32-1.02,0-1.78-.24-2.28-.73s-.76-1.24-.76-2.26c0-.94.22-1.66.67-2.17s1.13-.77,2.05-.77c.81,0,1.42.22,1.84.65.42.43.63,1,.63,1.7v1.07h-4.21c.03.44.13.78.28,1.03h0ZM377.3,532.59c-.26.31-.39.79-.39,1.46h3.34v-.47c0-.47-.13-.83-.38-1.08s-.65-.37-1.19-.37c-.66,0-1.11.15-1.37.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M386.53,536.5c-.25.26-.55.46-.91.58-.36.12-.79.19-1.3.19-.58,0-1.05-.15-1.43-.44s-.57-.72-.57-1.27.18-.99.54-1.3c.36-.32.91-.47,1.66-.47h1.98v-.35c0-.32-.04-.57-.13-.75s-.25-.31-.48-.39-.57-.12-1.01-.12c-.66,0-1.3.1-1.9.31v-.82c.57-.22,1.24-.32,2.03-.32s1.42.17,1.82.5.6.86.6,1.59v3.72h-.83l-.07-.65h0ZM384.54,534.53c-.44,0-.76.08-.95.25-.2.16-.29.42-.29.77,0,.33.11.56.32.7.22.14.54.21.96.21.81,0,1.45-.28,1.92-.83v-1.1h-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M392.73,537.36c-.15-.09-.41-.13-.79-.13h-1.51c-.52,0-.91-.09-1.18-.27-.26-.18-.4-.44-.4-.79,0-.25.08-.47.23-.68.15-.2.37-.35.66-.44-.62-.3-.94-.86-.94-1.68,0-.7.2-1.22.61-1.55.41-.33,1.04-.49,1.9-.49.3,0,.62.04.98.12h2.05l-.04.67h-1.03c.34.3.52.71.52,1.25,0,.64-.19,1.13-.56,1.48-.37.34-.93.52-1.69.52-.17,0-.4-.02-.7-.06-.26.02-.5.09-.71.22s-.31.3-.31.5c0,.14.06.25.17.31.11.06.31.09.59.09h1.57c.57,0,1,.12,1.31.35.3.23.46.56.46,1,0,.54-.22.92-.67,1.15-.44.23-1.11.34-2.01.34-.95,0-1.71-.1-2.28-.3v-.82c.31.1.67.18,1.06.24.4.06.79.08,1.17.08.44,0,.78-.02,1.02-.05.24-.03.42-.09.54-.19s.18-.23.18-.43c0-.21-.07-.36-.22-.44h.02ZM392.49,534.35c.22-.18.33-.51.33-.97s-.11-.8-.34-1.01-.61-.31-1.16-.31-.92.1-1.16.31c-.24.2-.36.54-.36,1.01s.12.77.35.96.62.29,1.18.29.95-.09,1.17-.28h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M395.88,531.46v3.64c0,.47.12.82.35,1.04.24.22.6.34,1.1.34.35,0,.68-.06,1-.19s.58-.3.8-.53v-4.3h.98v5.69h-.89l-.06-.65c-.29.23-.62.42-1,.56s-.78.21-1.21.21c-.68,0-1.19-.19-1.54-.56-.35-.38-.52-.92-.52-1.64v-3.6h.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M402.82,535.79c.16.24.39.42.7.53s.73.16,1.26.16c.58,0,1.12-.1,1.61-.3v.77c-.49.22-1.09.32-1.8.32-1.02,0-1.78-.24-2.28-.73s-.76-1.24-.76-2.26c0-.94.22-1.66.67-2.17s1.13-.77,2.05-.77c.81,0,1.42.22,1.84.65.42.43.63,1,.63,1.7v1.07h-4.21c.03.44.13.78.28,1.03h0ZM402.93,532.59c-.26.31-.39.79-.39,1.46h3.34v-.47c0-.47-.13-.83-.38-1.08s-.65-.37-1.19-.37c-.66,0-1.11.15-1.37.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M408.54,529.3h.9l-.74,2.2h-.74l.59-2.2h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M413.39,535.22c-.09-.11-.21-.2-.38-.28-.16-.08-.42-.17-.77-.28l-.32-.11c-.4-.14-.71-.26-.94-.38s-.41-.28-.55-.48c-.14-.2-.2-.47-.2-.8,0-.51.18-.9.54-1.16.36-.26.92-.4,1.69-.4.59,0,1.13.08,1.61.23v.86c-.5-.17-.99-.25-1.45-.25-.51,0-.87.05-1.09.16-.21.1-.32.29-.32.55,0,.18.05.33.14.43.09.1.22.19.4.26.17.07.47.17.91.31.47.14.84.29,1.1.43s.45.32.58.53c.12.21.19.48.19.8,0,1.08-.75,1.62-2.26,1.62-.36,0-.71-.02-1.04-.07s-.62-.11-.84-.19v-.86c.54.19,1.13.29,1.75.29.52,0,.88-.05,1.09-.16s.31-.31.31-.61c0-.18-.04-.33-.13-.44h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M416.78,536.37v.78h-1.08v-.78h1.08ZM416.73,529.42h-.98v1.88l.07,4h.84l.07-4v-1.88Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M271.55,427.27h4.76c1.13,0,1.96.29,2.51.87.55.58.82,1.39.82,2.45,0,.74-.19,1.37-.56,1.88s-.89.87-1.57,1.07c.18.13.33.27.43.43.11.16.22.38.34.67l1.3,3.01h-1.8l-1.27-2.9c-.13-.29-.28-.49-.45-.6-.17-.11-.45-.17-.82-.17h-1.95v3.67h-1.75v-10.38ZM275.85,432.55c1.36,0,2.04-.65,2.04-1.96s-.63-1.95-1.88-1.95h-2.7v3.91h2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M281.4,436.8c-.72-.67-1.08-1.66-1.08-2.99,0-1.25.32-2.23.95-2.92s1.57-1.04,2.82-1.04c1.13,0,1.99.29,2.59.88s.9,1.38.9,2.37v1.42h-5.58c.09.73.35,1.24.79,1.52s1.13.43,2.08.43c.39,0,.78-.04,1.18-.11s.76-.17,1.07-.29v1.29c-.68.3-1.54.45-2.61.45-1.35,0-2.39-.33-3.11-1h0ZM286.03,433.37v-.53c0-.55-.15-.96-.45-1.25s-.78-.43-1.45-.43c-.79,0-1.35.17-1.67.51s-.47.91-.47,1.69h4.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M290.64,440.36c-.56-.08-1.04-.18-1.42-.31v-1.35c.41.14.89.25,1.45.32s1.1.11,1.63.11c.81,0,1.39-.04,1.72-.14.33-.09.5-.28.5-.57,0-.22-.09-.38-.27-.47s-.5-.14-.97-.14h-2.06c-.68,0-1.19-.13-1.54-.38s-.53-.61-.53-1.09c0-.33.1-.63.29-.89s.48-.46.85-.59c-.86-.42-1.29-1.16-1.29-2.24,0-.97.29-1.67.87-2.12.58-.45,1.46-.67,2.64-.67.43,0,.9.05,1.4.16h2.8l-.05,1.14h-1.29c.4.35.6.85.6,1.48,0,.84-.25,1.48-.75,1.94s-1.24.68-2.23.68c-.26,0-.57-.03-.95-.08-.34.03-.64.12-.88.27-.25.14-.37.33-.37.55,0,.16.06.28.19.35s.34.1.64.1h2.14c.76,0,1.35.16,1.76.49s.62.8.62,1.42c0,.74-.31,1.28-.94,1.61s-1.57.5-2.82.5c-.59,0-1.17-.04-1.73-.11v.03ZM293.96,433.8c.27-.23.41-.64.41-1.21s-.14-1-.42-1.25-.76-.38-1.45-.38-1.15.13-1.44.38c-.3.25-.44.67-.44,1.25s.14.96.43,1.2c.28.24.77.36,1.46.36s1.18-.11,1.46-.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M304.15,427.27h1.8l3.28,6.71,3.27-6.71h1.8v10.36h-1.74v-7.51l-2.8,5.73h-1.06l-2.82-5.73v7.51h-1.74v-10.36h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M316.01,433.82c0-2.65,1.32-3.97,3.97-3.97s3.99,1.33,3.99,3.97-1.33,3.97-3.99,3.97-3.97-1.33-3.97-3.97ZM321.7,435.74c.34-.39.51-1.02.51-1.92s-.17-1.51-.51-1.9c-.34-.39-.91-.58-1.71-.58s-1.36.19-1.7.58c-.34.39-.51,1.02-.51,1.9s.17,1.53.51,1.92.9.58,1.7.58,1.38-.19,1.71-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M325.68,430.01h1.61l.1.88c.36-.24.8-.45,1.3-.64s1-.33,1.5-.4v1.34c-.46.09-.96.22-1.5.39-.54.18-.96.36-1.26.56v5.5h-1.75v-7.63h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M331.59,430.01h1.61l.08.8c.36-.29.79-.52,1.27-.7.48-.18,1-.27,1.54-.27.99,0,1.71.23,2.16.69s.68,1.18.68,2.16v4.94h-1.74v-4.86c0-.59-.12-1-.37-1.24s-.7-.35-1.35-.35c-.4,0-.79.08-1.17.24s-.7.37-.96.63v5.58h-1.75v-7.63h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M341.64,436.8c-.72-.67-1.08-1.66-1.08-2.99,0-1.25.32-2.23.95-2.92s1.57-1.04,2.82-1.04c1.13,0,1.99.29,2.59.88s.9,1.38.9,2.37v1.42h-5.58c.09.73.35,1.24.79,1.52s1.13.43,2.08.43c.39,0,.78-.04,1.18-.11s.76-.17,1.07-.29v1.29c-.68.3-1.54.45-2.61.45-1.35,0-2.39-.33-3.11-1h0ZM346.28,433.37v-.53c0-.55-.15-.96-.45-1.25s-.78-.43-1.45-.43c-.79,0-1.35.17-1.67.51s-.47.91-.47,1.69h4.04Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M271.54,452.75c.15-.35.37-.68.64-.99.27-.31.61-.64,1.02-.99.39-.34.67-.6.84-.77s.29-.34.36-.51c.07-.17.11-.37.11-.62,0-.34-.1-.6-.3-.77-.2-.17-.52-.26-.96-.26-.47,0-.96.1-1.48.29v-.93c.23-.08.5-.14.81-.19s.6-.07.87-.07c.68,0,1.2.17,1.56.51s.54.81.54,1.4c0,.41-.1.76-.29,1.05-.2.3-.5.63-.91,1l-.16.14c-.36.32-.64.57-.83.76-.19.19-.35.4-.48.63h2.74v.81h-4.08v-.52.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M280.22,447.06h1.05v2.7h2.99v-2.7h1.05v6.22h-1.05v-2.7h-2.99v2.7h-1.05v-6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M286.54,448.7h.97l.06.53c.22-.14.48-.27.78-.39.3-.12.6-.2.9-.24v.8c-.28.05-.58.13-.9.24s-.57.22-.75.33v3.3h-1.05v-4.58h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M290.71,453.31c-.29-.04-.53-.1-.71-.17v-.89c.21.08.45.15.71.19s.52.07.77.07c.37,0,.63-.03.78-.1.15-.06.22-.19.22-.38,0-.17-.07-.29-.2-.37-.14-.08-.39-.18-.76-.29l-.29-.1c-.46-.15-.8-.33-1.01-.52s-.32-.47-.32-.84c0-.43.15-.76.46-.98s.79-.33,1.45-.33c.25,0,.5.02.74.06s.45.09.62.14v.88c-.17-.07-.37-.13-.58-.17-.22-.04-.42-.06-.61-.06-.35,0-.61.03-.77.09s-.24.18-.24.34c0,.15.06.26.18.33.12.07.36.17.72.29l.21.07c.37.12.66.23.87.35s.36.26.45.43c.09.17.14.39.14.66,0,.89-.64,1.34-1.92,1.34-.31,0-.61-.02-.9-.06v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M300.32,447.06h1.18l2.36,6.22h-1.08l-.62-1.6h-2.5l-.62,1.6h-1.09l2.38-6.22h-.01ZM301.98,450.86l-1.08-2.85-1.08,2.85h2.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M305.71,454.9c-.34-.04-.62-.11-.85-.18v-.81c.24.08.53.15.87.19.33.05.66.07.98.07.49,0,.83-.03,1.03-.08s.3-.17.3-.34c0-.14-.05-.23-.16-.29-.11-.05-.3-.08-.58-.08h-1.24c-.41,0-.71-.08-.93-.23-.21-.15-.32-.37-.32-.65,0-.2.06-.38.17-.54.12-.16.29-.28.51-.35-.52-.25-.77-.7-.77-1.34,0-.58.17-1,.52-1.27.35-.27.88-.4,1.58-.4.26,0,.54.03.84.1h1.68l-.03.69h-.77c.24.21.36.51.36.89,0,.5-.15.89-.45,1.16s-.75.41-1.34.41c-.15,0-.34-.02-.57-.05-.21.02-.38.07-.53.16s-.22.2-.22.33c0,.1.04.17.12.21.08.04.21.06.39.06h1.28c.46,0,.81.1,1.06.29.25.2.37.48.37.85,0,.44-.19.77-.56.97-.38.2-.94.3-1.69.3-.35,0-.7-.02-1.04-.07h0ZM307.69,450.97c.16-.14.25-.38.25-.73s-.08-.6-.25-.75-.46-.23-.87-.23-.69.08-.86.23c-.18.15-.27.4-.27.75s.08.57.26.72c.17.15.46.22.87.22s.71-.07.87-.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M309.42,450.98c0-1.59.79-2.38,2.38-2.38s2.39.79,2.39,2.38-.8,2.38-2.39,2.38-2.38-.79-2.38-2.38ZM312.83,452.13c.2-.23.3-.62.3-1.15s-.1-.91-.3-1.14c-.2-.23-.55-.35-1.03-.35s-.82.12-1.02.35c-.2.23-.3.61-.3,1.14s.1.92.3,1.15c.2.23.54.35,1.02.35s.83-.12,1.03-.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M235.42,417.25c-14.03,0-25.41,11.38-25.41,25.41s11.38,25.41,25.41,25.41,25.41-11.38,25.41-25.41-11.38-25.41-25.41-25.41h0ZM220.19,449.54c0-.97.25-1.88.75-2.69s1.17-1.44,1.99-1.87c1.91-.95,3.87-1.68,5.84-2.16,3.93-.95,8.11-.95,12.04,0,1.97.48,3.93,1.2,5.84,2.15.83.43,1.5,1.06,2,1.87s.75,1.72.75,2.69v4.79h-29.21v-4.79h0ZM234.8,425.11c1.96,0,3.59.68,4.98,2.07s2.07,3.02,2.07,4.98-.68,3.59-2.07,4.98-3.02,2.07-4.98,2.07-3.59-.68-4.98-2.07-2.07-3.02-2.07-4.98.68-3.59,2.07-4.98c1.39-1.39,3.02-2.07,4.98-2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M229.82,437.15c1.39,1.39,3.02,2.07,4.98,2.07s3.59-.68,4.98-2.07,2.07-3.02,2.07-4.98-.68-3.59-2.07-4.98c-1.39-1.39-3.02-2.07-4.98-2.07s-3.59.68-4.98,2.07-2.07,3.02-2.07,4.98.68,3.59,2.07,4.98ZM231.78,429.15c.83-.83,1.85-1.26,3.02-1.26s2.19.42,3.02,1.26c.83.83,1.26,1.85,1.26,3.02s-.42,2.19-1.26,3.02c-.83.83-1.85,1.26-3.02,1.26s-2.19-.42-3.02-1.26c-.83-.83-1.26-1.85-1.26-3.02s.42-2.19,1.26-3.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M249.4,449.54c0-.97-.25-1.88-.75-2.69s-1.17-1.44-2-1.87c-1.9-.95-3.87-1.68-5.84-2.15-3.93-.95-8.1-.95-12.04,0-1.97.48-3.93,1.2-5.84,2.16-.82.42-1.49,1.05-1.99,1.87-.5.81-.75,1.72-.75,2.69v4.79h29.21v-4.79h0ZM246.63,451.55h-23.66v-2.01c0-.44.11-.84.33-1.2.22-.36.51-.64.87-.84,1.74-.87,3.51-1.53,5.27-1.96,3.52-.87,7.2-.87,10.72,0,1.76.43,3.52,1.09,5.25,1.95.38.21.67.49.89.85.22.36.33.77.33,1.2v2.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M234.8,436.44c1.17,0,2.19-.42,3.02-1.26.83-.83,1.26-1.85,1.26-3.02s-.42-2.19-1.26-3.02c-.83-.83-1.85-1.26-3.02-1.26s-2.19.42-3.02,1.26-1.26,1.85-1.26,3.02.42,2.19,1.26,3.02c.83.83,1.85,1.26,3.02,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M245.41,447.49c-1.73-.86-3.49-1.52-5.25-1.95-3.52-.87-7.2-.87-10.72,0-1.76.43-3.53,1.09-5.27,1.96-.36.2-.65.48-.87.84s-.33.77-.33,1.2v2.01h23.66v-2.01c0-.44-.11-.84-.33-1.2-.22-.36-.51-.64-.89-.85h0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st40",
    x: 0.12,
    y: 84.32,
    width: 175.04,
    height: 427.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st35",
    x: 9.33,
    y: 96.14,
    width: 154.52,
    height: 28.67,
    rx: 12.05,
    ry: 12.05
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M30.81,106.42h1.09v2.8h3.1v-2.8h1.09v6.44h-1.09v-2.8h-3.1v2.8h-1.09v-6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M37.15,110.49c0-1.65.82-2.47,2.47-2.47s2.48.82,2.48,2.47-.83,2.47-2.48,2.47-2.47-.82-2.47-2.47ZM40.68,111.68c.21-.24.31-.64.31-1.19s-.1-.94-.31-1.18c-.21-.24-.56-.36-1.06-.36s-.84.12-1.05.36-.32.63-.32,1.18.1.95.32,1.19c.21.24.56.36,1.05.36s.85-.12,1.06-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M43.16,108.12h1l.05.5c.51-.4,1.06-.6,1.67-.6.33,0,.59.05.78.15s.34.26.45.46c.24-.19.5-.34.79-.45s.62-.17,1-.17c.55,0,.95.14,1.21.42s.39.71.39,1.29v3.13h-1.07v-3.02c0-.36-.08-.61-.23-.77-.15-.15-.4-.22-.75-.22-.23,0-.44.04-.65.12s-.38.2-.52.36c.03.13.05.29.05.49v3.04h-1.01v-3.01c0-.36-.06-.62-.19-.77s-.35-.23-.67-.23c-.42,0-.83.19-1.23.56v3.45h-1.07v-4.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M52.19,112.34c-.45-.41-.67-1.03-.67-1.86,0-.78.2-1.39.59-1.81.39-.43.98-.65,1.75-.65.7,0,1.24.18,1.61.55s.56.86.56,1.47v.88h-3.47c.05.45.22.77.49.94.27.18.7.27,1.29.27.24,0,.48-.02.73-.07s.47-.11.67-.18v.8c-.42.19-.96.28-1.62.28-.84,0-1.48-.21-1.93-.62ZM55.07,110.21v-.33c0-.34-.09-.6-.28-.77-.19-.18-.49-.27-.9-.27-.49,0-.84.11-1.03.32-.2.21-.29.56-.29,1.05h2.51,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M18.48,112.29h1.18v-2.35h2.35v2.35h1.18v-3.53l-2.35-1.76-2.35,1.76v3.53h-.01ZM17.7,113.08v-4.7l3.14-2.35,3.14,2.35v4.7h-2.74v-2.35h-.78v2.35h-2.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st35",
    x: 9.33,
    y: 131.14,
    width: 154.52,
    height: 28.67,
    rx: 12.05,
    ry: 12.05
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M32.48,142.28h-2.06v-.85h5.2v.85h-2.05v5.59h-1.09v-5.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M35.81,147.35c-.45-.41-.67-1.03-.67-1.86,0-.78.2-1.39.59-1.81.39-.43.98-.65,1.75-.65.7,0,1.24.18,1.61.55s.56.86.56,1.47v.88h-3.47c.05.45.22.77.49.94.27.18.7.27,1.29.27.24,0,.48-.02.73-.07s.47-.11.67-.18v.8c-.42.19-.96.28-1.62.28-.84,0-1.48-.21-1.93-.62h0ZM38.69,145.22v-.33c0-.34-.09-.6-.28-.77-.19-.18-.49-.27-.9-.27-.49,0-.84.11-1.03.32-.2.21-.29.56-.29,1.05h2.51,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M40.99,147.59c-.32-.25-.48-.61-.48-1.08s.16-.83.47-1.1c.32-.27.79-.4,1.43-.4h1.52v-.21c0-.23-.04-.42-.1-.55-.07-.13-.2-.22-.39-.28s-.45-.09-.8-.09c-.56,0-1.08.08-1.57.25v-.81c.23-.09.49-.16.8-.21.31-.05.63-.08.97-.08.71,0,1.24.14,1.6.43.36.29.54.74.54,1.36v3.05h-.93l-.07-.48c-.2.19-.44.34-.73.44s-.64.15-1.05.15c-.48,0-.88-.12-1.2-.38h-.01ZM43.32,147.03c.25-.11.45-.26.61-.45v-.83h-1.5c-.32,0-.55.06-.7.18-.14.12-.21.31-.21.57,0,.24.08.42.24.52.16.11.4.17.72.17s.59-.05.84-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M46.18,143.12h1l.05.5c.51-.4,1.06-.6,1.67-.6.33,0,.59.05.78.15.19.1.34.26.45.46.24-.19.5-.34.79-.45s.62-.17,1-.17c.55,0,.95.14,1.21.42s.39.71.39,1.29v3.13h-1.07v-3.02c0-.36-.08-.61-.23-.77-.15-.15-.4-.22-.75-.22-.23,0-.44.04-.65.12s-.38.2-.52.36c.03.13.05.29.05.49v3.04h-1.01v-3.01c0-.36-.06-.62-.19-.77s-.35-.23-.67-.23c-.42,0-.83.19-1.23.56v3.45h-1.07v-4.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M58.44,141.43h1.12l2.04,4.17,2.03-4.17h1.12v6.44h-1.08v-4.67l-1.74,3.56h-.66l-1.75-3.56v4.67h-1.08s0-6.44,0-6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M66.29,147.59c-.32-.25-.48-.61-.48-1.08s.16-.83.47-1.1c.32-.27.79-.4,1.43-.4h1.52v-.21c0-.23-.04-.42-.1-.55-.07-.13-.2-.22-.39-.28s-.45-.09-.8-.09c-.56,0-1.08.08-1.57.25v-.81c.23-.09.49-.16.8-.21.31-.05.63-.08.97-.08.71,0,1.24.14,1.6.43s.54.74.54,1.36v3.05h-.93l-.07-.48c-.2.19-.44.34-.73.44s-.64.15-1.05.15c-.48,0-.88-.12-1.2-.38h0ZM68.62,147.03c.25-.11.45-.26.61-.45v-.83h-1.5c-.32,0-.55.06-.7.18-.14.12-.21.31-.21.57,0,.24.08.42.24.52.16.11.4.17.72.17s.59-.05.84-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M71.48,143.12h1l.05.5c.23-.18.49-.32.79-.43.3-.11.62-.17.96-.17.61,0,1.06.14,1.34.43s.42.73.42,1.34v3.07h-1.08v-3.02c0-.37-.08-.62-.23-.77-.15-.15-.43-.22-.84-.22-.25,0-.49.05-.73.15s-.44.23-.59.39v3.47h-1.09v-4.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M77.39,147.59c-.32-.25-.48-.61-.48-1.08s.16-.83.47-1.1c.32-.27.79-.4,1.43-.4h1.52v-.21c0-.23-.04-.42-.1-.55-.07-.13-.2-.22-.39-.28s-.45-.09-.8-.09c-.56,0-1.08.08-1.57.25v-.81c.23-.09.49-.16.8-.21.31-.05.63-.08.97-.08.71,0,1.24.14,1.6.43s.54.74.54,1.36v3.05h-.93l-.07-.48c-.2.19-.44.34-.73.44s-.64.15-1.05.15c-.48,0-.88-.12-1.2-.38h0ZM79.72,147.03c.25-.11.45-.26.61-.45v-.83h-1.5c-.32,0-.55.06-.7.18-.14.12-.21.31-.21.57,0,.24.08.42.24.52.16.11.4.17.72.17s.59-.05.84-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M83.42,149.56c-.35-.05-.65-.11-.89-.19v-.84c.25.09.55.15.9.2s.68.07,1.01.07c.51,0,.86-.03,1.07-.08.21-.06.31-.18.31-.35,0-.14-.05-.24-.17-.3-.11-.06-.31-.08-.6-.08h-1.28c-.42,0-.74-.08-.96-.23-.22-.16-.33-.38-.33-.67,0-.21.06-.39.18-.56.12-.16.3-.29.53-.37-.53-.26-.8-.72-.8-1.39,0-.6.18-1.04.54-1.31.36-.28.91-.42,1.64-.42.27,0,.56.03.87.1h1.74l-.03.71h-.8c.25.22.37.53.37.92,0,.52-.15.92-.46,1.21-.31.28-.77.42-1.38.42-.16,0-.36-.02-.59-.05-.21.02-.4.07-.55.16s-.23.21-.23.35c0,.1.04.17.12.21.08.04.21.06.4.06h1.33c.47,0,.84.1,1.09.31.26.2.39.5.39.89,0,.46-.2.79-.58,1-.39.21-.98.31-1.76.31-.37,0-.72-.02-1.07-.07h-.01ZM85.48,145.48c.17-.14.25-.4.25-.76s-.09-.62-.26-.77-.47-.23-.9-.23-.71.08-.9.23c-.18.16-.27.42-.27.77s.09.6.27.75.48.23.9.23.74-.07.91-.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M88.29,147.35c-.45-.41-.67-1.03-.67-1.86,0-.78.2-1.39.59-1.81.39-.43.98-.65,1.75-.65.7,0,1.24.18,1.61.55s.56.86.56,1.47v.88h-3.47c.05.45.22.77.49.94.27.18.7.27,1.29.27.24,0,.48-.02.73-.07s.47-.11.67-.18v.8c-.42.19-.96.28-1.62.28-.84,0-1.48-.21-1.93-.62h0ZM91.17,145.22v-.33c0-.34-.09-.6-.28-.77-.19-.18-.49-.27-.9-.27-.49,0-.84.11-1.03.32-.2.21-.29.56-.29,1.05h2.51-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M93.19,143.12h1l.05.5c.51-.4,1.06-.6,1.67-.6.33,0,.59.05.78.15.19.1.34.26.45.46.24-.19.5-.34.79-.45s.62-.17,1-.17c.55,0,.95.14,1.21.42s.39.71.39,1.29v3.13h-1.07v-3.02c0-.36-.08-.61-.23-.77-.15-.15-.4-.22-.75-.22-.23,0-.44.04-.65.12s-.38.2-.52.36c.03.13.05.29.05.49v3.04h-1.01v-3.01c0-.36-.06-.62-.19-.77s-.35-.23-.67-.23c-.42,0-.83.19-1.23.56v3.45h-1.07v-4.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M102.22,147.35c-.45-.41-.67-1.03-.67-1.86,0-.78.2-1.39.59-1.81.39-.43.98-.65,1.75-.65.7,0,1.24.18,1.61.55s.56.86.56,1.47v.88h-3.47c.05.45.22.77.49.94.27.18.7.27,1.29.27.24,0,.48-.02.73-.07s.47-.11.67-.18v.8c-.42.19-.96.28-1.62.28-.84,0-1.48-.21-1.93-.62h0ZM105.1,145.22v-.33c0-.34-.09-.6-.28-.77-.19-.18-.49-.27-.9-.27-.49,0-.84.11-1.03.32-.2.21-.29.56-.29,1.05h2.51-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M107.12,143.12h1l.05.5c.23-.18.49-.32.79-.43.3-.11.62-.17.96-.17.61,0,1.06.14,1.34.43s.42.73.42,1.34v3.07h-1.08v-3.02c0-.37-.08-.62-.23-.77-.15-.15-.43-.22-.84-.22-.25,0-.49.05-.73.15s-.44.23-.59.39v3.47h-1.09v-4.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M113.58,147.57c-.25-.26-.38-.64-.38-1.12v-2.48h-.7v-.85h.7v-1.09l1.08-.33v1.42h1.26l-.07.85h-1.19v2.42c0,.27.06.47.19.58.12.11.33.17.62.17.18,0,.37-.03.57-.1v.77c-.26.11-.58.16-.95.16-.5,0-.88-.13-1.13-.4h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M17.48,146.46v-.46c0-.21.11-.38.32-.51.22-.13.5-.2.85-.2h.18c.06,0,.12,0,.17.02-.07.1-.12.21-.15.32s-.05.23-.05.35v.48h-1.32ZM19.24,146.46v-.48c0-.16.04-.3.13-.43.09-.13.21-.24.36-.34s.34-.17.56-.22.45-.07.71-.07.5.02.72.07.41.12.56.22.28.21.36.34.12.27.12.43v.48h-3.53.01ZM23.21,146.46v-.48c0-.13-.02-.25-.05-.36s-.08-.22-.14-.32c.05,0,.11-.02.17-.02h.17c.35,0,.64.06.85.19s.32.3.32.52v.46h-1.32ZM19.87,145.87h2.28c-.05-.1-.18-.18-.41-.26s-.47-.11-.74-.11-.52.04-.74.11-.36.16-.4.26h0ZM18.65,144.99c-.16,0-.3-.06-.42-.17s-.17-.25-.17-.42.06-.31.17-.42.25-.17.42-.17.31.06.42.17.17.25.17.42-.06.3-.17.42-.25.17-.42.17ZM23.36,144.99c-.16,0-.3-.06-.42-.17s-.17-.25-.17-.42.06-.31.17-.42.25-.17.42-.17.31.06.42.17.17.25.17.42-.06.3-.17.42-.25.17-.42.17ZM21.01,144.7c-.24,0-.45-.09-.62-.26s-.26-.38-.26-.62.09-.46.26-.63.38-.25.62-.25.46.08.63.25.25.38.25.63-.08.45-.25.62-.38.26-.63.26ZM21.01,144.11c.08,0,.15-.03.21-.08.06-.06.08-.13.08-.21s-.03-.15-.08-.21c-.06-.06-.13-.08-.21-.08s-.15.03-.21.08-.08.13-.08.21.03.15.08.21.13.08.21.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st35",
    x: 9.33,
    y: 166.14,
    width: 154.52,
    height: 28.67,
    rx: 12.05,
    ry: 12.05
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M30.81,176.43h.96l3.36,4.74v-4.74h1.08v6.44h-.96l-3.35-4.73v4.73h-1.09v-6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M37.95,182.35c-.45-.41-.67-1.03-.67-1.86,0-.78.2-1.39.59-1.81.39-.43.98-.65,1.75-.65.7,0,1.24.18,1.61.55s.56.86.56,1.47v.88h-3.47c.05.45.22.77.49.94.27.18.7.27,1.29.27.24,0,.48-.02.73-.07s.47-.11.67-.18v.8c-.42.19-.96.28-1.62.28-.84,0-1.48-.21-1.93-.62h0ZM40.83,180.22v-.33c0-.34-.09-.6-.28-.77-.19-.18-.49-.27-.9-.27-.49,0-.84.11-1.03.32-.2.21-.29.56-.29,1.05h2.51,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M42.65,178.13h1.09l.82,3.45.93-2.87v-.58h.83l1.03,3.45.82-3.45h1.08l-1.24,4.74h-1.03l-1.01-3.1-1.03,3.1h-1.04s-1.25-4.74-1.25-4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M50.56,182.9c-.3-.04-.55-.1-.74-.18v-.92c.22.09.46.15.73.2s.54.07.79.07c.39,0,.66-.03.81-.1s.23-.2.23-.39c0-.17-.07-.3-.21-.39-.14-.08-.4-.19-.79-.31l-.3-.1c-.48-.16-.83-.34-1.05-.54-.22-.2-.33-.49-.33-.88,0-.45.16-.79.48-1.02.32-.23.82-.34,1.5-.34.26,0,.51.02.76.06s.47.09.65.15v.91c-.18-.07-.38-.13-.6-.17-.22-.04-.44-.06-.63-.06-.37,0-.63.03-.8.1-.17.06-.25.18-.25.35,0,.15.06.27.19.35.13.08.38.17.75.29l.22.07c.39.12.69.24.9.37.21.12.37.27.47.45.1.18.15.41.15.69,0,.93-.66,1.39-1.99,1.39-.32,0-.63-.02-.93-.06h-.01Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st35",
    x: 9.33,
    y: 201.15,
    width: 154.52,
    height: 28.67,
    rx: 12.05,
    ry: 12.05
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M31.44,217.12c-.55-.57-.83-1.36-.83-2.37,0-1.09.27-1.93.8-2.52s1.34-.9,2.41-.9c.67,0,1.3.1,1.89.31v.95c-.57-.22-1.17-.33-1.81-.33-.78,0-1.34.21-1.68.62-.34.41-.51,1.04-.51,1.87,0,.76.18,1.33.55,1.72.36.39.92.58,1.67.58.66,0,1.26-.1,1.8-.31v.96c-.57.18-1.2.27-1.89.27-1.04,0-1.84-.29-2.39-.85h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M37.07,217.68c-.19-.19-.29-.51-.29-.94v-5.61h1.09v5.51c0,.18.03.31.09.38s.17.1.31.1c.16,0,.31-.02.46-.06v.79c-.22.08-.48.12-.77.12-.4,0-.7-.1-.89-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M39.73,217.5c-.3-.32-.46-.77-.46-1.38v-2.99h1.09v2.99c0,.35.09.61.26.78s.44.25.8.25c.26,0,.5-.05.73-.15.23-.1.43-.23.6-.4v-3.47h1.08v4.74h-.99l-.05-.49c-.5.39-1.09.59-1.76.59-.57,0-1-.16-1.3-.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M46.82,217.84c-.25-.09-.49-.23-.71-.44l-.06.47h-.94v-6.74h1.09v2.31c.41-.27.9-.41,1.49-.41.7,0,1.24.2,1.62.59.38.4.56,1.01.56,1.83s-.19,1.47-.56,1.89c-.38.42-.91.62-1.6.62-.34,0-.64-.04-.89-.14v.02ZM48.45,216.74c.21-.27.31-.7.31-1.28s-.11-.99-.33-1.23c-.22-.24-.56-.36-1.04-.36s-.89.14-1.2.41v2.38c.31.33.72.5,1.22.5s.83-.14,1.04-.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M50.93,211.13h1.09v2.46c.21-.17.46-.31.75-.41s.61-.15.96-.15c.6,0,1.04.14,1.33.43s.43.73.43,1.34v3.07h-1.08v-3.02c0-.37-.08-.62-.23-.77-.16-.15-.43-.22-.81-.22-.24,0-.48.05-.73.15s-.45.24-.61.4v3.45h-1.09v-6.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M56.51,215.5c0-1.65.82-2.47,2.47-2.47s2.48.82,2.48,2.47-.83,2.47-2.48,2.47-2.47-.82-2.47-2.47ZM60.04,216.69c.21-.24.31-.64.31-1.19s-.1-.94-.31-1.18c-.21-.24-.56-.36-1.06-.36s-.84.12-1.05.36-.32.63-.32,1.18.1.95.32,1.19c.21.24.56.36,1.05.36s.85-.12,1.06-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M62.92,217.5c-.3-.32-.46-.77-.46-1.38v-2.99h1.09v2.99c0,.35.09.61.26.78s.44.25.8.25c.26,0,.5-.05.73-.15.23-.1.43-.23.6-.4v-3.47h1.08v4.74h-.99l-.05-.49c-.5.39-1.09.59-1.76.59-.57,0-1-.16-1.3-.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M68.95,217.91c-.3-.04-.55-.1-.74-.18v-.92c.22.09.46.15.73.2.27.05.54.07.79.07.39,0,.66-.03.81-.1.15-.07.23-.2.23-.39,0-.17-.07-.3-.21-.39-.14-.08-.4-.19-.79-.31l-.3-.1c-.48-.16-.83-.34-1.05-.54s-.33-.49-.33-.88c0-.45.16-.79.48-1.02.32-.23.82-.34,1.5-.34.26,0,.51.02.76.06s.47.09.65.15v.91c-.18-.07-.38-.13-.6-.17s-.44-.06-.63-.06c-.37,0-.63.03-.8.1-.17.06-.25.18-.25.35,0,.15.06.27.19.35.13.08.38.17.75.29l.22.07c.39.12.69.24.9.37.21.12.37.27.47.45s.15.41.15.69c0,.93-.66,1.39-1.99,1.39-.32,0-.63-.02-.93-.06h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M73.41,217.35c-.45-.41-.67-1.03-.67-1.86,0-.78.2-1.39.59-1.81.39-.43.98-.65,1.75-.65.7,0,1.24.18,1.61.55s.56.86.56,1.47v.88h-3.47c.05.45.22.77.49.94.27.18.7.27,1.29.27.24,0,.48-.02.73-.07s.47-.11.67-.18v.8c-.42.19-.96.28-1.62.28-.84,0-1.48-.21-1.93-.62h0ZM76.29,215.22v-.33c0-.34-.09-.6-.28-.77-.19-.18-.49-.27-.9-.27-.49,0-.84.11-1.03.32-.2.21-.29.56-.29,1.05h2.51-.01Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st35",
    x: 9.33,
    y: 237.15,
    width: 154.52,
    height: 28.67,
    rx: 12.05,
    ry: 12.05
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M30.81,247.44h3.12c.63,0,1.1.15,1.41.44.31.3.47.72.47,1.27,0,.34-.07.63-.21.87s-.32.42-.56.54c.33.09.58.25.76.48.18.23.26.55.26.97,0,.62-.17,1.08-.5,1.4-.34.31-.83.46-1.48.46h-3.26v-6.44h0ZM33.78,250.19c.68,0,1.02-.31,1.02-.94,0-.35-.08-.6-.25-.75-.17-.16-.46-.24-.89-.24h-1.76v1.93h1.88ZM33.84,253.08c.39,0,.68-.08.85-.25.18-.17.26-.45.26-.85,0-.34-.09-.59-.27-.75s-.5-.24-.96-.24h-1.83v2.09h1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M36.92,251.51c0-1.65.82-2.47,2.47-2.47s2.48.82,2.48,2.47-.83,2.47-2.48,2.47-2.47-.82-2.47-2.47ZM40.45,252.7c.21-.24.31-.64.31-1.19s-.1-.94-.31-1.18c-.21-.24-.56-.36-1.06-.36s-.84.12-1.05.36-.32.63-.32,1.18.1.95.32,1.19c.21.24.56.36,1.05.36s.85-.12,1.06-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M42.48,251.51c0-1.65.82-2.47,2.47-2.47s2.48.82,2.48,2.47-.83,2.47-2.48,2.47-2.47-.82-2.47-2.47ZM46.01,252.7c.21-.24.31-.64.31-1.19s-.1-.94-.31-1.18c-.21-.24-.56-.36-1.06-.36s-.84.12-1.05.36-.32.63-.32,1.18.1.95.32,1.19c.21.24.56.36,1.05.36s.85-.12,1.06-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M48.82,253.58c-.25-.26-.38-.64-.38-1.12v-2.48h-.7v-.85h.7v-1.09l1.08-.33v1.42h1.26l-.07.85h-1.19v2.42c0,.27.06.47.19.58.12.11.33.17.62.17.18,0,.37-.03.57-.1v.77c-.26.11-.58.16-.95.16-.5,0-.88-.13-1.13-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M53.42,250.67l-2.25-3.23h1.26l1.64,2.39,1.64-2.39h1.27l-2.26,3.23,2.3,3.21h-1.28l-1.67-2.36-1.67,2.36h-1.28s2.3-3.21,2.3-3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M58.08,253.35c-.43-.42-.64-1.03-.64-1.84s.23-1.43.69-1.84,1.09-.62,1.9-.62c.32,0,.59.02.81.07s.44.12.66.22v.81c-.35-.17-.77-.26-1.26-.26-.57,0-.99.13-1.27.38s-.43.67-.43,1.25.13.99.4,1.25c.26.26.69.39,1.29.39.47,0,.9-.09,1.29-.27v.83c-.44.18-.95.27-1.54.27-.83,0-1.46-.21-1.89-.63h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M62.57,247.14h1.09v2.46c.21-.17.46-.31.75-.41s.61-.15.96-.15c.6,0,1.04.14,1.33.43s.43.73.43,1.34v3.07h-1.08v-3.02c0-.37-.08-.62-.23-.77-.16-.15-.43-.22-.81-.22-.24,0-.48.05-.73.15s-.45.24-.61.4v3.45h-1.09v-6.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M68.63,253.6c-.32-.25-.48-.61-.48-1.08s.16-.83.47-1.1c.32-.27.79-.4,1.43-.4h1.52v-.21c0-.23-.04-.42-.1-.55-.07-.13-.2-.22-.39-.28s-.45-.09-.8-.09c-.56,0-1.08.08-1.57.25v-.81c.23-.09.49-.16.8-.21.31-.05.63-.08.97-.08.71,0,1.24.14,1.6.43s.54.74.54,1.36v3.05h-.93l-.07-.48c-.2.19-.44.34-.73.44s-.64.15-1.05.15c-.48,0-.88-.12-1.2-.38h0ZM70.96,253.04c.25-.11.45-.26.61-.45v-.83h-1.5c-.32,0-.55.06-.7.18-.14.12-.21.31-.21.57,0,.24.08.42.24.52.16.11.4.17.72.17s.59-.05.84-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M73.82,249.14h1l.05.5c.23-.18.49-.32.79-.43.3-.11.62-.17.96-.17.61,0,1.06.14,1.34.43s.42.73.42,1.34v3.07h-1.08v-3.02c0-.37-.08-.62-.23-.77-.15-.15-.43-.22-.84-.22-.25,0-.49.05-.73.15s-.44.23-.59.39v3.47h-1.09v-4.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M80.44,255.57c-.35-.05-.65-.11-.89-.19v-.84c.25.09.55.15.9.2s.68.07,1.01.07c.51,0,.86-.03,1.07-.08.21-.06.31-.18.31-.35,0-.14-.05-.24-.17-.3-.11-.06-.31-.08-.6-.08h-1.28c-.42,0-.74-.08-.96-.23-.22-.16-.33-.38-.33-.67,0-.21.06-.39.18-.56.12-.16.3-.29.53-.37-.53-.26-.8-.72-.8-1.39,0-.6.18-1.04.54-1.31.36-.28.91-.42,1.64-.42.27,0,.56.03.87.1h1.74l-.03.71h-.8c.25.22.37.53.37.92,0,.52-.15.92-.46,1.21-.31.28-.77.42-1.38.42-.16,0-.36-.02-.59-.05-.21.02-.4.07-.55.16s-.23.21-.23.35c0,.1.04.17.12.21.08.04.21.06.4.06h1.33c.47,0,.84.1,1.09.31.26.2.39.5.39.89,0,.46-.2.79-.58,1-.39.21-.98.31-1.76.31-.37,0-.72-.02-1.07-.07h-.01ZM82.5,251.49c.17-.14.25-.4.25-.76s-.09-.62-.26-.77-.47-.23-.9-.23-.71.08-.9.23c-.18.16-.27.42-.27.77s.09.6.27.75.48.23.9.23.74-.07.91-.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M85.31,253.36c-.45-.41-.67-1.03-.67-1.86,0-.78.2-1.39.59-1.81.39-.43.98-.65,1.75-.65.7,0,1.24.18,1.61.55s.56.86.56,1.47v.88h-3.47c.05.45.22.77.49.94.27.18.7.27,1.29.27.24,0,.48-.02.73-.07s.47-.11.67-.18v.8c-.42.19-.96.28-1.62.28-.84,0-1.48-.21-1.93-.62h0ZM88.19,251.23v-.33c0-.34-.09-.6-.28-.77-.19-.18-.49-.27-.9-.27-.49,0-.84.11-1.03.32-.2.21-.29.56-.29,1.05h2.51-.01Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st35",
    x: 9.33,
    y: 273.16,
    width: 154.52,
    height: 28.67,
    rx: 12.05,
    ry: 12.05
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M33.08,283.44h1.22l2.44,6.44h-1.12l-.64-1.66h-2.59l-.64,1.66h-1.13s2.46-6.44,2.46-6.44ZM34.8,287.38l-1.12-2.95-1.12,2.95s2.24,0,2.24,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M37.92,289.43c-.38-.36-.56-.96-.56-1.78,0-.55.1-1.03.29-1.42.19-.39.46-.69.8-.9.34-.2.73-.3,1.17-.3.28,0,.53.03.76.1s.44.17.65.31v-2.31h1.09v6.74h-.93l-.07-.47c-.22.2-.46.35-.71.44s-.55.14-.89.14c-.69,0-1.22-.18-1.59-.54h0ZM41.03,288.66v-2.37c-.31-.28-.71-.42-1.18-.42s-.81.15-1.04.46-.35.75-.35,1.34c0,.55.1.94.32,1.16.21.22.55.33,1.03.33s.89-.17,1.22-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M43.38,285.14h1l.05.5c.51-.4,1.06-.6,1.67-.6.33,0,.59.05.78.15s.34.26.45.46c.24-.19.5-.34.79-.45.29-.11.62-.17,1-.17.55,0,.95.14,1.21.42s.39.71.39,1.29v3.13h-1.07v-3.02c0-.36-.08-.61-.23-.77-.15-.15-.4-.22-.75-.22-.23,0-.44.04-.65.12s-.38.2-.52.36c.03.13.05.29.05.49v3.04h-1.01v-3.01c0-.36-.06-.62-.19-.77s-.35-.23-.67-.23c-.42,0-.83.19-1.23.56v3.45h-1.07v-4.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M52.66,285.97h-.72l.1-.83h1.71v4.74h-1.09s0-3.91,0-3.91ZM52.57,283.25h1.19v.9h-1.19v-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M55.02,285.14h1l.05.5c.23-.18.49-.32.79-.43s.62-.17.96-.17c.61,0,1.06.14,1.34.43.28.29.42.73.42,1.34v3.07h-1.08v-3.02c0-.37-.08-.62-.23-.77-.15-.15-.43-.22-.84-.22-.25,0-.49.05-.73.15s-.44.23-.59.39v3.47h-1.09v-4.74h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M17.48,288.48v-.46c0-.21.11-.38.32-.51.22-.13.5-.2.85-.2h.18c.06,0,.12,0,.17.02-.07.1-.12.21-.15.32s-.05.23-.05.35v.48h-1.32ZM19.24,288.48v-.48c0-.16.04-.3.13-.43.09-.13.21-.24.36-.34s.34-.17.56-.22.45-.07.71-.07.5.02.72.07.41.12.56.22.28.21.36.34.12.27.12.43v.48h-3.53.01ZM23.21,288.48v-.48c0-.13-.02-.25-.05-.36s-.08-.22-.14-.32c.05,0,.11-.02.17-.02h.17c.35,0,.64.06.85.19s.32.3.32.52v.46h-1.32ZM19.87,287.89h2.28c-.05-.1-.18-.18-.41-.26s-.47-.11-.74-.11-.52.04-.74.11-.36.16-.4.26h0ZM18.65,287.01c-.16,0-.3-.06-.42-.17s-.17-.25-.17-.42.06-.31.17-.42.25-.17.42-.17.31.06.42.17.17.25.17.42-.06.3-.17.42-.25.17-.42.17ZM23.36,287.01c-.16,0-.3-.06-.42-.17s-.17-.25-.17-.42.06-.31.17-.42.25-.17.42-.17.31.06.42.17.17.25.17.42-.06.3-.17.42-.25.17-.42.17ZM21.01,286.71c-.24,0-.45-.09-.62-.26s-.26-.38-.26-.62.09-.46.26-.63.38-.25.62-.25.46.08.63.25.25.38.25.63-.08.45-.25.62c-.17.17-.38.26-.63.26ZM21.01,286.12c.08,0,.15-.03.21-.08.06-.06.08-.13.08-.21s-.03-.15-.08-.21c-.06-.06-.13-.08-.21-.08s-.15.03-.21.08-.08.13-.08.21.03.15.08.21.13.08.21.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M18.95,182.71c-.19,0-.34-.07-.48-.2-.13-.13-.2-.29-.2-.48v-5.39l.56.56.56-.56.56.56.56-.56.56.56.56-.56.56.56.56-.56.56.56.56-.56.56.56.56-.56v5.39c0,.19-.07.34-.2.48-.13.13-.29.2-.48.2h-5.39.03ZM18.95,182.04h2.36v-2.02h-2.36v2.02ZM21.98,182.04h2.36v-.67h-2.36v.67ZM21.98,180.69h2.36v-.67h-2.36v.67ZM18.95,179.34h5.39v-1.01h-5.39v1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M22.12,218.13c-.48,0-.93-.09-1.36-.27s-.79-.43-1.1-.74-.56-.68-.74-1.1-.27-.88-.27-1.36.09-.93.27-1.36.43-.79.74-1.1.68-.56,1.1-.74.88-.27,1.36-.27.93.09,1.36.27.79.43,1.1.74.56.68.74,1.1.27.88.27,1.36-.09.93-.27,1.36-.43.79-.74,1.1-.68.56-1.1.74-.88.27-1.36.27ZM23.86,213.79l.47-.16.14-.47c-.19-.28-.41-.52-.67-.72s-.55-.35-.86-.45l-.47.33v.49l1.39.97h0ZM20.38,213.79l1.39-.97v-.49l-.47-.33c-.31.1-.6.25-.86.45s-.48.44-.67.72l.14.47.47.16h0ZM20.02,216.46l.4-.03.26-.47-.5-1.51-.49-.17-.35.26c0,.38.05.72.16,1.03s.28.61.52.9h0ZM22.12,217.44c.15,0,.3,0,.44-.03s.29-.06.43-.1l.24-.52-.23-.38h-1.77l-.23.38.24.52c.14.05.28.08.43.1s.29.03.44.03h0ZM21.34,215.7h1.56l.49-1.39-1.27-.89-1.25.89s.47,1.39.47,1.39ZM24.22,216.46c.24-.29.42-.59.52-.9s.16-.65.16-1.03l-.35-.24-.49.16-.5,1.51.26.47.4.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M20.08,249.66c.24,0,.47.04.69.13s.42.21.6.38l3.56,3.4h.22c.11,0,.19-.04.27-.11s.11-.16.11-.27c0-.05,0-.1-.01-.16s-.04-.11-.1-.17l-1.7-1.7-.66-1.99-.69.17c-.24.06-.45.02-.64-.13s-.29-.34-.29-.59v-.78l-.26-.13-1.43,1.92h0v.02h.37-.04ZM20.08,250.41h-.43s.04.08.07.12.06.07.1.1l3.02,2.75c.07.07.15.12.23.15s.18.05.27.05h.5l-2.99-2.86c-.11-.11-.23-.18-.36-.23-.13-.05-.27-.07-.41-.07h0ZM23.34,254.32c-.19,0-.36-.03-.53-.1s-.32-.16-.47-.29l-3.03-2.75c-.29-.26-.45-.58-.48-.96-.03-.38.06-.72.29-1.03l1.43-1.92c.11-.14.25-.24.42-.28s.35-.03.51.06l.26.13c.13.07.23.16.3.28s.11.25.11.39v.78l.69-.18c.19-.05.37-.03.54.07s.29.23.35.41l.61,1.82,1.58,1.58c.12.12.21.26.26.4.05.14.07.29.07.46,0,.31-.11.57-.33.79-.22.22-.48.33-.79.33h-1.81.02Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M229.98,110.52h-3.71v-1.53h9.36v1.53h-3.69v10.06h-1.96v-10.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M235.98,119.64c-.8-.74-1.21-1.86-1.21-3.35,0-1.4.35-2.49,1.06-3.27.71-.77,1.76-1.16,3.15-1.16,1.26,0,2.23.33,2.9.99.67.66,1.01,1.54,1.01,2.65v1.58h-6.25c.1.82.39,1.38.88,1.7s1.27.48,2.32.48c.43,0,.87-.04,1.32-.13.45-.08.85-.19,1.2-.32v1.44c-.76.34-1.73.5-2.92.5-1.51,0-2.67-.37-3.47-1.12h.01ZM241.16,115.81v-.59c0-.61-.17-1.08-.5-1.4-.34-.32-.88-.48-1.62-.48-.89,0-1.51.19-1.86.58-.35.38-.53,1.01-.53,1.89h4.52-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M245.3,120.08c-.58-.45-.86-1.09-.86-1.94s.29-1.5.85-1.99,1.42-.73,2.56-.73h2.74v-.38c0-.42-.06-.75-.19-.98s-.36-.41-.69-.51-.82-.16-1.44-.16c-1.01,0-1.95.15-2.83.45v-1.46c.41-.16.89-.28,1.44-.38s1.13-.14,1.75-.14c1.27,0,2.23.26,2.87.77.64.52.96,1.33.96,2.45v5.49h-1.67l-.13-.86c-.36.35-.8.61-1.31.78-.52.17-1.15.26-1.89.26-.86,0-1.58-.23-2.16-.68h0ZM249.5,119.07c.44-.19.81-.46,1.1-.81v-1.49h-2.7c-.58,0-.99.11-1.25.32-.26.22-.39.56-.39,1.03,0,.43.14.75.43.94.29.2.72.3,1.3.3s1.07-.1,1.51-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M254.64,112.05h1.8l.09.9c.91-.72,1.91-1.08,3.01-1.08.59,0,1.06.09,1.4.28.35.19.62.47.81.84.43-.35.91-.62,1.43-.82s1.12-.3,1.79-.3c.98,0,1.71.25,2.18.76.47.5.7,1.28.7,2.32v5.63h-1.93v-5.44c0-.65-.14-1.11-.41-1.38s-.73-.4-1.35-.4c-.41,0-.8.07-1.17.22s-.68.36-.94.65c.06.23.09.52.09.88v5.47h-1.82v-5.42c0-.65-.11-1.11-.33-1.39s-.63-.41-1.21-.41c-.76,0-1.49.34-2.21,1.01v6.21h-1.93v-8.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M276.71,108.99h2.02l3.67,7.51,3.65-7.51h2.02v11.59h-1.94v-8.41l-3.13,6.41h-1.19l-3.15-6.41v8.41h-1.94v-11.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M290.84,120.08c-.58-.45-.86-1.09-.86-1.94s.29-1.5.85-1.99,1.42-.73,2.56-.73h2.74v-.38c0-.42-.06-.75-.19-.98s-.36-.41-.69-.51-.82-.16-1.44-.16c-1.01,0-1.95.15-2.83.45v-1.46c.41-.16.89-.28,1.44-.38s1.13-.14,1.75-.14c1.27,0,2.23.26,2.87.77.64.52.96,1.33.96,2.45v5.49h-1.67l-.13-.86c-.36.35-.8.61-1.31.78-.52.17-1.15.26-1.89.26-.86,0-1.58-.23-2.16-.68h0ZM295.04,119.07c.44-.19.81-.46,1.1-.81v-1.49h-2.7c-.58,0-.99.11-1.25.32-.26.22-.39.56-.39,1.03,0,.43.14.75.43.94.29.2.72.3,1.3.3s1.07-.1,1.51-.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M300.18,112.05h1.8l.09.9c.41-.32.88-.58,1.42-.78s1.12-.3,1.73-.3c1.1,0,1.91.26,2.41.77.5.52.76,1.32.76,2.41v5.53h-1.94v-5.44c0-.66-.14-1.12-.41-1.39-.28-.26-.78-.4-1.51-.4-.44,0-.88.09-1.31.27s-.78.41-1.07.7v6.25h-1.96v-8.53h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M310.82,120.08c-.58-.45-.86-1.09-.86-1.94s.29-1.5.85-1.99,1.42-.73,2.56-.73h2.74v-.38c0-.42-.06-.75-.19-.98s-.36-.41-.69-.51-.82-.16-1.44-.16c-1.01,0-1.95.15-2.83.45v-1.46c.41-.16.89-.28,1.44-.38s1.13-.14,1.75-.14c1.27,0,2.23.26,2.87.77.64.52.96,1.33.96,2.45v5.49h-1.67l-.13-.86c-.36.35-.8.61-1.31.78-.52.17-1.15.26-1.89.26-.86,0-1.58-.23-2.16-.68h0ZM315.02,119.07c.44-.19.81-.46,1.1-.81v-1.49h-2.7c-.58,0-.99.11-1.25.32-.26.22-.39.56-.39,1.03,0,.43.14.75.43.94.29.2.72.3,1.3.3s1.07-.1,1.51-.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M321.68,123.62c-.63-.08-1.16-.2-1.59-.34v-1.51c.46.16,1,.28,1.62.36s1.23.13,1.82.13c.91,0,1.55-.05,1.93-.15s.56-.31.56-.64c0-.25-.1-.43-.3-.53-.2-.1-.56-.15-1.09-.15h-2.3c-.76,0-1.33-.14-1.73-.42s-.59-.69-.59-1.21c0-.37.11-.71.32-1,.22-.29.53-.51.95-.66-.96-.47-1.44-1.3-1.44-2.5,0-1.08.32-1.87.97-2.37s1.63-.75,2.95-.75c.48,0,1,.06,1.57.18h3.13l-.05,1.28h-1.44c.44.4.67.95.67,1.66,0,.94-.28,1.66-.84,2.17-.56.51-1.39.77-2.49.77-.29,0-.64-.03-1.06-.09-.38.04-.71.13-.99.3-.28.16-.41.37-.41.62,0,.18.07.31.22.39.14.08.38.12.72.12h2.39c.85,0,1.51.18,1.97.55s.69.9.69,1.59c0,.83-.35,1.43-1.05,1.8s-1.75.56-3.16.56c-.66,0-1.3-.04-1.94-.13v-.03ZM325.39,116.29c.31-.26.46-.71.46-1.36s-.16-1.11-.47-1.4-.85-.42-1.62-.42-1.28.14-1.61.42-.5.75-.5,1.4.16,1.07.48,1.34.86.41,1.63.41,1.32-.13,1.63-.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M330.44,119.64c-.8-.74-1.21-1.86-1.21-3.35,0-1.4.35-2.49,1.06-3.27.71-.77,1.76-1.16,3.15-1.16,1.26,0,2.23.33,2.9.99.67.66,1.01,1.54,1.01,2.65v1.58h-6.25c.1.82.39,1.38.88,1.7s1.27.48,2.32.48c.43,0,.87-.04,1.32-.13.45-.08.85-.19,1.2-.32v1.44c-.76.34-1.73.5-2.92.5-1.51,0-2.67-.37-3.47-1.12h0ZM335.62,115.81v-.59c0-.61-.17-1.08-.5-1.4-.34-.32-.88-.48-1.62-.48-.89,0-1.51.19-1.86.58-.35.38-.53,1.01-.53,1.89h4.52-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M339.26,112.05h1.8l.09.9c.91-.72,1.91-1.08,3.01-1.08.59,0,1.06.09,1.4.28.35.19.62.47.81.84.43-.35.91-.62,1.43-.82s1.12-.3,1.79-.3c.98,0,1.71.25,2.18.76.47.5.7,1.28.7,2.32v5.63h-1.93v-5.44c0-.65-.14-1.11-.41-1.38s-.73-.4-1.35-.4c-.41,0-.8.07-1.17.22s-.68.36-.94.65c.06.23.09.52.09.88v5.47h-1.82v-5.42c0-.65-.11-1.11-.33-1.39s-.63-.41-1.21-.41c-.76,0-1.49.34-2.21,1.01v6.21h-1.93s0-8.53,0-8.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M355.51,119.64c-.8-.74-1.21-1.86-1.21-3.35,0-1.4.35-2.49,1.06-3.27.71-.77,1.76-1.16,3.15-1.16,1.26,0,2.23.33,2.9.99.67.66,1.01,1.54,1.01,2.65v1.58h-6.25c.1.82.39,1.38.88,1.7s1.27.48,2.32.48c.43,0,.87-.04,1.32-.13.45-.08.85-.19,1.2-.32v1.44c-.76.34-1.73.5-2.92.5-1.51,0-2.67-.37-3.47-1.12h0ZM360.7,115.81v-.59c0-.61-.17-1.08-.5-1.4-.34-.32-.88-.48-1.62-.48-.89,0-1.51.19-1.86.58-.35.38-.53,1.01-.53,1.89h4.52-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M364.33,112.05h1.8l.09.9c.41-.32.88-.58,1.42-.78s1.12-.3,1.73-.3c1.1,0,1.91.26,2.41.77.5.52.76,1.32.76,2.41v5.53h-1.94v-5.44c0-.66-.14-1.12-.41-1.39-.28-.26-.78-.4-1.51-.4-.44,0-.88.09-1.31.27s-.78.41-1.07.7v6.25h-1.96v-8.53h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M375.96,120.05c-.46-.47-.68-1.14-.68-2.01v-4.46h-1.26v-1.53h1.26v-1.96l1.94-.59v2.56h2.27l-.13,1.53h-2.14v4.36c0,.49.11.84.33,1.04.22.2.6.3,1.12.3.32,0,.67-.06,1.03-.18v1.39c-.47.19-1.04.29-1.71.29-.9,0-1.58-.24-2.03-.71v-.03Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M454.29,336.99h-244.33c-6.99,0-12.71-5.72-12.71-12.71v-170.57c0-6.99,5.72-12.71,12.71-12.71h244.33c6.99,0,12.71,5.72,12.71,12.71v170.57c0,6.99-5.72,12.71-12.71,12.71Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M214.05,161.5c-.46-.4-.69-.99-.69-1.76v-3.84h1.03v3.81c0,.51.14.89.42,1.14.28.26.68.38,1.21.38s.92-.13,1.2-.38c.28-.26.42-.64.42-1.14v-3.81h1.02v3.84c0,.77-.23,1.35-.69,1.76s-1.11.61-1.95.61-1.5-.2-1.96-.61h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M220.6,156.81l-.99.17v-.86l2.01-.31v6.21h-1.02v-5.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M222.64,161.5c.15-.35.36-.67.63-.97s.6-.62,1.01-.97c.39-.34.66-.59.83-.75s.28-.33.35-.5c.07-.16.1-.37.1-.61,0-.34-.1-.59-.29-.75-.2-.17-.51-.25-.94-.25-.46,0-.95.09-1.45.28v-.91c.23-.08.49-.14.79-.19.3-.05.59-.07.86-.07.67,0,1.18.17,1.54.5.35.33.53.79.53,1.38,0,.4-.1.74-.29,1.03-.19.29-.49.62-.9.99l-.16.14c-.35.31-.62.56-.81.75s-.34.39-.47.62h2.69v.8h-4.01v-.51h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M227.97,155.8h.9l-.63,1.85h-.78l.5-1.85h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M230.17,162.04c-.28-.04-.52-.1-.7-.17v-.87c.21.08.44.15.7.19.26.04.51.07.75.07.37,0,.62-.03.77-.1.15-.06.22-.19.22-.37,0-.16-.07-.29-.2-.37s-.38-.18-.75-.29l-.28-.1c-.46-.15-.79-.32-1-.51s-.31-.46-.31-.83c0-.42.15-.74.46-.96.3-.22.78-.33,1.42-.33.25,0,.49.02.73.06.24.04.44.09.61.14v.86c-.17-.07-.36-.12-.57-.16-.21-.04-.41-.06-.6-.06-.35,0-.6.03-.76.09-.16.06-.24.17-.24.34,0,.15.06.25.18.33.12.07.36.17.71.28l.21.07c.37.11.65.23.85.35.2.12.35.26.44.43s.14.38.14.65c0,.88-.63,1.32-1.89,1.32-.3,0-.6-.02-.88-.06h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M238,161.34c-.48-.51-.72-1.3-.72-2.37s.24-1.9.71-2.41c.47-.51,1.2-.76,2.18-.76s1.71.25,2.18.76c.47.51.71,1.31.71,2.41s-.24,1.86-.72,2.37-1.2.76-2.18.76-1.7-.25-2.18-.76h.02ZM241.59,160.7c.3-.35.45-.93.45-1.73s-.15-1.42-.44-1.76c-.29-.35-.77-.52-1.42-.52s-1.12.17-1.41.52c-.29.35-.44.94-.44,1.76s.15,1.37.45,1.72c.3.36.77.54,1.4.54s1.12-.18,1.41-.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M244.09,157.51h.95l.05.47c.21-.17.46-.31.75-.41s.59-.16.91-.16c.58,0,1.01.14,1.27.41s.4.7.4,1.27v2.91h-1.02v-2.87c0-.35-.07-.59-.22-.73s-.41-.21-.8-.21c-.23,0-.46.05-.69.14-.22.09-.41.22-.56.37v3.29h-1.03v-4.5.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M249.85,161.83c-.18-.18-.28-.48-.28-.89v-5.32h1.03v5.23c0,.17.03.29.09.36s.16.1.29.1c.15,0,.3-.02.44-.06v.75c-.21.08-.45.11-.73.11-.38,0-.66-.09-.84-.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M252.48,158.3h-.68l.1-.79h1.62v4.5h-1.03v-3.71h-.01ZM252.4,155.72h1.13v.85h-1.13v-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M254.72,157.51h.95l.05.47c.21-.17.46-.31.75-.41s.59-.16.91-.16c.58,0,1.01.14,1.27.41s.4.7.4,1.27v2.91h-1.02v-2.87c0-.35-.07-.59-.22-.73s-.41-.21-.8-.21c-.23,0-.46.05-.69.14-.22.09-.41.22-.56.37v3.29h-1.03v-4.5.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M260.65,161.52c-.42-.39-.64-.98-.64-1.76s.19-1.31.56-1.72.93-.61,1.66-.61c.66,0,1.17.17,1.53.52.35.35.53.81.53,1.4v.83h-3.29c.05.43.21.73.46.9.26.17.67.25,1.22.25.23,0,.46-.02.7-.07.24-.04.45-.1.63-.17v.76c-.4.18-.91.27-1.54.27-.8,0-1.41-.2-1.83-.59h.01ZM263.39,159.5v-.31c0-.32-.09-.57-.27-.74s-.46-.25-.85-.25c-.47,0-.8.1-.98.3-.19.2-.28.53-.28,1h2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M268.81,155.9h2.81c.66,0,1.16.17,1.48.51s.48.82.48,1.44c0,.44-.11.81-.33,1.11s-.53.51-.93.63c.11.08.19.16.26.25.06.09.13.22.2.39l.77,1.77h-1.06l-.75-1.71c-.08-.17-.16-.29-.27-.36s-.26-.1-.48-.1h-1.15v2.16h-1.03v-6.11.02ZM271.35,159.01c.8,0,1.21-.39,1.21-1.16s-.37-1.15-1.11-1.15h-1.59v2.31h1.5-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M274.62,161.52c-.42-.39-.64-.98-.64-1.76s.19-1.31.56-1.72.93-.61,1.66-.61c.66,0,1.17.17,1.53.52.35.35.53.81.53,1.4v.83h-3.29c.05.43.21.73.46.9.26.17.67.25,1.22.25.23,0,.46-.02.7-.07.24-.04.45-.1.63-.17v.76c-.4.18-.91.27-1.54.27-.8,0-1.41-.2-1.83-.59h.01ZM277.35,159.5v-.31c0-.32-.09-.57-.27-.74s-.46-.25-.85-.25c-.47,0-.8.1-.98.3-.19.2-.28.53-.28,1h2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M278.61,157.51h1.07l1.26,3.49,1.26-3.49h1.06l-1.77,4.5h-1.12l-1.77-4.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M284.25,161.52c-.42-.39-.64-.98-.64-1.76s.19-1.31.56-1.72.93-.61,1.66-.61c.66,0,1.17.17,1.53.52.35.35.53.81.53,1.4v.83h-3.29c.05.43.21.73.46.9.26.17.67.25,1.22.25.23,0,.46-.02.7-.07.24-.04.45-.1.63-.17v.76c-.4.18-.91.27-1.54.27-.8,0-1.41-.2-1.83-.59h.01ZM286.99,159.5v-.31c0-.32-.09-.57-.27-.74s-.46-.25-.85-.25c-.47,0-.8.1-.98.3-.19.2-.28.53-.28,1h2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M288.9,157.51h.95l.05.47c.21-.17.46-.31.75-.41s.59-.16.91-.16c.58,0,1.01.14,1.27.41s.4.7.4,1.27v2.91h-1.02v-2.87c0-.35-.07-.59-.22-.73s-.41-.21-.8-.21c-.23,0-.46.05-.69.14-.22.09-.41.22-.56.37v3.29h-1.03v-4.5.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M294.77,161.65c-.29-.3-.43-.74-.43-1.3v-2.84h1.03v2.84c0,.34.08.58.25.74.16.16.42.24.76.24.25,0,.48-.05.69-.14s.4-.22.57-.38v-3.29h1.02v4.5h-.94l-.05-.46c-.47.37-1.03.56-1.67.56-.54,0-.95-.15-1.24-.45v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M300.32,161.52c-.42-.39-.64-.98-.64-1.76s.19-1.31.56-1.72.93-.61,1.66-.61c.66,0,1.17.17,1.53.52.35.35.53.81.53,1.4v.83h-3.29c.05.43.21.73.46.9.26.17.67.25,1.22.25.23,0,.46-.02.7-.07.24-.04.45-.1.63-.17v.76c-.4.18-.91.27-1.54.27-.8,0-1.41-.2-1.83-.59h.01ZM303.05,159.5v-.31c0-.32-.09-.57-.27-.74s-.46-.25-.85-.25c-.47,0-.8.1-.98.3-.19.2-.28.53-.28,1h2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M213.31,176.74h.31c.23,0,.41-.07.53-.21s.18-.33.18-.57v-1.71h-.89v-1.4h.89v-1.2c0-.7.22-1.26.67-1.68.44-.42,1.03-.63,1.75-.63.66,0,1.21.1,1.65.3v1.25c-.13-.05-.29-.1-.5-.13-.21-.04-.4-.05-.59-.05-.4,0-.7.09-.89.26s-.28.44-.28.8v1.09h2.23l-.07,1.4h-2.16v1.61c0,.22-.02.39-.07.52s-.13.25-.26.35h3.12v1.4h-5.63v-1.4h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M219.95,177.27c.21-.47.5-.89.85-1.28s.82-.84,1.4-1.36l.35-.31c.42-.39.72-.67.89-.85.17-.18.3-.37.38-.56s.11-.44.11-.73c0-.41-.13-.72-.4-.93-.27-.21-.66-.32-1.18-.32-.69,0-1.38.14-2.08.42v-1.6c.33-.12.72-.21,1.18-.28.45-.07.89-.1,1.31-.1.99,0,1.74.24,2.25.73.52.49.77,1.17.77,2.04,0,.55-.13,1.03-.39,1.44s-.65.85-1.18,1.3l-.21.19c-.4.35-.74.65-1,.91-.26.26-.49.52-.67.79h3.54v1.4h-5.9v-.87l-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M228.05,178.16c-.51-.08-.91-.18-1.21-.3v-1.59c.69.3,1.46.44,2.31.44.65,0,1.13-.09,1.43-.28.3-.18.45-.5.45-.95,0-.38-.13-.65-.4-.81s-.66-.25-1.19-.25h-1.36l.13-1.33h1.13c.52,0,.9-.09,1.14-.26s.36-.45.36-.83-.14-.66-.42-.84-.71-.28-1.3-.28c-.38,0-.75.04-1.14.11s-.72.18-1.02.32v-1.55c.3-.13.67-.23,1.12-.31s.9-.12,1.34-.12c1.05,0,1.85.22,2.41.66s.84,1.02.84,1.75c0,.45-.1.85-.3,1.22-.2.36-.5.62-.88.79.46.13.8.37,1.02.71.22.34.34.74.34,1.22,0,.86-.31,1.51-.93,1.94-.62.44-1.46.65-2.53.65-.4,0-.86-.04-1.37-.12h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M237.72,170.88h-3.97v-1.4h5.96v1.12l-3.19,7.54h-1.88l3.08-7.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M241.43,177.44c-.56-.56-.85-1.41-.85-2.56v-1.85c0-.72.15-1.35.46-1.91.31-.56.75-.99,1.33-1.3s1.25-.46,2.02-.46c.44,0,.82.03,1.16.08s.65.13.97.24v1.56c-.56-.22-1.23-.34-2-.34-.73,0-1.28.16-1.66.47s-.57.74-.57,1.29v.42c.28-.2.61-.35.99-.46s.74-.16,1.08-.16c1.01,0,1.77.25,2.26.74s.74,1.21.74,2.14-.28,1.62-.84,2.15-1.4.79-2.53.79-1.99-.28-2.55-.84h-.01ZM245.29,176.52c.3-.27.44-.65.44-1.12,0-.52-.13-.91-.39-1.17s-.7-.39-1.32-.39c-.29,0-.58.05-.89.16s-.59.25-.85.42v.82c0,1.13.57,1.69,1.71,1.69.56,0,.99-.14,1.29-.41h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M248.35,176.78h1.48v1.36h-1.48v-1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M251.75,177.33c-.61-.77-.92-1.91-.92-3.41s.31-2.64.92-3.41,1.61-1.16,2.99-1.16,2.38.39,2.99,1.16c.61.77.92,1.91.92,3.41s-.31,2.64-.92,3.41c-.61.77-1.61,1.16-2.99,1.16s-2.38-.39-2.99-1.16ZM256.34,176.19c.31-.5.47-1.25.47-2.27s-.16-1.77-.47-2.27-.85-.75-1.6-.75-1.29.25-1.6.75c-.31.5-.47,1.25-.47,2.27s.16,1.77.47,2.27.85.75,1.6.75,1.29-.25,1.6-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M260.56,177.33c-.61-.77-.92-1.91-.92-3.41s.31-2.64.92-3.41c.61-.77,1.61-1.16,2.99-1.16s2.38.39,2.99,1.16.92,1.91.92,3.41-.31,2.64-.92,3.41c-.61.77-1.61,1.16-2.99,1.16s-2.38-.39-2.99-1.16ZM265.16,176.19c.31-.5.47-1.25.47-2.27s-.16-1.77-.47-2.27-.85-.75-1.6-.75-1.29.25-1.6.75-.47,1.25-.47,2.27.16,1.77.47,2.27.85.75,1.6.75,1.29-.25,1.6-.75Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M234.78,204.26h-2c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h2c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M443.3,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM435.28,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM427.26,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM419.24,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM411.22,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM403.2,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM395.18,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM387.16,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM379.14,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM371.12,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM363.1,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM355.08,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM347.06,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM339.04,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM331.02,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM323,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM314.98,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM306.96,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM298.94,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM290.92,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM282.9,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM274.88,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM266.86,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM258.84,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM250.82,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM242.8,204.26h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M449.31,204.26h-2c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h2c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M234.78,224.27h-2c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h2c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M443.3,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM435.28,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM427.26,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM419.24,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM411.22,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM403.2,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM395.18,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM387.16,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM379.14,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM371.12,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM363.1,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM355.08,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM347.06,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM339.04,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM331.02,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM323,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM314.98,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM306.96,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM298.94,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM290.92,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM282.9,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM274.88,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM266.86,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM258.84,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM250.82,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM242.8,224.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M449.31,224.27h-2c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h2c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M234.78,244.27h-2c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h2c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M443.3,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM435.28,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM427.26,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM419.24,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM411.22,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM403.2,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM395.18,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM387.16,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM379.14,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM371.12,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM363.1,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM355.08,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM347.06,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM339.04,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM331.02,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM323,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM314.98,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM306.96,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM298.94,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM290.92,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM282.9,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM274.88,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM266.86,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM258.84,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM250.82,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM242.8,244.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M449.31,244.27h-2c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h2c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M234.78,264.27h-2c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h2c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M443.3,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM435.28,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM427.26,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM419.24,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM411.22,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM403.2,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM395.18,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM387.16,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM379.14,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM371.12,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM363.1,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM355.08,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM347.06,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM339.04,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM331.02,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM323,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM314.98,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM306.96,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM298.94,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM290.92,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM282.9,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM274.88,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM266.86,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM258.84,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM250.82,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM242.8,264.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M449.31,264.27h-2c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h2c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M213.82,204.96c.1-.22.23-.42.4-.61s.38-.4.64-.62c.24-.21.42-.37.52-.48s.18-.21.22-.32c.04-.1.07-.23.07-.38,0-.21-.06-.37-.19-.48s-.32-.16-.59-.16c-.29,0-.6.06-.92.18v-.58c.14-.05.31-.09.5-.12s.37-.04.54-.04c.42,0,.75.1.97.31s.34.5.34.87c0,.25-.06.47-.18.65s-.31.39-.57.62l-.1.09c-.22.2-.4.35-.51.47-.12.12-.22.25-.3.39h1.7v.5h-2.54v-.32.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M217.39,205.3c-.2-.03-.36-.07-.49-.13v-.57c.14.06.29.11.47.14.18.03.35.05.52.05.31,0,.54-.05.68-.16s.22-.28.22-.52-.06-.4-.17-.5-.31-.16-.6-.16h-1.14v-.4l.1-1.63h2.2l-.05.5h-1.59l-.07,1.01h.65c.46,0,.79.1,1,.29.21.19.32.49.32.89s-.13.69-.38.91-.62.32-1.1.32c-.19,0-.38-.02-.58-.04h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M220.37,204.88c-.27-.34-.41-.83-.41-1.48s.13-1.18.4-1.52c.26-.34.7-.52,1.3-.52s1.03.17,1.3.52c.26.34.4.85.4,1.52s-.13,1.14-.4,1.48-.7.51-1.29.51-1.02-.17-1.29-.51h-.01ZM222.46,204.47c.16-.24.24-.6.24-1.07,0-.5-.08-.87-.23-1.12-.16-.24-.42-.37-.8-.37s-.65.12-.8.37c-.16.24-.23.62-.23,1.12,0,.47.08.83.24,1.07s.43.36.8.36.63-.12.79-.37h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M224.28,204.88c-.27-.34-.41-.83-.41-1.48s.13-1.18.4-1.52c.26-.34.7-.52,1.3-.52s1.03.17,1.3.52c.26.34.4.85.4,1.52s-.13,1.14-.4,1.48-.7.51-1.29.51-1.02-.17-1.29-.51h-.01ZM226.36,204.47c.16-.24.24-.6.24-1.07,0-.5-.08-.87-.23-1.12-.16-.24-.42-.37-.8-.37s-.65.12-.8.37c-.16.24-.23.62-.23,1.12,0,.47.08.83.24,1.07s.43.36.8.36.63-.12.79-.37h-.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M213.82,224.96c.1-.22.23-.42.4-.61s.38-.4.64-.62c.24-.21.42-.37.52-.48s.18-.21.22-.32c.04-.1.07-.23.07-.38,0-.21-.06-.37-.19-.48s-.32-.16-.59-.16c-.29,0-.6.06-.92.18v-.58c.14-.05.31-.09.5-.12s.37-.04.54-.04c.42,0,.75.1.97.31s.34.5.34.87c0,.25-.06.47-.18.65s-.31.39-.57.62l-.1.09c-.22.2-.4.35-.51.47-.12.12-.22.25-.3.39h1.7v.5h-2.54v-.32.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M217.28,224.88c-.27-.34-.41-.83-.41-1.48s.13-1.18.4-1.52c.26-.34.7-.52,1.3-.52s1.03.17,1.3.52c.26.34.4.85.4,1.52s-.13,1.14-.4,1.48-.7.51-1.29.51-1.02-.17-1.29-.51h-.01ZM219.37,224.47c.16-.24.24-.6.24-1.07,0-.5-.08-.87-.23-1.12-.16-.24-.42-.37-.8-.37s-.65.12-.8.37c-.16.24-.23.62-.23,1.12,0,.47.08.83.24,1.07s.43.36.8.36.63-.12.79-.37h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M221.19,224.88c-.27-.34-.41-.83-.41-1.48s.13-1.18.4-1.52c.26-.34.7-.52,1.3-.52s1.03.17,1.3.52c.26.34.4.85.4,1.52s-.13,1.14-.4,1.48-.7.51-1.29.51-1.02-.17-1.29-.51h-.01ZM223.27,224.47c.16-.24.24-.6.24-1.07,0-.5-.08-.87-.23-1.12-.16-.24-.42-.37-.8-.37s-.65.12-.8.37c-.16.24-.23.62-.23,1.12,0,.47.08.83.24,1.07s.43.36.8.36.63-.12.79-.37h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M225.09,224.88c-.27-.34-.41-.83-.41-1.48s.13-1.18.4-1.52c.26-.34.7-.52,1.3-.52s1.03.17,1.3.52c.26.34.4.85.4,1.52s-.13,1.14-.4,1.48-.7.51-1.29.51-1.02-.17-1.29-.51h-.01ZM227.18,224.47c.16-.24.24-.6.24-1.07,0-.5-.08-.87-.23-1.12-.16-.24-.42-.37-.8-.37s-.65.12-.8.37c-.16.24-.23.62-.23,1.12,0,.47.08.83.24,1.07s.43.36.8.36.63-.12.79-.37h-.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M214.45,242l-.62.11v-.55l1.27-.2v3.92h-.65v-3.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M216.25,245.3c-.2-.03-.36-.07-.49-.13v-.57c.14.06.29.11.47.14.18.03.35.05.52.05.31,0,.54-.05.68-.16s.22-.28.22-.52-.06-.4-.17-.5-.31-.16-.6-.16h-1.14v-.4l.1-1.63h2.2l-.05.5h-1.59l-.07,1.01h.65c.46,0,.79.1,1,.29.21.19.32.49.32.89s-.13.69-.38.91-.62.32-1.1.32c-.19,0-.38-.02-.58-.04h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M219.23,244.89c-.27-.34-.41-.83-.41-1.48s.13-1.18.4-1.52c.26-.34.7-.52,1.3-.52s1.03.17,1.3.52c.26.34.4.85.4,1.52s-.13,1.14-.4,1.48-.7.51-1.29.51-1.02-.17-1.29-.51h-.01ZM221.32,244.47c.16-.24.24-.6.24-1.07,0-.5-.08-.87-.23-1.12-.16-.24-.42-.37-.8-.37s-.65.12-.8.37c-.16.24-.23.62-.23,1.12,0,.47.08.83.24,1.07s.43.36.8.36.63-.12.79-.37h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M223.14,244.89c-.27-.34-.41-.83-.41-1.48s.13-1.18.4-1.52c.26-.34.7-.52,1.3-.52s1.03.17,1.3.52c.26.34.4.85.4,1.52s-.13,1.14-.4,1.48-.7.51-1.29.51-1.02-.17-1.29-.51h-.01ZM225.22,244.47c.16-.24.24-.6.24-1.07,0-.5-.08-.87-.23-1.12-.16-.24-.42-.37-.8-.37s-.65.12-.8.37c-.16.24-.23.62-.23,1.12,0,.47.08.83.24,1.07s.43.36.8.36.63-.12.79-.37h-.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M214.45,262l-.62.11v-.55l1.27-.2v3.92h-.65v-3.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M216.14,264.89c-.27-.34-.41-.83-.41-1.48s.13-1.18.4-1.52c.26-.34.7-.52,1.3-.52s1.03.17,1.3.52c.26.34.4.85.4,1.52s-.13,1.14-.4,1.48-.7.51-1.29.51-1.02-.17-1.29-.51h-.01ZM218.23,264.47c.16-.24.24-.6.24-1.07,0-.5-.08-.87-.23-1.12-.16-.24-.42-.37-.8-.37s-.65.12-.8.37c-.16.24-.23.62-.23,1.12,0,.47.08.83.24,1.07.16.24.43.36.8.36s.63-.12.79-.37h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M220.05,264.89c-.27-.34-.41-.83-.41-1.48s.13-1.18.4-1.52c.26-.34.7-.52,1.3-.52s1.03.17,1.3.52c.26.34.4.85.4,1.52s-.13,1.14-.4,1.48-.7.51-1.29.51-1.02-.17-1.29-.51h-.01ZM222.13,264.47c.16-.24.24-.6.24-1.07,0-.5-.08-.87-.23-1.12-.16-.24-.42-.37-.8-.37s-.65.12-.8.37c-.16.24-.23.62-.23,1.12,0,.47.08.83.24,1.07.16.24.43.36.8.36s.63-.12.79-.37h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M223.95,264.89c-.27-.34-.41-.83-.41-1.48s.13-1.18.4-1.52c.26-.34.7-.52,1.3-.52s1.03.17,1.3.52c.26.34.4.85.4,1.52s-.13,1.14-.4,1.48-.7.51-1.29.51-1.02-.17-1.29-.51h-.01ZM226.04,264.47c.16-.24.24-.6.24-1.07,0-.5-.08-.87-.23-1.12-.16-.24-.42-.37-.8-.37s-.65.12-.8.37c-.16.24-.23.62-.23,1.12,0,.47.08.83.24,1.07.16.24.43.36.8.36s.63-.12.79-.37h-.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M234.78,284.27h-2c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h2c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M443.3,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM435.28,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM427.26,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM419.24,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM411.22,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM403.2,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM395.18,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM387.16,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM379.14,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM371.12,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM363.1,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM355.08,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM347.06,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM339.04,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM331.02,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM323,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM314.98,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM306.96,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM298.94,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM290.92,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM282.9,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM274.88,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM266.86,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM258.84,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM250.82,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM242.8,284.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M449.31,284.27h-2c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h2c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M234.78,304.27h-2c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h2c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M443.3,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM435.28,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM427.26,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM419.24,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM411.22,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM403.2,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM395.18,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM387.16,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM379.14,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM371.12,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM363.1,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM355.08,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM347.06,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM339.04,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM331.02,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM323,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM314.98,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM306.96,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM298.94,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM290.92,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM282.9,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM274.88,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM266.86,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM258.84,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM250.82,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5ZM242.8,304.27h-4.01c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h4.01c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M449.31,304.27h-2c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h2c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M214.33,285.31c-.2-.03-.36-.07-.49-.13v-.57c.14.06.29.11.47.14.18.03.35.05.52.05.31,0,.54-.05.68-.16.14-.11.22-.28.22-.52s-.06-.4-.17-.5-.31-.16-.6-.16h-1.14v-.4l.1-1.63h2.2l-.05.5h-1.59l-.07,1.01h.65c.46,0,.79.1,1,.29s.32.49.32.89-.13.69-.38.91-.62.32-1.1.32c-.19,0-.38-.02-.58-.04h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M217.32,284.89c-.27-.34-.41-.83-.41-1.48s.13-1.18.4-1.52c.26-.34.7-.52,1.3-.52s1.03.17,1.3.52c.26.34.4.85.4,1.52s-.13,1.14-.4,1.48-.7.51-1.29.51-1.02-.17-1.29-.51h-.01ZM219.4,284.48c.16-.24.24-.6.24-1.07,0-.5-.08-.87-.23-1.12-.16-.24-.42-.37-.8-.37s-.65.12-.8.37c-.16.24-.23.62-.23,1.12,0,.47.08.83.24,1.07.16.24.43.36.8.36s.63-.12.79-.37h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M221.22,284.89c-.27-.34-.41-.83-.41-1.48s.13-1.18.4-1.52c.26-.34.7-.52,1.3-.52s1.03.17,1.3.52c.26.34.4.85.4,1.52s-.13,1.14-.4,1.48-.7.51-1.29.51-1.02-.17-1.29-.51h-.01ZM223.31,284.48c.16-.24.24-.6.24-1.07,0-.5-.08-.87-.23-1.12-.16-.24-.42-.37-.8-.37s-.65.12-.8.37c-.16.24-.23.62-.23,1.12,0,.47.08.83.24,1.07.16.24.43.36.8.36s.63-.12.79-.37h-.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M214.23,304.89c-.27-.34-.41-.83-.41-1.48s.13-1.18.4-1.52c.26-.34.7-.52,1.3-.52s1.03.17,1.3.52.4.85.4,1.52-.13,1.14-.4,1.48-.7.51-1.29.51-1.02-.17-1.29-.51h-.01ZM216.31,304.48c.16-.24.24-.6.24-1.07,0-.5-.08-.87-.23-1.12-.16-.24-.42-.37-.8-.37s-.65.12-.8.37c-.16.24-.23.62-.23,1.12,0,.47.08.83.24,1.07.16.24.43.36.8.36s.63-.12.79-.37h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M232.55,295.27c-.21,0-.4-.13-.47-.34-.09-.26.05-.55.31-.63,21.91-7.48,36.28-18.35,42.71-32.32.68-1.47,1.33-2.91,1.97-4.33,3.9-8.62,7.27-16.06,12.44-21.85,9.37-10.5,24.76-11.56,45.73-3.17,37.52,15.01,45.97,16.26,63.19,14.74,14.44-1.28,32.35-13.24,51.8-34.59.19-.2.5-.22.71-.03.2.19.22.5.03.71-19.62,21.54-37.76,33.61-52.45,34.91-19.68,1.74-30.29-1.46-63.65-14.8-20.55-8.22-35.56-7.24-44.62,2.91-5.07,5.68-8.41,13.06-12.28,21.6-.64,1.42-1.3,2.87-1.98,4.34-6.55,14.22-21.12,25.27-43.3,32.84-.05.02-.11.03-.16.03l.02-.02Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st170"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st124"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M450.61,213.1h-218.06,218.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st186",
    x: 232.55,
    y: 213.1,
    width: 218.06,
    height: 45.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st186",
    x: 232.55,
    y: 258.44,
    width: 218.06,
    height: 45.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M232.55,303.77h218.06-218.06,0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M232.13,315.97v-.55c.1.04.21.08.34.1.13.02.26.04.39.04.26,0,.45-.05.56-.16s.16-.29.16-.53v-2.68h.65v2.78c0,.37-.11.66-.32.85s-.53.29-.94.29c-.33,0-.61-.05-.84-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M235.13,315.89c-.19-.15-.29-.37-.29-.65s.1-.5.29-.66c.19-.16.48-.24.85-.24h.91v-.13c0-.14-.02-.25-.06-.33s-.12-.14-.23-.17c-.11-.04-.27-.05-.48-.05-.34,0-.65.05-.94.15v-.49c.14-.05.3-.09.48-.13.18-.03.38-.05.58-.05.42,0,.74.09.96.26.21.17.32.44.32.82v1.83h-.56l-.04-.29c-.12.12-.27.2-.44.26s-.38.09-.63.09c-.29,0-.53-.08-.72-.22h0ZM236.53,315.55c.15-.06.27-.15.37-.27v-.5h-.9c-.19,0-.33.04-.42.11-.09.07-.13.19-.13.34,0,.14.05.25.14.32.1.07.24.1.43.1s.36-.03.5-.1h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M238.24,313.21h.6l.03.3c.14-.11.29-.2.47-.26.18-.07.37-.1.58-.1.37,0,.64.09.8.26s.25.44.25.8v1.84h-.65v-1.81c0-.22-.05-.37-.14-.46s-.26-.13-.5-.13c-.15,0-.29.03-.44.09-.14.06-.26.14-.36.23v2.08h-.65v-2.84h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M262.38,312.19h2.63v.51h-1.97v1.17h1.75v.5h-1.75v1.68h-.65v-3.86h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M265.35,315.74c-.27-.25-.4-.62-.4-1.12,0-.47.12-.83.35-1.09.24-.26.59-.39,1.05-.39.42,0,.74.11.97.33s.34.51.34.88v.53h-2.08c.03.27.13.46.29.57.16.11.42.16.77.16.14,0,.29-.01.44-.04s.28-.06.4-.11v.48c-.25.11-.58.17-.97.17-.5,0-.89-.12-1.16-.37h0ZM267.08,314.46v-.2c0-.2-.06-.36-.17-.46-.11-.11-.29-.16-.54-.16-.3,0-.5.06-.62.19s-.18.34-.18.63h1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M269.32,316.03c-.15-.05-.29-.14-.43-.26l-.04.28h-.56v-4.04h.65v1.39c.24-.16.54-.25.89-.25.42,0,.74.12.97.36s.34.6.34,1.1-.11.88-.34,1.13-.54.38-.96.38c-.2,0-.38-.03-.53-.08h0ZM270.3,315.37c.13-.16.19-.42.19-.77s-.07-.59-.2-.74-.34-.22-.63-.22-.54.08-.72.25v1.43c.19.2.43.3.73.3s.49-.08.62-.25h.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M292.38,312.19h.67l1.22,2.5,1.22-2.5h.67v3.86h-.65v-2.8l-1.04,2.14h-.4l-1.05-2.14v2.8h-.65v-3.86h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M297.09,315.89c-.19-.15-.29-.37-.29-.65s.1-.5.29-.66.48-.24.85-.24h.91v-.13c0-.14-.02-.25-.06-.33s-.12-.14-.23-.17c-.11-.04-.27-.05-.48-.05-.34,0-.65.05-.94.15v-.49c.14-.05.3-.09.48-.13.18-.03.38-.05.58-.05.42,0,.74.09.96.26.21.17.32.44.32.82v1.83h-.56l-.04-.29c-.12.12-.27.2-.44.26s-.38.09-.63.09c-.29,0-.53-.08-.72-.22h0ZM298.49,315.55c.15-.06.27-.15.37-.27v-.5h-.9c-.19,0-.33.04-.42.11-.09.07-.13.19-.13.34,0,.14.05.25.14.32.1.07.24.1.43.1s.36-.03.5-.1h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M300.2,313.21h.6l.04.33c.14-.09.3-.17.49-.24.19-.07.37-.12.56-.15v.5c-.17.03-.36.08-.56.15s-.36.13-.47.21v2.05h-.65v-2.84h-.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M323.75,312.19h.73l1.46,3.86h-.67l-.38-1h-1.55l-.38,1h-.68l1.48-3.86h-.01ZM324.78,314.55l-.67-1.77-.67,1.77h1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M326.58,313.21h.56l.04.28c.13-.12.27-.2.43-.26.15-.06.33-.08.53-.08.42,0,.75.11.97.34s.33.59.33,1.09-.12.89-.35,1.14c-.23.26-.56.39-.97.39-.34,0-.64-.08-.88-.24v1.48h-.65v-4.14h0ZM328.58,315.36c.14-.17.2-.43.2-.79s-.06-.57-.19-.72c-.12-.14-.33-.21-.62-.21s-.54.1-.73.3v1.42c.19.17.43.25.71.25s.49-.09.62-.26h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M330.07,313.21h.6l.04.33c.14-.09.3-.17.49-.24.19-.07.37-.12.56-.15v.5c-.17.03-.36.08-.56.15s-.36.13-.47.21v2.05h-.65v-2.84h-.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M352.39,312.19h.67l1.22,2.5,1.22-2.5h.67v3.86h-.65v-2.8l-1.04,2.14h-.4l-1.05-2.14v2.8h-.65v-3.86h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M357.1,315.89c-.19-.15-.29-.37-.29-.65s.1-.5.29-.66.48-.24.85-.24h.91v-.13c0-.14-.02-.25-.06-.33s-.12-.14-.23-.17c-.11-.04-.27-.05-.48-.05-.34,0-.65.05-.94.15v-.49c.14-.05.3-.09.48-.13.18-.03.38-.05.58-.05.42,0,.74.09.96.26.21.17.32.44.32.82v1.83h-.56l-.04-.29c-.12.12-.27.2-.44.26s-.38.09-.63.09c-.29,0-.53-.08-.72-.22h0ZM358.49,315.55c.15-.06.27-.15.37-.27v-.5h-.9c-.19,0-.33.04-.42.11-.09.07-.13.19-.13.34,0,.14.05.25.14.32.1.07.24.1.43.1s.36-.03.5-.1h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M360.03,317.02v-.49c.11.04.23.06.37.06.12,0,.22-.02.29-.06.08-.04.14-.1.2-.18s.12-.2.2-.35l-1.27-2.81h.68l.91,2.11.92-2.11h.67l-1.16,2.68c-.17.41-.35.71-.54.92s-.43.3-.73.3c-.22,0-.4-.03-.55-.08h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M382.15,315.97v-.55c.1.04.21.08.34.1.13.02.26.04.39.04.26,0,.45-.05.56-.16s.16-.29.16-.53v-2.68h.65v2.78c0,.37-.11.66-.32.85-.21.19-.53.29-.94.29-.33,0-.61-.05-.84-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M385.22,315.83c-.18-.19-.27-.46-.27-.82v-1.79h.65v1.79c0,.21.05.37.16.47.1.1.26.15.48.15.16,0,.3-.03.44-.09s.26-.14.36-.24v-2.08h.65v2.84h-.59l-.03-.29c-.3.24-.65.35-1.06.35-.34,0-.6-.09-.78-.29h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M388.44,313.21h.6l.03.3c.14-.11.29-.2.47-.26.18-.07.37-.1.58-.1.37,0,.64.09.8.26s.25.44.25.8v1.84h-.65v-1.81c0-.22-.05-.37-.14-.46-.09-.09-.26-.13-.5-.13-.15,0-.29.03-.44.09-.14.06-.26.14-.36.23v2.08h-.65v-2.84h.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M412.15,315.97v-.55c.1.04.21.08.34.1.13.02.26.04.39.04.26,0,.45-.05.56-.16s.16-.29.16-.53v-2.68h.65v2.78c0,.37-.11.66-.32.85-.21.19-.53.29-.94.29-.33,0-.61-.05-.84-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M415.22,315.83c-.18-.19-.27-.46-.27-.82v-1.79h.65v1.79c0,.21.05.37.16.47.1.1.26.15.48.15.16,0,.3-.03.44-.09s.26-.14.36-.24v-2.08h.65v2.84h-.59l-.03-.29c-.3.24-.65.35-1.06.35-.34,0-.6-.09-.78-.29h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st260",
    d: "M418.62,315.94c-.12-.12-.17-.3-.17-.56v-3.37h.65v3.31c0,.11.02.18.06.22s.1.06.18.06c.1,0,.19-.01.28-.04v.47c-.13.05-.29.07-.46.07-.24,0-.42-.06-.53-.17h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st178",
    cx: 236.13,
    cy: 293.68,
    r: 1.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M236.13,295.7c-1.11,0-2.02-.91-2.02-2.02s.91-2.02,2.02-2.02,2.02.91,2.02,2.02-.91,2.02-2.02,2.02ZM236.13,292.66c-.56,0-1.02.46-1.02,1.02s.46,1.02,1.02,1.02,1.02-.46,1.02-1.02-.46-1.02-1.02-1.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st178",
    cx: 266.13,
    cy: 275.68,
    r: 1.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M266.13,277.7c-1.11,0-2.02-.91-2.02-2.02s.91-2.02,2.02-2.02,2.02.91,2.02,2.02-.91,2.02-2.02,2.02ZM266.13,274.66c-.56,0-1.02.46-1.02,1.02s.46,1.02,1.02,1.02,1.02-.46,1.02-1.02-.46-1.02-1.02-1.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st178",
    cx: 298.14,
    cy: 230.68,
    r: 1.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M298.14,232.7c-1.11,0-2.02-.91-2.02-2.02s.91-2.02,2.02-2.02,2.02.91,2.02,2.02-.91,2.02-2.02,2.02ZM298.14,229.66c-.56,0-1.02.46-1.02,1.02s.46,1.02,1.02,1.02,1.02-.46,1.02-1.02-.46-1.02-1.02-1.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st178",
    cx: 329.14,
    cy: 230.68,
    r: 1.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M329.14,232.7c-1.11,0-2.02-.91-2.02-2.02s.91-2.02,2.02-2.02,2.02.91,2.02,2.02-.91,2.02-2.02,2.02ZM329.14,229.66c-.56,0-1.02.46-1.02,1.02s.46,1.02,1.02,1.02,1.02-.46,1.02-1.02-.46-1.02-1.02-1.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st178",
    cx: 359.14,
    cy: 241.68,
    r: 1.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M359.14,243.7c-1.11,0-2.02-.91-2.02-2.02s.91-2.02,2.02-2.02,2.02.91,2.02,2.02-.91,2.02-2.02,2.02ZM359.14,240.66c-.56,0-1.02.46-1.02,1.02s.46,1.02,1.02,1.02,1.02-.46,1.02-1.02-.46-1.02-1.02-1.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st178",
    cx: 387.15,
    cy: 248.68,
    r: 1.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M387.15,250.7c-1.11,0-2.02-.91-2.02-2.02s.91-2.02,2.02-2.02,2.02.91,2.02,2.02-.91,2.02-2.02,2.02ZM387.15,247.66c-.56,0-1.02.46-1.02,1.02s.46,1.02,1.02,1.02,1.02-.46,1.02-1.02-.46-1.02-1.02-1.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st178",
    cx: 415.15,
    cy: 242.68,
    r: 1.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M415.15,244.7c-1.11,0-2.02-.91-2.02-2.02s.91-2.02,2.02-2.02,2.02.91,2.02,2.02-.91,2.02-2.02,2.02ZM415.15,241.66c-.56,0-1.02.46-1.02,1.02s.46,1.02,1.02,1.02,1.02-.46,1.02-1.02-.46-1.02-1.02-1.02Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M197.04,119.82v-1.36c0-.62.32-1.12.95-1.51.63-.39,1.47-.58,2.51-.58.19,0,.37,0,.54.01s.34.03.5.05c-.2.3-.35.62-.45.95s-.15.68-.15,1.04v1.4h-3.9ZM202.23,119.82v-1.4c0-.46.13-.88.38-1.26.25-.38.61-.72,1.07-1s1.01-.5,1.65-.65,1.34-.22,2.08-.22,1.47.07,2.11.22,1.19.36,1.65.65.81.62,1.06,1,.37.8.37,1.26v1.4h-10.37ZM213.89,119.82v-1.4c0-.37-.05-.73-.14-1.06s-.23-.64-.42-.93c.16-.03.32-.05.49-.05s.33-.01.51-.01c1.04,0,1.87.19,2.51.57s.95.89.95,1.52v1.36h-3.9ZM204.06,118.1h6.72c-.14-.29-.54-.54-1.2-.76s-1.38-.32-2.17-.32-1.52.11-2.17.32-1.05.47-1.18.76h0ZM200.5,115.51c-.48,0-.88-.17-1.22-.51s-.51-.75-.51-1.22.17-.9.51-1.23.75-.5,1.22-.5.9.17,1.23.5.5.74.5,1.23-.17.88-.5,1.22-.74.51-1.23.51ZM214.32,115.51c-.48,0-.88-.17-1.22-.51s-.51-.75-.51-1.22.17-.9.51-1.23.75-.5,1.22-.5.9.17,1.23.5.5.74.5,1.23-.17.88-.5,1.22-.74.51-1.23.51ZM207.41,114.64c-.72,0-1.33-.25-1.84-.76-.5-.5-.76-1.12-.76-1.84s.25-1.35.76-1.85,1.12-.75,1.84-.75,1.35.25,1.85.75.75,1.11.75,1.85-.25,1.33-.75,1.84c-.5.5-1.11.76-1.85.76ZM207.41,112.91c.24,0,.45-.08.62-.25s.25-.37.25-.62-.08-.45-.25-.62c-.17-.17-.37-.25-.62-.25s-.45.08-.62.25-.25.37-.25.62.08.45.25.62.37.25.62.25Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M229.98,380.54h-3.71v-1.53h9.36v1.53h-3.69v10.06h-1.96v-10.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M235.98,389.67c-.8-.74-1.21-1.86-1.21-3.35,0-1.4.35-2.49,1.06-3.27.71-.77,1.76-1.16,3.15-1.16,1.26,0,2.23.33,2.9.99s1.01,1.54,1.01,2.65v1.58h-6.25c.1.82.39,1.38.88,1.7s1.27.48,2.32.48c.43,0,.87-.04,1.32-.13.45-.08.85-.19,1.2-.32v1.44c-.76.34-1.73.5-2.92.5-1.51,0-2.67-.37-3.47-1.12h.01ZM241.16,385.84v-.59c0-.61-.17-1.08-.5-1.39-.34-.32-.88-.48-1.62-.48-.89,0-1.51.19-1.86.58s-.53,1.01-.53,1.89h4.52-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M245.3,390.11c-.58-.45-.86-1.09-.86-1.94s.29-1.5.85-1.99c.57-.49,1.42-.73,2.56-.73h2.74v-.38c0-.42-.06-.75-.19-.98s-.36-.41-.69-.51c-.34-.11-.82-.16-1.44-.16-1.01,0-1.95.15-2.83.45v-1.46c.41-.16.89-.28,1.44-.38s1.13-.14,1.75-.14c1.27,0,2.23.26,2.87.77.64.52.96,1.33.96,2.45v5.49h-1.67l-.13-.86c-.36.35-.8.61-1.31.78-.52.17-1.15.26-1.89.26-.86,0-1.58-.22-2.16-.67h0ZM249.5,389.09c.44-.19.81-.46,1.1-.81v-1.49h-2.7c-.58,0-.99.11-1.25.32-.26.22-.39.56-.39,1.03,0,.43.14.75.43.94s.72.3,1.3.3,1.07-.1,1.51-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M254.64,382.07h1.8l.09.9c.91-.72,1.91-1.08,3.01-1.08.59,0,1.06.09,1.4.28.35.19.62.47.81.84.43-.35.91-.62,1.43-.82s1.12-.3,1.79-.3c.98,0,1.71.25,2.18.76.47.5.7,1.28.7,2.32v5.63h-1.93v-5.44c0-.65-.14-1.11-.41-1.38-.28-.27-.73-.4-1.35-.4-.41,0-.8.07-1.17.22-.37.14-.68.36-.94.65.06.23.09.52.09.88v5.47h-1.82v-5.42c0-.65-.11-1.11-.33-1.39-.22-.28-.63-.41-1.21-.41-.76,0-1.49.34-2.21,1.01v6.21h-1.93v-8.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M276.71,379.01h1.73l6.05,8.53v-8.53h1.94v11.59h-1.73l-6.03-8.51v8.51h-1.96v-11.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M289.56,389.67c-.8-.74-1.21-1.86-1.21-3.35,0-1.4.35-2.49,1.06-3.27.71-.77,1.76-1.16,3.15-1.16,1.26,0,2.23.33,2.9.99.67.66,1.01,1.54,1.01,2.65v1.58h-6.25c.1.82.39,1.38.88,1.7s1.27.48,2.32.48c.43,0,.87-.04,1.32-.13.45-.08.85-.19,1.2-.32v1.44c-.76.34-1.73.5-2.92.5-1.51,0-2.67-.37-3.47-1.12h0ZM294.75,385.84v-.59c0-.61-.17-1.08-.5-1.39-.34-.32-.88-.48-1.62-.48-.89,0-1.51.19-1.86.58s-.53,1.01-.53,1.89h4.52-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M298.02,382.07h1.96l1.48,6.21,1.67-5.17v-1.04h1.49l1.85,6.21,1.48-6.21h1.94l-2.23,8.53h-1.85l-1.82-5.58-1.85,5.58h-1.87l-2.25-8.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M312.26,390.67c-.54-.08-.98-.18-1.33-.31v-1.66c.4.16.84.28,1.32.36s.96.13,1.43.13c.7,0,1.18-.06,1.46-.18s.41-.35.41-.7c0-.31-.13-.54-.38-.69s-.73-.33-1.42-.55l-.54-.18c-.86-.29-1.49-.61-1.89-.96-.4-.35-.59-.88-.59-1.58,0-.8.29-1.41.86-1.83.58-.41,1.48-.62,2.7-.62.47,0,.93.04,1.38.11.45.07.84.16,1.16.27v1.64c-.32-.13-.69-.23-1.09-.31-.4-.07-.78-.11-1.14-.11-.66,0-1.14.06-1.44.17-.3.11-.45.33-.45.64,0,.28.11.48.34.62.23.14.68.32,1.35.53l.4.13c.7.22,1.24.44,1.62.66s.66.49.84.81c.17.32.26.73.26,1.23,0,1.67-1.19,2.5-3.58,2.5-.58,0-1.13-.04-1.67-.12h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M200.95,392.34c-.48,0-.89-.17-1.23-.51s-.51-.75-.51-1.23v-13.92l1.46,1.46,1.44-1.46,1.46,1.46,1.46-1.46,1.44,1.46,1.46-1.46,1.46,1.46,1.44-1.46,1.46,1.46,1.46-1.46,1.44,1.46,1.46-1.46v13.92c0,.48-.17.89-.51,1.23s-.75.51-1.23.51h-13.96ZM200.95,390.6h6.09v-5.22h-6.09v5.22ZM208.78,390.6h6.09v-1.74h-6.09v1.74ZM208.78,387.12h6.09v-1.74h-6.09v1.74ZM200.95,383.64h13.92v-2.61h-13.92v2.61Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M17.02,53.46c.56,1.19.25,2.25.25,2.27.01,0-1.18-.17-1.83-1.52-.64-1.36-.09-2.67-.09-2.66,0,.01,1.11.73,1.67,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M24.25,61.23s.02.04.03.06h0c.26.61.33.65.24.83-.09.18-.15.17-.83.3h0s-.05,0-.07.01c-1.06.19-1.64,1.07-1.63,1.07-.01,0,1.33.74,2.44.47,1.09-.27,1.4-1.14,1.46-1.28.06-.15.33-1-.1-1.9-.42-.89-1.37-1.44-1.37-1.45,0,0-.55.92-.16,1.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M21.83,59.7s.01.04.01.06h0c.15.64.21.7.1.86-.11.16-.18.14-.86.16h-.07c-1.08,0-1.8.77-1.79.78-.01,0,1.19.95,2.32.88,1.12-.08,1.57-.89,1.66-1.01.09-.13.49-.93.23-1.89-.26-.95-1.1-1.65-1.1-1.66,0,0-.7.82-.48,1.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M19.7,57.77s0,.04,0,.07h0c.04.66.09.73-.05.86-.14.14-.2.11-.88,0h0s-.05,0-.07-.01c-1.07-.19-1.91.45-1.91.45-.01,0,1.01,1.15,2.15,1.27,1.12.12,1.7-.6,1.81-.71.11-.12.65-.83.55-1.82-.1-.98-.81-1.82-.81-1.83,0,0-.83.68-.79,1.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M17.93,55.49s0,.04,0,.07h0c-.07.66-.03.73-.2.85-.16.11-.22.07-.87-.15q-.44-.15,0,0s-.04-.02-.07-.02c-1.02-.38-1.96.1-1.96.11-.01,0,.81,1.33,1.91,1.64,1.09.31,1.79-.29,1.91-.38.13-.1.78-.71.85-1.7.07-.98-.49-1.95-.49-1.96,0,0-.94.53-1.07,1.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M26.73,60.45s-.38,1.01.17,1.88c0,.02.02.04.04.06h0c.36.55.44.58.39.78-.05.19-.12.19-.77.44h0l-.07.02c-1.02.37-1.44,1.33-1.43,1.34-.01,0,1.45.5,2.5.05.36-.15.61-.36.79-.58h0c.42-.4.37-.64.97-.55.59.09,1.7.59,2.8.57,1.1-.03,1.14-.73,1.14-.72,0,0-.15-.65-1.15-.62-1,.02-2.11.3-2.7.21-.58-.09-.45-.31-.67-.83h0c-.07-.27-.19-.56-.39-.84-.58-.8-1.61-1.19-1.62-1.2h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M54.29,53.46c-.56,1.19-.25,2.25-.25,2.27-.01,0,1.18-.17,1.83-1.52.64-1.36.09-2.67.09-2.66,0,.01-1.11.73-1.67,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M47.06,61.23s-.02.04-.03.06h0c-.26.61-.33.65-.24.83.09.18.15.17.83.3h0s.04,0,.07.01c1.06.19,1.64,1.07,1.63,1.07.01,0-1.33.74-2.44.47-1.09-.27-1.4-1.14-1.46-1.28-.06-.15-.33-1,.1-1.9.42-.89,1.37-1.44,1.37-1.45,0,0,.55.92.16,1.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M49.48,59.7s-.01.04-.01.06h0c-.15.64-.21.7-.09.86.11.16.18.14.86.16h.07c1.08,0,1.8.77,1.79.78.01,0-1.19.95-2.32.88-1.12-.08-1.57-.89-1.66-1.01-.09-.13-.49-.93-.23-1.89.26-.95,1.1-1.65,1.1-1.66,0,0,.7.82.48,1.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M51.61,57.77s0,.04,0,.07h0c-.04.66-.09.73.05.86.14.14.2.11.88,0h0s.04,0,.07-.01c1.07-.19,1.91.45,1.9.45.01,0-1.01,1.15-2.15,1.27-1.12.12-1.7-.6-1.81-.71-.11-.12-.65-.83-.55-1.82.1-.98.81-1.82.81-1.83,0,0,.83.68.79,1.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M53.38,55.49s0,.04,0,.07h0c.07.66.03.73.2.85.16.11.22.07.87-.15q.44-.15,0,0s.04-.02.07-.02c1.02-.38,1.96.1,1.96.11.01,0-.81,1.33-1.91,1.64-1.09.31-1.79-.29-1.91-.38-.13-.1-.78-.71-.85-1.7-.07-.98.49-1.95.49-1.96,0,0,.94.53,1.07,1.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M44.57,60.45s.38,1.01-.17,1.88c-.01.02-.02.04-.04.06h0c-.36.55-.44.58-.39.78.05.19.12.19.77.44h0s.04.01.07.02c1.02.37,1.43,1.33,1.43,1.34.01,0-1.45.5-2.5.05-.36-.15-.61-.36-.79-.58h0c-.42-.4-.37-.64-.97-.55-.59.09-1.7.59-2.8.57-1.1-.03-1.14-.73-1.14-.72,0,0,.15-.65,1.15-.62,1,.02,2.11.3,2.7.21.58-.09.45-.31.67-.83h0c.07-.27.19-.56.39-.84.58-.8,1.61-1.19,1.62-1.2h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st255",
    d: "M57.5,39.1l-1.84-16.82c-.11-1.03-.89-2.17-1.81-2.65l-.1-.05-.11-.03-16.49-4.22c-.4-.11-.94-.17-1.5-.17s-1.1.06-1.51.18l-16.47,4.21-.11.03-.1.05c-.92.48-1.7,1.61-1.82,2.65l-1.83,16.82c-.1.88.09,2.16.45,2.98.09.2,2.18,5,7.51,10.42,5.34,5.42,12.03,8.37,12.31,8.49.44.19,1,.3,1.58.3s1.14-.11,1.58-.3c.28-.12,6.97-3.07,12.31-8.49,5.33-5.42,7.42-10.22,7.51-10.42.35-.82.54-2.1.45-2.98h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M56.55,39.2l-1.84-16.82c-.08-.72-.67-1.57-1.31-1.9l-16.49-4.22c-.69-.19-1.83-.19-2.52,0l-16.49,4.22c-.64.33-1.23,1.19-1.31,1.9l-1.84,16.82c-.08.71.09,1.84.37,2.5,0,0,2.04,4.77,7.31,10.13,5.27,5.35,12.01,8.29,12.01,8.29.66.29,1.74.29,2.4,0,0,0,6.74-2.93,12.01-8.29,5.27-5.35,7.31-10.13,7.31-10.13.28-.66.45-1.79.37-2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M54.66,41.05c.17-.4.3-1.24.25-1.67l-1.84-16.82c-.02-.14-.19-.41-.34-.55l-16.23-4.15h-.02c-.15-.05-.44-.09-.83-.09s-.68.04-.83.08h-.02s-16.23,4.16-16.23,4.16c-.15.14-.32.41-.34.55l-1.84,16.82c-.05.43.08,1.27.25,1.67.02.04,2.02,4.58,6.97,9.62,4.97,5.05,11.43,7.9,11.49,7.93.06.03.25.08.54.08s.48-.05.54-.08c.07-.03,6.53-2.88,11.5-7.93,4.99-5.07,6.95-9.57,6.97-9.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st254",
    d: "M34.29,56.5c.65.34,1.12.56,1.33.66h.08c.2-.09.67-.32,1.33-.66v-25.33h-2.73v25.33ZM17.92,39.55v.07h0c0,.25.08.68.14.83,0,.02.8,1.79,2.59,4.31v-13.59h-1.81l-.91,8.38h0ZM52.48,31.17h-1.81v13.6c1.78-2.5,2.57-4.25,2.59-4.32h0c.06-.15.12-.56.13-.79v-.11l-.91-8.38h0ZM39.75,54.94c.85-.52,1.78-1.13,2.73-1.83v-21.95h-2.73v23.78h0ZM45.2,50.92c.47-.42.94-.86,1.39-1.32.47-.48.92-.96,1.34-1.42v-17.01h-2.73v19.75h0ZM23.37,48.18c.42.47.86.94,1.34,1.43.45.46.92.9,1.39,1.32v-19.75h-2.73v17.01ZM28.83,53.12c.95.69,1.88,1.3,2.73,1.83v-23.78h-2.73v21.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M52.29,29.47l-.68-6.17-15.48-3.96h-.02s-.04-.02-.04-.02h0s-.15-.03-.42-.03c-.28,0-.44.03-.44.03h-.04s-15.49,3.97-15.49,3.97l-.67,6.17h33.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st254",
    d: "M43.85,43.28c0,4.53-3.67,8.19-8.19,8.19s-8.19-3.67-8.19-8.19,3.67-8.19,8.19-8.19,8.19,3.67,8.19,8.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M42.48,43.28c0,3.77-3.06,6.82-6.82,6.82s-6.82-3.06-6.82-6.82,3.06-6.82,6.82-6.82,6.82,3.06,6.82,6.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M33.86,42.72l.69,2.12h2.22l.69-2.12-1.8-1.31-1.8,1.31h0ZM35.66,37.62c-3.12,0-5.66,2.53-5.66,5.66s2.53,5.66,5.66,5.66,5.66-2.53,5.66-5.66-2.53-5.66-5.66-5.66ZM37.63,46l-.66,2.01c-.42.12-.86.19-1.32.19s-.9-.07-1.32-.19l-.66-2.01h-2.12c-.48-.73-.77-1.59-.81-2.52l1.71-1.24-.65-2.01c.55-.7,1.29-1.24,2.14-1.55l1.71,1.25,1.71-1.25c.85.32,1.59.86,2.14,1.55l-.66,2.01,1.71,1.24c-.04.93-.33,1.79-.81,2.52h-2.12,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M32.14,22.93c.05.07.13.1.22.1s.16-.03.22-.1.08-.16.08-.27v-.8h.32v.81c0,.21-.06.37-.17.48-.12.11-.26.17-.45.17s-.33-.06-.45-.17-.18-.27-.18-.48v-.81h.32v.8c0,.12.03.21.08.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M34.33,21.86h.32v1.45h-.32l-.69-.91v.91h-.32v-1.45h.3l.71.93v-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M35.01,21.86h.32v1.45h-.32v-1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M36.31,22.14v1.17h-.32v-1.17h-.41v-.28h1.14v.28h-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M38,21.86v.29h-.72v.3h.65v.28h-.65v.3h.75v.29h-1.07v-1.45h1.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M39.42,22.05c.14.13.21.3.21.53s-.07.4-.2.54c-.13.13-.34.2-.62.2h-.5v-1.45h.51c.26,0,.46.06.6.19h0ZM39.18,22.91c.08-.08.12-.18.12-.33s-.04-.25-.12-.33c-.08-.08-.2-.11-.37-.11h-.18v.88h.21c.15,0,.26-.04.34-.11Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M26.89,27.98l.07.24h-.79l.08-.24v-1.1l-.79-2.23-.19-.28h.95l-.09.15.43,1.42.43-1.42-.09-.15h.95l-.19.28-.78,2.23v1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M29.97,24.68v3.22l-.32.32h-1.28l-.33-.32v-3.22l.33-.32h1.28l.32.32ZM29.24,25.02h-.49l-.08.07v2.42l.08.07h.49l.08-.07v-2.42l-.08-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M32.42,24.62v3.29l-.33.32h-1.29l-.32-.32v-3.29l-.08-.25h.8l-.08.25v2.89l.08.07h.5l.08-.07v-2.89l-.08-.25h.81s-.08.25-.08.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M32.88,28.23l.08-.24v-3.37l-.08-.25h1.69l.33.32v1.76l-.33.33.28,1.2.1.26h-.8l.06-.24-.27-1.16-.05-.06h-.21l-.08.08v1.14l.08.24s-.8,0-.8,0ZM34.18,26.12l.08-.07v-.96l-.08-.07h-.5l-.08.07v.96l.08.07h.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M36.59,27.91v-3.22l.33-.32h1.28l.32.32v.65l.08.24h-.81l.09-.24v-.25l-.07-.08h-.5l-.08.08v2.42l.08.08h.5l.07-.08v-.25l-.09-.24h.81l-.08.24v.66l-.32.32h-1.28l-.33-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M40.91,28.23h-1.93l.08-.24v-3.37l-.08-.25h.8l-.08.25v2.89l.08.07h.99l.26-.07-.12.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M43.3,24.62v3.29l-.33.32h-1.29l-.32-.32v-3.29l-.08-.25h.8l-.08.25v2.89l.08.07h.5l.08-.07v-2.89l-.08-.25h.81l-.08.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M43.77,24.37h1.69l.33.32v1.26l-.33.32.33.33v1.32l-.33.32h-1.69l.08-.25v-3.37l-.08-.24h0ZM44.49,25.87l.08.07h.49l.08-.07v-.79l-.08-.08h-.49l-.08.08v.79ZM45.06,26.59h-.49l-.08.08v.84l.08.08h.49l.08-.08v-.84l-.08-.08Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M78.02,41.05l-5.08-8.9h2.48l3.78,6.88,3.78-6.88h2.48l-5.08,8.9v5.25h-2.37v-5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M85.06,41.09c0-3.62,1.81-5.43,5.43-5.43s5.45,1.81,5.45,5.43-1.82,5.43-5.45,5.43-5.43-1.81-5.43-5.43ZM92.82,43.71c.46-.53.69-1.4.69-2.62s-.23-2.07-.69-2.59c-.46-.53-1.24-.79-2.34-.79s-1.86.26-2.32.79c-.46.53-.69,1.39-.69,2.59s.23,2.09.69,2.62c.46.53,1.23.79,2.32.79s1.88-.26,2.34-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M99.15,45.48c-.67-.7-1-1.7-1-3.02v-6.57h2.4v6.57c0,.78.19,1.35.57,1.71s.97.55,1.76.55c.57,0,1.11-.11,1.6-.32.5-.21.94-.51,1.32-.89v-7.63h2.37v10.42h-2.18l-.11-1.08c-1.1.86-2.39,1.3-3.87,1.3-1.25,0-2.2-.35-2.87-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M110.97,35.89h2.2l.13,1.21c.5-.32,1.09-.62,1.78-.88.69-.26,1.37-.45,2.04-.55v1.82c-.63.12-1.31.3-2.04.54-.73.24-1.3.49-1.71.76v7.52h-2.4v-10.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M128.55,44.64c-1.22-1.25-1.82-2.99-1.82-5.2,0-2.39.59-4.24,1.76-5.55s2.94-1.97,5.3-1.97c1.48,0,2.86.23,4.15.68v2.09c-1.25-.48-2.57-.73-3.98-.73-1.71,0-2.94.45-3.69,1.36-.75.91-1.12,2.28-1.12,4.11,0,1.67.4,2.93,1.2,3.78.8.85,2.02,1.27,3.66,1.27,1.45,0,2.77-.23,3.96-.68v2.11c-1.26.4-2.65.59-4.15.59-2.29,0-4.04-.63-5.25-1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M140.92,45.89c-.43-.42-.64-1.11-.64-2.07v-12.33h2.4v12.11c0,.4.07.67.21.82.14.15.36.23.67.23.35,0,.69-.04,1.01-.13v1.74c-.48.18-1.05.26-1.69.26-.88,0-1.53-.21-1.96-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M146.78,45.48c-.67-.7-1-1.7-1-3.02v-6.57h2.4v6.57c0,.78.19,1.35.57,1.71s.97.55,1.76.55c.57,0,1.11-.11,1.6-.32.5-.21.94-.51,1.32-.89v-7.63h2.37v10.42h-2.18l-.11-1.08c-1.1.86-2.39,1.3-3.87,1.3-1.25,0-2.2-.35-2.87-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M162.35,46.23c-.56-.2-1.08-.52-1.56-.96l-.13,1.03h-2.07v-14.81h2.4v5.08c.89-.6,1.99-.9,3.27-.9,1.54,0,2.72.44,3.55,1.31.83.87,1.24,2.22,1.24,4.03s-.41,3.23-1.24,4.14c-.83.92-2,1.37-3.51,1.37-.75,0-1.4-.1-1.96-.3ZM165.95,43.82c.46-.6.69-1.54.69-2.81s-.24-2.18-.71-2.71c-.48-.53-1.24-.8-2.3-.8s-1.96.3-2.64.9v5.23c.69.73,1.58,1.1,2.68,1.1s1.81-.3,2.27-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M179.52,32.15h9.63v1.87h-7.23v4.29h6.42v1.85h-6.42v6.15h-2.4v-14.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M191.21,44.64c-1.22-1.25-1.82-2.99-1.82-5.2,0-2.39.59-4.24,1.76-5.55s2.94-1.97,5.3-1.97c1.48,0,2.86.23,4.15.68v2.09c-1.25-.48-2.57-.73-3.98-.73-1.71,0-2.94.45-3.69,1.36-.75.91-1.12,2.28-1.12,4.11,0,1.67.4,2.93,1.2,3.78.8.85,2.02,1.27,3.66,1.27,1.45,0,2.77-.23,3.96-.68v2.11c-1.26.4-2.65.59-4.15.59-2.29,0-4.04-.63-5.25-1.88Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootballClubDesktop);
export default __webpack_public_path__ + "static/media/football-club-desktop.a4541f30ebc3f9c76be8a223c88be08f.svg";
export { ForwardRef as ReactComponent };